var _path, _path2, _path3, _path4, _g, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonitoring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Floor_2_",
    style: {
      fill: "#FAFAFA"
    },
    cx: 250,
    cy: 350.787,
    rx: 242.025,
    ry: 139.731
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadows"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow_37_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M128.073,414.332l119.76,69.178c2.767,1.598,7.254,1.598,10.022,0l182.979-105.643 c2.767-1.598,2.767-4.188,0-5.786l-119.759-69.178c-2.767-1.598-7.254-1.598-10.022,0l-182.98,105.643 C125.305,410.143,125.305,412.734,128.073,414.332z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow_18_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M156.561,348.565l-61.169,35.293c-1.467,0.847-3.845,0.847-5.312,0l-61.09-35.293 c-1.467-0.847-1.467-2.22,0-3.067l61.169-35.293c1.467-0.847,3.845-0.847,5.312,0l61.091,35.292 C158.028,346.345,158.028,347.718,156.561,348.565z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow_24_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M259.512,289.175l-61.959,35.749c-1.486,0.858-3.895,0.858-5.38,0l-61.879-35.748 c-1.486-0.858-1.486-2.249,0-3.107l61.958-35.748c1.486-0.858,3.895-0.858,5.38,0l61.88,35.748 C260.997,286.926,260.997,288.317,259.512,289.175z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plants_4_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4039_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4044_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4045_",
    style: {
      fill: "#5f95fa"
    },
    d: "M328.698,313.006l-6.424-3.712c0,0-3.823-15.886-2.3-30.18 c2.142-20.097,15.371-27.659,20.401-25.926c5.03,1.733,6.487,7.581-1.836,19.551 C333.629,279.801,327.596,294.51,328.698,313.006z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4042_",
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4043_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M328.698,313.006l-6.424-3.712c0,0-3.823-15.886-2.3-30.18 c2.142-20.097,15.371-27.659,20.401-25.926c5.03,1.733,6.487,7.581-1.836,19.551 C333.629,279.801,327.596,294.51,328.698,313.006z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4040_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4041_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M326.036,305.201c0.021-0.001,0.041-0.004,0.062-0.008 c0.242-0.046,0.401-0.279,0.354-0.521c-3.521-18.536,2.954-39.366,10.973-48.033c0.167-0.18,0.156-0.463-0.025-0.629 c-0.181-0.165-0.463-0.156-0.629,0.025c-8.165,8.825-14.767,29.995-11.194,48.804 C325.619,305.06,325.818,305.212,326.036,305.201z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1411_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4037_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4038_",
    style: {
      fill: "#5f95fa"
    },
    d: "M345.815,323.087c0.959,0.488,3.512-1.696,4.223-2.227 c1.218-0.909,2.179-2.158,2.789-3.547c0.71-1.616,0.824-3.315,0.489-5.047c-0.174-0.898-0.471-1.766-0.768-2.632 c-0.291-0.849-0.582-1.699-0.874-2.548c-0.287-0.838-0.578-1.705-0.511-2.589c0.137-1.78,1.644-3.098,3.017-4.238 c1.518-1.261,3.083-2.904,2.966-5.032c-0.09-1.642-1.017-3.125-2.1-4.363c-1.083-1.238-2.348-2.316-3.337-3.63 c-0.712-0.946-1.286-2.071-1.238-3.254c0.03-0.735,0.299-1.44,0.616-2.103c0.682-1.424,1.609-2.744,2.053-4.259 c0.443-1.515,0.276-3.364-0.94-4.37c-0.998-0.827-2.422-0.877-3.709-0.727c-1.191,0.139-2.33,0.737-3.346,1.371 c-3.285,2.05-5.012,6.15-8.525,7.777c-1.355,0.628-2.865,0.826-4.287,1.28c-1.423,0.454-2.856,1.264-3.456,2.632 c-1.184,2.696,1.423,5.813,0.638,8.651c-0.694,2.511-3.047,3.578-4.282,5.872c-0.54,1.004-0.62,2.136-0.467,3.265 c0.258,1.912,0.61,3.307,1.639,5.395c0.85,1.726,3.245,4.989,3.245,4.989S345.668,323.012,345.815,323.087z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4035_",
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4036_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M345.815,323.087c0.959,0.488,3.512-1.696,4.223-2.227 c1.218-0.909,2.179-2.158,2.789-3.547c0.71-1.616,0.824-3.315,0.489-5.047c-0.174-0.898-0.471-1.766-0.768-2.632 c-0.291-0.849-0.582-1.699-0.874-2.548c-0.287-0.838-0.578-1.705-0.511-2.589c0.137-1.78,1.644-3.098,3.017-4.238 c1.518-1.261,3.083-2.904,2.966-5.032c-0.09-1.642-1.017-3.125-2.1-4.363c-1.083-1.238-2.348-2.316-3.337-3.63 c-0.712-0.946-1.286-2.071-1.238-3.254c0.03-0.735,0.299-1.44,0.616-2.103c0.682-1.424,1.609-2.744,2.053-4.259 c0.443-1.515,0.276-3.364-0.94-4.37c-0.998-0.827-2.422-0.877-3.709-0.727c-1.191,0.139-2.33,0.737-3.346,1.371 c-3.285,2.05-5.012,6.15-8.525,7.777c-1.355,0.628-2.865,0.826-4.287,1.28c-1.423,0.454-2.856,1.264-3.456,2.632 c-1.184,2.696,1.423,5.813,0.638,8.651c-0.694,2.511-3.047,3.578-4.282,5.872c-0.54,1.004-0.62,2.136-0.467,3.265 c0.258,1.912,0.61,3.307,1.639,5.395c0.85,1.726,3.245,4.989,3.245,4.989S345.668,323.012,345.815,323.087z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4022_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4023_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M336.517,318.241c0.006,0,0.012,0,0.012,0c0.238-0.022,0.408-0.228,0.387-0.459 c-1.538-16.673,5.404-35.514,10.858-41.162c0.161-0.167,0.157-0.434-0.01-0.596c-0.168-0.161-0.434-0.156-0.596,0.01 c-5.564,5.761-12.651,24.918-11.092,41.825C336.097,318.085,336.292,318.252,336.517,318.241z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4020_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4021_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M338.173,297.684c0.041-0.002,0.083-0.01,0.123-0.025 c5.284-1.93,11.96-2.56,12.026-2.566c0.232-0.022,0.402-0.227,0.381-0.458c-0.022-0.231-0.207-0.406-0.458-0.381 c-0.068,0.007-6.849,0.646-12.238,2.615c-0.218,0.079-0.331,0.322-0.251,0.54C337.821,297.585,337.993,297.693,338.173,297.684z "
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Server_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Server_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8066_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M200.632,101.675l49.771,28.735c0.919,0.531,1.665,1.822,1.665,2.884v151.163 c0,1.062-0.745,2.353-1.665,2.884l-53.835,31.082c-0.919,0.531-2.41,0.531-3.33,0l-49.77-28.735 c-0.919-0.531-1.665-1.822-1.665-2.884V135.641c0-1.062,0.745-2.353,1.665-2.884l53.833-31.081 C198.222,101.144,199.712,101.144,200.632,101.675z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8063_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M141.805,135.637v151.165c0,1.061,0.746,2.353,1.661,2.884l49.775,28.736 c0.453,0.269,1.061,0.4,1.661,0.4V163.812c-0.6,0-1.199-0.138-1.661-0.4l-49.775-28.736l-0.454-0.377l-0.592-0.492 C142.044,134.376,141.805,135.038,141.805,135.637z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M143.469,132.757l53.834-31.081c0.919-0.531,2.41-0.531,3.329,0l49.771,28.735 c0.919,0.531,0.919,1.392,0,1.922l-53.835,31.082c-0.919,0.531-2.41,0.531-3.33,0l-49.77-28.735 C142.549,134.149,142.549,133.288,143.469,132.757z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M198.967,101.277c0.603,0,1.205,0.133,1.665,0.398l49.771,28.735 c0.92,0.531,0.92,1.392,0,1.922l-53.835,31.082c-0.46,0.265-1.062,0.398-1.665,0.398c-0.602,0-1.205-0.133-1.665-0.398 l-49.77-28.735c-0.919-0.531-0.919-1.392,0-1.922l53.834-31.081C197.762,101.41,198.365,101.277,198.967,101.277  M198.967,100.346c-0.79,0-1.546,0.186-2.13,0.523l-53.834,31.081c-0.734,0.424-1.155,1.068-1.155,1.768 c0,0.699,0.421,1.344,1.155,1.767l49.77,28.735c0.584,0.337,1.34,0.523,2.13,0.523c0.79,0,1.546-0.186,2.13-0.523 l53.835-31.082c0.734-0.424,1.155-1.068,1.155-1.767c0-0.699-0.421-1.344-1.155-1.768l-49.771-28.735 C200.514,100.532,199.757,100.346,198.967,100.346L198.967,100.346z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8029_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8057_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M187.095,166.437c-1.725-1-3.124-0.089-3.124,2.034l0,76.328 c0,2.123,1.399,4.656,3.124,5.656c1.725,1,3.124,0.089,3.124-2.034l0.001-76.328C190.219,169.969,188.82,167.437,187.095,166.437 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8056_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M187.095,248.629c-0.862-0.498-1.562-1.762-1.562-2.824l0.001-76.559 c0-1.062,0.699-1.519,1.562-1.021c0.863,0.498,1.562,1.762,1.562,2.824l-0.001,76.559 C188.657,248.67,187.957,249.127,187.095,248.629z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3598_",
    style: {
      opacity: 0.15
    },
    d: "M187.095,248.629c-0.862-0.498-1.562-1.762-1.562-2.824l0.001-76.559 c0-1.062,0.699-1.519,1.562-1.021c0.863,0.498,1.562,1.762,1.562,2.824l-0.001,76.559 C188.657,248.67,187.957,249.127,187.095,248.629z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8055_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M187.095,248.629c-0.862-0.498-1.562-1.762-1.562-2.824l0.001-37.406 l3.124,1.803l-0.001,37.406C188.657,248.67,187.957,249.127,187.095,248.629z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8052_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M177.724,161.027c-1.725-1-3.124-0.089-3.124,2.034l0,76.328 c0,2.123,1.398,4.656,3.124,5.656c1.725,1,3.123,0.089,3.124-2.034l0-76.328C180.848,164.559,179.45,162.027,177.724,161.027z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8051_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M177.724,243.219c-0.863-0.498-1.562-1.762-1.562-2.824l0-76.559 c0-1.062,0.699-1.519,1.562-1.021c0.863,0.498,1.562,1.762,1.562,2.824l-0.001,76.559 C179.286,243.26,178.587,243.717,177.724,243.219z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8045_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M168.354,155.617c-1.725-1-3.124-0.089-3.124,2.034l0,76.328 c0,2.124,1.398,4.656,3.124,5.656c1.725,1,3.124,0.09,3.124-2.034l0-76.328C171.477,159.149,170.079,156.617,168.354,155.617z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8044_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M168.353,237.809c-0.862-0.498-1.562-1.762-1.562-2.824l0.001-76.559 c0-1.062,0.699-1.519,1.562-1.021c0.863,0.498,1.562,1.762,1.562,2.824l-0.001,76.559 C169.915,237.85,169.216,238.307,168.353,237.809z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3604_",
    style: {
      opacity: 0.15
    },
    d: "M168.353,237.809c-0.862-0.498-1.562-1.762-1.562-2.824l0.001-76.559 c0-1.062,0.699-1.519,1.562-1.021c0.863,0.498,1.562,1.762,1.562,2.824l-0.001,76.559 C169.915,237.85,169.216,238.307,168.353,237.809z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8043_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M168.353,237.809c-0.862-0.498-1.562-1.762-1.562-2.824l0.001-55.59l3.124,1.803 l-0.001,55.59C169.915,237.85,169.216,238.307,168.353,237.809z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8040_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M158.983,150.207c-1.725-1-3.124-0.089-3.124,2.034l0,76.328 c0,2.124,1.398,4.656,3.124,5.656c1.725,1,3.124,0.089,3.124-2.034l0.001-76.328 C162.107,153.739,160.708,151.207,158.983,150.207z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8039_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M158.982,232.399c-0.863-0.498-1.562-1.762-1.562-2.824l0.001-76.559 c0-1.062,0.699-1.519,1.562-1.021c0.863,0.498,1.562,1.762,1.562,2.824l-0.001,76.559 C160.544,232.44,159.845,232.897,158.982,232.399z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3605_",
    style: {
      opacity: 0.15
    },
    d: "M158.982,232.399c-0.863-0.498-1.562-1.762-1.562-2.824l0.001-76.559 c0-1.062,0.699-1.519,1.562-1.021c0.863,0.498,1.562,1.762,1.562,2.824l-0.001,76.559 C160.544,232.44,159.845,232.897,158.982,232.399z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8037_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M158.982,232.399c-0.863-0.498-1.562-1.762-1.562-2.824l0-13.961l3.124,1.803 l-0.001,13.961C160.544,232.44,159.845,232.897,158.982,232.399z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8034_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M149.612,144.797c-1.725-1-3.124-0.089-3.124,2.034l0,76.328 c0,2.123,1.398,4.656,3.123,5.656c1.725,1,3.124,0.089,3.124-2.034l0-76.328C152.736,148.329,151.337,145.797,149.612,144.797z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8033_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M149.611,226.989c-0.863-0.498-1.562-1.762-1.562-2.824l0.001-76.559 c0-1.062,0.699-1.519,1.562-1.021c0.863,0.498,1.562,1.762,1.562,2.824l-0.001,76.559 C151.173,227.03,150.474,227.487,149.611,226.989z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3640_",
    style: {
      opacity: 0.15
    },
    d: "M149.611,226.989c-0.863-0.498-1.562-1.762-1.562-2.824l0.001-76.559 c0-1.062,0.699-1.519,1.562-1.021c0.863,0.498,1.562,1.762,1.562,2.824l-0.001,76.559 C151.173,227.03,150.474,227.487,149.611,226.989z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8032_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M149.611,226.989c-0.863-0.498-1.562-1.762-1.562-2.824l0.001-41.014 l3.124,1.803l-0.001,41.014C151.173,227.03,150.474,227.487,149.611,226.989z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Server_4_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8028_",
    d: "M153.353,289.857c0.407,0.235,0.737,0.806,0.737,1.276c0,0.47-0.33,0.66-0.737,0.425 c-0.407-0.235-0.737-0.806-0.737-1.276S152.946,289.622,153.353,289.857z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.492,293.408c0.405,0.234,0.734,0.804,0.734,1.272c0,0.468-0.329,0.658-0.734,0.424 c-0.406-0.234-0.734-0.803-0.734-1.272C158.758,293.364,159.086,293.174,159.492,293.408z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.527,296.891c0.404,0.233,0.731,0.801,0.731,1.267c0,0.466-0.327,0.656-0.731,0.422 c-0.404-0.233-0.732-0.801-0.732-1.267C164.796,296.847,165.123,296.658,165.527,296.891z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8027_",
    d: "M171.614,300.408c0.403,0.232,0.729,0.798,0.729,1.263c0,0.465-0.326,0.653-0.729,0.421 c-0.403-0.232-0.729-0.798-0.729-1.263S171.211,300.176,171.614,300.408z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7982_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8010_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M214.366,191.954c-0.272,0-0.526-0.066-0.756-0.199c-0.529-0.305-0.82-0.906-0.82-1.692v-3.93 c0-1.42,0.964-3.088,2.194-3.799l28.909-16.691c0.68-0.394,1.346-0.443,1.876-0.137c0.529,0.306,0.82,0.907,0.82,1.693 l0.001,3.93c0,1.42-0.964,3.089-2.194,3.799l-28.909,16.691C215.101,191.841,214.72,191.954,214.366,191.954z  M244.395,166.513l-28.909,16.691c-0.917,0.529-1.691,1.87-1.691,2.928v3.93c0,0.405,0.116,0.705,0.318,0.822 c0.201,0.114,0.519,0.066,0.871-0.136l28.909-16.691c0.917-0.53,1.691-1.87,1.691-2.928l-0.001-3.93 c0-0.405-0.116-0.705-0.318-0.822C245.066,166.259,244.748,166.31,244.395,166.513L244.395,166.513z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7983_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7998_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M244.037,169.405v1.906c0,0.248-0.174,0.549-0.389,0.673l-0.437,0.252 c-0.214,0.124-0.389,0.023-0.389-0.224v-1.906c0-0.248,0.174-0.549,0.389-0.673l0.437-0.252 C243.863,169.057,244.037,169.158,244.037,169.405z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7997_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M242.074,170.537v1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.214,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.389-0.673l0.437-0.252 C241.9,170.189,242.074,170.289,242.074,170.537z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7996_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M240.111,171.669v1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.215,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C239.937,171.32,240.111,171.421,240.111,171.669z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7995_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M238.148,172.8v1.906c0,0.247-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.214,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C237.974,172.452,238.148,172.553,238.148,172.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7994_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M236.185,173.932l0,1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.215,0.124-0.389,0.023-0.389-0.224v-1.906c0-0.248,0.174-0.549,0.389-0.673l0.437-0.252 C236.011,173.584,236.185,173.684,236.185,173.932z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7993_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M234.222,175.064l0,1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.214,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C234.048,174.715,234.222,174.816,234.222,175.064z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7992_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M232.259,176.195v1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.215,0.124-0.388,0.024-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C232.085,175.847,232.259,175.947,232.259,176.195z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7991_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M230.296,177.327l0,1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.215,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C230.122,176.979,230.296,177.079,230.296,177.327z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7990_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M228.333,178.458v1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.214,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C228.159,178.11,228.333,178.211,228.333,178.458z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7989_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M226.37,179.59v1.906c0,0.248-0.174,0.549-0.389,0.673l-0.437,0.252 c-0.214,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C226.196,179.242,226.37,179.342,226.37,179.59z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7988_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M224.407,180.722l0,1.906c0,0.248-0.174,0.549-0.389,0.673l-0.437,0.252 c-0.215,0.124-0.389,0.023-0.389-0.224v-1.906c0-0.248,0.174-0.549,0.389-0.673l0.437-0.252 C224.233,180.374,224.407,180.474,224.407,180.722z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7987_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M222.444,181.853v1.906c0,0.248-0.174,0.549-0.389,0.673l-0.437,0.252 c-0.214,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C222.27,181.505,222.444,181.605,222.444,181.853z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7986_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M220.481,182.985v1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.215,0.124-0.389,0.023-0.389-0.224v-1.906c0-0.248,0.174-0.549,0.389-0.673l0.437-0.252 C220.307,182.637,220.481,182.737,220.481,182.985z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7985_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M218.518,184.116v1.906c0,0.248-0.174,0.549-0.389,0.673l-0.437,0.252 c-0.215,0.124-0.389,0.023-0.389-0.224v-1.906c0-0.248,0.174-0.549,0.389-0.673l0.437-0.252 C218.344,183.768,218.518,183.869,218.518,184.116z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7984_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M216.555,185.248v1.906c0,0.248-0.174,0.549-0.389,0.673l-0.437,0.252 c-0.214,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C216.381,184.9,216.555,185,216.555,185.248z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6212_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7981_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M210.372,189.068l-0.811-0.468l-0.001-0.001l-0.006-0.003l-0.001,0.001 c-0.278-0.157-0.659-0.133-1.081,0.11c-0.849,0.49-1.538,1.683-1.538,2.663c0,0.49,0.172,0.833,0.449,0.994v0l0.001,0.001l0,0 l0.755,0.432l0.136-0.228c0.14-0.032,0.286-0.082,0.441-0.171c0.849-0.49,1.538-1.683,1.538-2.663 c0-0.145-0.02-0.274-0.048-0.393L210.372,189.068z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7980_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M209.253,189.155c-0.849,0.49-1.538,1.683-1.538,2.663 s0.688,1.378,1.537,0.888c0.849-0.49,1.538-1.682,1.538-2.663S210.102,188.665,209.253,189.155z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6215_",
    style: {
      opacity: 0.8,
      fill: "#FAFAFA"
    },
    d: "M209.253,189.155c-0.849,0.49-1.538,1.683-1.538,2.663 s0.688,1.378,1.537,0.888c0.849-0.49,1.538-1.682,1.538-2.663S210.102,188.665,209.253,189.155z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5650_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5670_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M203.697,192.92l-0.811-0.468l-0.001,0l-0.006-0.003l0,0.001 c-0.278-0.157-0.659-0.133-1.081,0.11c-0.849,0.49-1.537,1.683-1.537,2.663c0,0.489,0.172,0.833,0.449,0.994v0l0.001,0.001 l0,0l0.755,0.432l0.136-0.227c0.14-0.032,0.287-0.082,0.441-0.172c0.849-0.49,1.538-1.682,1.538-2.663 c0-0.146-0.02-0.274-0.048-0.393L203.697,192.92z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5669_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M202.578,193.007c-0.849,0.49-1.538,1.682-1.538,2.663 s0.688,1.378,1.537,0.888c0.849-0.49,1.538-1.683,1.538-2.663C204.116,192.914,203.427,192.517,202.578,193.007z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5658_",
    style: {
      opacity: 0.8,
      fill: "#FAFAFA"
    },
    d: "M202.578,193.007c-0.849,0.49-1.538,1.682-1.538,2.663 s0.688,1.378,1.537,0.888c0.849-0.49,1.538-1.683,1.538-2.663C204.116,192.914,203.427,192.517,202.578,193.007z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5645_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5649_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M202.335,222.485c-0.244,0-0.473-0.058-0.675-0.174c-0.466-0.27-0.734-0.817-0.734-1.503 l-0.001-14.19c0-1.237,0.84-2.689,1.911-3.308l41.34-23.868c0.596-0.342,1.204-0.385,1.669-0.117 c0.465,0.27,0.733,0.817,0.733,1.503l-0.001,14.189c0,1.236-0.839,2.689-1.91,3.309l-41.341,23.867 C202.99,222.386,202.65,222.485,202.335,222.485z M244.666,180.29l-41.341,23.868c-0.769,0.444-1.418,1.57-1.418,2.458 l0.001,14.19c0,0.321,0.09,0.566,0.242,0.653c0.153,0.091,0.404,0.046,0.687-0.117l41.34-23.867 c0.769-0.445,1.419-1.572,1.419-2.459l0.001-14.189c0-0.326-0.088-0.564-0.242-0.654 C245.197,180.086,244.948,180.128,244.666,180.29L244.666,180.29z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5648_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M242.962,186.118c0,0.996-0.745,2.234-1.665,2.764l-35.093,20.261 c-0.92,0.531-1.665,0.154-1.665-0.842c0-0.996,0.746-2.234,1.665-2.765l35.093-20.261 C242.217,184.745,242.962,185.122,242.962,186.118z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5647_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M242.962,193.332c0,0.996-0.745,2.234-1.665,2.765l-35.093,20.261 c-0.92,0.531-1.665,0.154-1.665-0.842c0-0.996,0.746-2.234,1.665-2.764l35.093-20.261 C242.217,191.959,242.962,192.336,242.962,193.332z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5646_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M241.298,192.49l-14.893,8.598l0,3.606l14.893-8.598 c0.92-0.531,1.665-1.769,1.665-2.765C242.962,192.336,242.217,191.959,241.298,192.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5589_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5644_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M214.366,228.433c-0.272,0-0.527-0.066-0.756-0.198c-0.529-0.306-0.82-0.907-0.82-1.693v-3.929 c0-1.42,0.964-3.089,2.194-3.8l28.909-16.691c0.683-0.394,1.348-0.441,1.876-0.136c0.529,0.306,0.82,0.907,0.82,1.693 l0.001,3.929c0,1.421-0.964,3.089-2.194,3.8l-28.909,16.69C215.101,228.321,214.72,228.433,214.366,228.433z M244.395,202.992 l-28.909,16.691c-0.917,0.529-1.691,1.871-1.691,2.929v3.929c0,0.405,0.116,0.705,0.318,0.822 c0.2,0.117,0.517,0.066,0.871-0.136l28.909-16.69c0.917-0.53,1.691-1.871,1.691-2.929l-0.001-3.929 c0-0.406-0.116-0.705-0.318-0.822C245.064,202.741,244.747,202.789,244.395,202.992L244.395,202.992z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5590_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5605_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M244.037,205.886v1.906c0,0.248-0.174,0.549-0.389,0.673l-0.437,0.252 c-0.214,0.124-0.389,0.023-0.389-0.224v-1.906c0-0.248,0.174-0.549,0.389-0.673l0.437-0.252 C243.863,205.538,244.037,205.638,244.037,205.886z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5604_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M242.074,207.017v1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.214,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.389-0.673l0.437-0.252 C241.9,206.669,242.074,206.77,242.074,207.017z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5603_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M240.111,208.149v1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.215,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C239.937,207.801,240.111,207.901,240.111,208.149z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5602_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M238.148,209.281v1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.214,0.124-0.388,0.024-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C237.974,208.932,238.148,209.033,238.148,209.281z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5601_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M236.185,210.412l0,1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.215,0.124-0.389,0.023-0.389-0.224v-1.906c0-0.248,0.174-0.549,0.389-0.673l0.437-0.252 C236.011,210.064,236.185,210.164,236.185,210.412z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5600_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M234.222,211.544l0,1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.214,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C234.048,211.196,234.222,211.296,234.222,211.544z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5599_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M232.259,212.675v1.907c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.215,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C232.085,212.327,232.259,212.428,232.259,212.675z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5598_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M230.296,213.807l0,1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.215,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C230.122,213.459,230.296,213.559,230.296,213.807z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5597_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M228.333,214.939v1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.214,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C228.159,214.59,228.333,214.691,228.333,214.939z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5596_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M226.37,216.07v1.906c0,0.248-0.174,0.549-0.389,0.673l-0.437,0.252 c-0.214,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C226.196,215.722,226.37,215.823,226.37,216.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5595_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M224.407,217.202l0,1.906c0,0.248-0.174,0.549-0.389,0.673l-0.437,0.252 c-0.215,0.124-0.389,0.023-0.389-0.224v-1.906c0-0.248,0.174-0.549,0.389-0.673l0.437-0.252 C224.233,216.854,224.407,216.954,224.407,217.202z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5594_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M222.444,218.333v1.906c0,0.248-0.174,0.549-0.389,0.673l-0.437,0.252 c-0.214,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C222.27,217.985,222.444,218.086,222.444,218.333z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5593_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M220.481,219.465v1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.215,0.124-0.389,0.023-0.389-0.224v-1.906c0-0.248,0.174-0.549,0.389-0.673l0.437-0.252 C220.307,219.117,220.481,219.217,220.481,219.465z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5592_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M218.518,220.597v1.906c0,0.248-0.174,0.549-0.389,0.673l-0.437,0.252 c-0.215,0.124-0.389,0.023-0.389-0.224v-1.906c0-0.248,0.174-0.549,0.389-0.673l0.437-0.252 C218.344,220.249,218.518,220.349,218.518,220.597z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5591_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M216.555,221.728v1.906c0,0.248-0.174,0.549-0.389,0.673l-0.437,0.252 c-0.214,0.124-0.388,0.024-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C216.381,221.38,216.555,221.481,216.555,221.728z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5585_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5588_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M210.372,225.548l-0.811-0.468l-0.001,0l-0.006-0.003l-0.001,0.001 c-0.278-0.157-0.659-0.133-1.081,0.11c-0.849,0.49-1.538,1.683-1.538,2.663c0,0.49,0.172,0.833,0.449,0.994v0l0.001,0.001l0,0 l0.755,0.432l0.136-0.227c0.14-0.033,0.286-0.083,0.441-0.172c0.849-0.49,1.538-1.683,1.538-2.663 c0-0.146-0.02-0.274-0.048-0.393L210.372,225.548z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5587_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M209.253,225.636c-0.849,0.49-1.538,1.683-1.538,2.663 c0,0.981,0.688,1.378,1.537,0.888c0.849-0.49,1.538-1.683,1.538-2.663S210.102,225.145,209.253,225.636z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5586_",
    style: {
      opacity: 0.8,
      fill: "#FAFAFA"
    },
    d: "M209.253,225.636c-0.849,0.49-1.538,1.683-1.538,2.663 c0,0.981,0.688,1.378,1.537,0.888c0.849-0.49,1.538-1.683,1.538-2.663S210.102,225.145,209.253,225.636z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5581_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5584_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M203.697,229.4l-0.811-0.468l-0.001,0l-0.006-0.003l0,0.001 c-0.278-0.157-0.659-0.133-1.081,0.11c-0.849,0.49-1.537,1.682-1.537,2.663c0,0.489,0.172,0.833,0.449,0.994v0l0.001,0.001 l0,0l0.755,0.432l0.136-0.228c0.14-0.032,0.287-0.082,0.441-0.171c0.849-0.49,1.538-1.683,1.538-2.663 c0-0.146-0.02-0.274-0.048-0.393L203.697,229.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5583_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M202.578,229.488c-0.849,0.49-1.538,1.682-1.538,2.663 s0.688,1.378,1.537,0.888c0.849-0.49,1.538-1.683,1.538-2.663C204.116,229.395,203.427,228.997,202.578,229.488z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5582_",
    style: {
      opacity: 0.8,
      fill: "#FAFAFA"
    },
    d: "M202.578,229.488c-0.849,0.49-1.538,1.682-1.538,2.663 s0.688,1.378,1.537,0.888c0.849-0.49,1.538-1.683,1.538-2.663C204.116,229.395,203.427,228.997,202.578,229.488z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5576_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5580_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M202.335,258.965c-0.244,0-0.473-0.059-0.676-0.176c-0.465-0.268-0.733-0.816-0.733-1.503 l-0.001-14.189c0-1.236,0.839-2.689,1.91-3.309l41.342-23.867c0.596-0.343,1.204-0.384,1.669-0.117 c0.465,0.27,0.733,0.816,0.733,1.502l-0.001,14.19c0,1.237-0.84,2.689-1.911,3.308l-41.34,23.868 C202.99,258.867,202.65,258.965,202.335,258.965z M244.666,216.771l-41.341,23.867c-0.769,0.445-1.418,1.572-1.418,2.459 l0.001,14.189c0,0.322,0.09,0.566,0.242,0.654c0.153,0.088,0.404,0.046,0.687-0.117l41.34-23.868 c0.769-0.444,1.419-1.57,1.419-2.458l0.001-14.19c0-0.325-0.088-0.564-0.242-0.652 C245.2,216.567,244.948,216.608,244.666,216.771L244.666,216.771z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5579_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M242.962,222.599c0,0.996-0.745,2.234-1.665,2.765l-35.093,20.261 c-0.92,0.531-1.665,0.154-1.665-0.842c0-0.996,0.746-2.234,1.665-2.765l35.093-20.261 C242.217,221.226,242.962,221.603,242.962,222.599z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5578_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M242.962,229.812c0,0.996-0.745,2.234-1.665,2.765l-35.093,20.261 c-0.92,0.531-1.665,0.154-1.665-0.842c0-0.996,0.746-2.234,1.665-2.765l35.093-20.261 C242.217,228.439,242.962,228.816,242.962,229.812z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5577_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M241.298,228.97l-14.893,8.599l0,3.606l14.893-8.598 c0.92-0.531,1.665-1.769,1.665-2.765C242.962,228.816,242.217,228.439,241.298,228.97z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3923_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5575_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M214.366,264.914c-0.272,0-0.527-0.066-0.756-0.198c-0.529-0.306-0.82-0.907-0.82-1.694v-3.93 c0-1.42,0.964-3.088,2.194-3.799l28.909-16.691c0.68-0.395,1.346-0.443,1.876-0.137c0.529,0.306,0.82,0.907,0.82,1.693 l0.001,3.93c0,1.422-0.964,3.091-2.194,3.799l-28.909,16.691C215.101,264.802,214.72,264.914,214.366,264.914z  M244.395,239.473l-28.909,16.691c-0.917,0.529-1.691,1.87-1.691,2.928v3.93c0,0.406,0.116,0.705,0.318,0.822 c0.2,0.117,0.517,0.066,0.871-0.136l28.909-16.691c0.917-0.529,1.691-1.869,1.691-2.928l-0.001-3.93 c0-0.406-0.116-0.705-0.318-0.822C245.066,239.22,244.748,239.269,244.395,239.473L244.395,239.473z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3927_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5574_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M244.037,242.366v1.906c0,0.248-0.174,0.549-0.389,0.673l-0.437,0.252 c-0.214,0.124-0.389,0.023-0.389-0.224v-1.906c0-0.248,0.174-0.549,0.389-0.673l0.437-0.252 C243.863,242.018,244.037,242.118,244.037,242.366z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5573_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M242.074,243.498v1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.214,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.389-0.673l0.437-0.252 C241.9,243.15,242.074,243.25,242.074,243.498z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5572_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M240.111,244.629v1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.215,0.124-0.388,0.024-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C239.937,244.281,240.111,244.382,240.111,244.629z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5571_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M238.148,245.761v1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.214,0.124-0.388,0.024-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C237.974,245.413,238.148,245.513,238.148,245.761z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5570_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M236.185,246.893l0,1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.215,0.124-0.389,0.023-0.389-0.224v-1.906c0-0.248,0.174-0.549,0.389-0.673l0.437-0.252 C236.011,246.544,236.185,246.645,236.185,246.893z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5569_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M234.222,248.024l0,1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.214,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C234.048,247.676,234.222,247.777,234.222,248.024z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5568_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M232.259,249.156v1.906c0,0.247-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.215,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C232.085,248.808,232.259,248.908,232.259,249.156z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5567_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M230.296,250.287l0,1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.215,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C230.122,249.939,230.296,250.04,230.296,250.287z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5566_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M228.333,251.419v1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.214,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C228.159,251.071,228.333,251.171,228.333,251.419z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5565_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M226.37,252.551v1.906c0,0.248-0.174,0.549-0.389,0.673l-0.437,0.252 c-0.214,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C226.196,252.202,226.37,252.303,226.37,252.551z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5564_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M224.407,253.682l0,1.906c0,0.248-0.174,0.549-0.389,0.673l-0.437,0.252 c-0.215,0.124-0.389,0.023-0.389-0.224v-1.906c0-0.248,0.174-0.549,0.389-0.673l0.437-0.252 C224.233,253.334,224.407,253.435,224.407,253.682z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5563_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M222.444,254.814v1.906c0,0.248-0.174,0.549-0.389,0.673l-0.437,0.252 c-0.214,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C222.27,254.466,222.444,254.566,222.444,254.814z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5562_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M220.481,255.945v1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.215,0.124-0.389,0.023-0.389-0.224v-1.906c0-0.248,0.174-0.549,0.389-0.673l0.437-0.252 C220.307,255.597,220.481,255.698,220.481,255.945z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3929_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M218.518,257.077v1.906c0,0.248-0.174,0.549-0.389,0.673l-0.437,0.252 c-0.215,0.124-0.389,0.023-0.389-0.224v-1.906c0-0.248,0.174-0.549,0.389-0.673l0.437-0.252 C218.344,256.729,218.518,256.829,218.518,257.077z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3928_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M216.555,258.209v1.906c0,0.248-0.174,0.549-0.389,0.673l-0.437,0.252 c-0.214,0.124-0.388,0.024-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C216.381,257.861,216.555,257.961,216.555,258.209z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3916_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3922_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M210.372,262.028l-0.811-0.468l-0.001,0l-0.006-0.003l-0.001,0.001 c-0.278-0.157-0.659-0.133-1.081,0.11c-0.849,0.49-1.538,1.683-1.538,2.663c0,0.489,0.172,0.833,0.449,0.994v0l0.001,0.001 l0,0l0.755,0.432l0.136-0.228c0.14-0.032,0.286-0.083,0.441-0.172c0.849-0.49,1.538-1.683,1.538-2.663 c0-0.146-0.02-0.274-0.048-0.393L210.372,262.028z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3918_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M209.253,262.116c-0.849,0.49-1.538,1.682-1.538,2.663 s0.688,1.378,1.537,0.888c0.849-0.49,1.538-1.683,1.538-2.663C210.79,262.023,210.102,261.626,209.253,262.116z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3917_",
    style: {
      opacity: 0.8,
      fill: "#FAFAFA"
    },
    d: "M209.253,262.116c-0.849,0.49-1.538,1.682-1.538,2.663 s0.688,1.378,1.537,0.888c0.849-0.49,1.538-1.683,1.538-2.663C210.79,262.023,210.102,261.626,209.253,262.116z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3912_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3915_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M203.697,265.88l-0.811-0.468l-0.001,0l-0.006-0.003l0,0.001 c-0.278-0.157-0.659-0.133-1.081,0.11c-0.849,0.49-1.537,1.682-1.537,2.663c0,0.49,0.172,0.833,0.449,0.994v0l0.001,0l0,0 l0.755,0.432l0.136-0.227c0.14-0.032,0.287-0.082,0.441-0.172c0.849-0.49,1.538-1.682,1.538-2.663 c0-0.146-0.02-0.274-0.048-0.393L203.697,265.88z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3914_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M202.578,265.968c-0.849,0.49-1.538,1.682-1.538,2.663 s0.688,1.378,1.537,0.888c0.849-0.49,1.538-1.683,1.538-2.663C204.116,265.875,203.427,265.478,202.578,265.968z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3913_",
    style: {
      opacity: 0.8,
      fill: "#FAFAFA"
    },
    d: "M202.578,265.968c-0.849,0.49-1.538,1.682-1.538,2.663 s0.688,1.378,1.537,0.888c0.849-0.49,1.538-1.683,1.538-2.663C204.116,265.875,203.427,265.478,202.578,265.968z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3907_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3911_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M202.335,295.445c-0.244,0-0.473-0.058-0.675-0.174c-0.466-0.27-0.734-0.817-0.734-1.503 l-0.001-14.189c0-1.237,0.84-2.69,1.911-3.309l41.34-23.868c0.596-0.343,1.204-0.384,1.669-0.117 c0.465,0.27,0.733,0.817,0.733,1.503l-0.001,14.189c0,1.236-0.839,2.689-1.91,3.309l-41.341,23.867 C202.99,295.346,202.65,295.445,202.335,295.445z M244.666,253.251l-41.341,23.868c-0.769,0.444-1.418,1.57-1.418,2.459 l0.001,14.189c0,0.321,0.09,0.566,0.242,0.652c0.153,0.09,0.404,0.046,0.687-0.117l41.34-23.867 c0.769-0.445,1.419-1.572,1.419-2.459l0.001-14.189c0-0.326-0.088-0.564-0.242-0.654 C245.197,253.045,244.948,253.088,244.666,253.251L244.666,253.251z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3910_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M242.962,259.079c0,0.996-0.745,2.234-1.665,2.764l-35.093,20.261 c-0.92,0.531-1.665,0.154-1.665-0.842c0-0.996,0.746-2.234,1.665-2.765l35.093-20.261 C242.217,257.706,242.962,258.083,242.962,259.079z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3909_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M242.962,266.293c0,0.996-0.745,2.234-1.665,2.764l-35.093,20.261 c-0.92,0.531-1.665,0.154-1.665-0.842c0-0.996,0.746-2.234,1.665-2.765l35.093-20.261 C242.217,264.92,242.962,265.297,242.962,266.293z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3908_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M241.298,265.45l-14.893,8.598l0,3.607l14.893-8.598 c0.92-0.531,1.665-1.769,1.665-2.764C242.962,265.297,242.217,264.92,241.298,265.45z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3874_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3905_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M214.366,301.394c-0.272,0-0.527-0.065-0.757-0.198c-0.528-0.306-0.819-0.907-0.819-1.693 v-3.929c0-1.421,0.964-3.09,2.194-3.8l28.909-16.69c0.68-0.394,1.346-0.443,1.876-0.137c0.529,0.306,0.82,0.907,0.82,1.693 l0.001,3.929c0,1.421-0.964,3.089-2.194,3.8l-28.909,16.691C215.101,301.283,214.72,301.394,214.366,301.394z  M244.395,275.954l-28.909,16.69c-0.917,0.53-1.691,1.871-1.691,2.929v3.929c0,0.405,0.116,0.705,0.318,0.822 c0.201,0.118,0.519,0.069,0.871-0.135l28.909-16.691c0.917-0.529,1.691-1.871,1.691-2.929l-0.001-3.929 c0-0.405-0.116-0.705-0.318-0.822C245.066,275.7,244.748,275.751,244.395,275.954L244.395,275.954z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3875_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3904_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M244.037,278.846v1.906c0,0.248-0.174,0.549-0.389,0.673l-0.437,0.252 c-0.214,0.124-0.389,0.023-0.389-0.224v-1.906c0-0.248,0.174-0.549,0.389-0.673l0.437-0.252 C243.863,278.498,244.037,278.599,244.037,278.846z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3903_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M242.074,279.978v1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.214,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.389-0.673l0.437-0.252 C241.9,279.63,242.074,279.73,242.074,279.978z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3902_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M240.111,281.11v1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.215,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C239.937,280.761,240.111,280.862,240.111,281.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3901_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M238.148,282.241v1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.214,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C237.974,281.893,238.148,281.993,238.148,282.241z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3900_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M236.185,283.373l0,1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.215,0.124-0.389,0.023-0.389-0.224v-1.906c0-0.248,0.174-0.549,0.389-0.673l0.437-0.252 C236.011,283.025,236.185,283.125,236.185,283.373z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3899_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M234.222,284.504l0,1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.214,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C234.048,284.156,234.222,284.257,234.222,284.504z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3898_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M232.259,285.636v1.906c0,0.247-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.215,0.124-0.388,0.024-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C232.085,285.288,232.259,285.388,232.259,285.636z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3897_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M230.296,286.768l0,1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.215,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C230.122,286.419,230.296,286.52,230.296,286.768z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3896_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M228.333,287.899v1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.214,0.124-0.388,0.023-0.388-0.224V288.6c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C228.159,287.551,228.333,287.652,228.333,287.899z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3893_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M226.37,289.031v1.906c0,0.248-0.174,0.549-0.389,0.673l-0.437,0.252 c-0.214,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C226.196,288.683,226.37,288.783,226.37,289.031z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3891_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M224.407,290.163l0,1.906c0,0.248-0.174,0.549-0.389,0.673l-0.437,0.252 c-0.215,0.124-0.389,0.023-0.389-0.224v-1.906c0-0.248,0.174-0.549,0.389-0.673l0.437-0.252 C224.233,289.814,224.407,289.915,224.407,290.163z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3885_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M222.444,291.294v1.906c0,0.248-0.174,0.549-0.389,0.673l-0.437,0.252 c-0.214,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C222.27,290.946,222.444,291.046,222.444,291.294z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3880_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M220.481,292.426v1.906c0,0.248-0.174,0.549-0.388,0.673l-0.437,0.252 c-0.215,0.124-0.389,0.023-0.389-0.224v-1.906c0-0.248,0.174-0.549,0.389-0.673l0.437-0.252 C220.307,292.078,220.481,292.178,220.481,292.426z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3877_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M218.518,293.557v1.906c0,0.248-0.174,0.549-0.389,0.673l-0.437,0.252 c-0.215,0.124-0.389,0.023-0.389-0.224v-1.906c0-0.248,0.174-0.549,0.389-0.673l0.437-0.252 C218.344,293.209,218.518,293.31,218.518,293.557z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3876_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M216.555,294.689v1.906c0,0.248-0.174,0.549-0.389,0.673l-0.437,0.252 c-0.214,0.124-0.388,0.023-0.388-0.224v-1.906c0-0.248,0.174-0.549,0.388-0.673l0.437-0.252 C216.381,294.341,216.555,294.441,216.555,294.689z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3870_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3873_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M210.372,298.509l-0.811-0.468l-0.001,0l-0.006-0.003l-0.001,0.001 c-0.278-0.157-0.659-0.133-1.081,0.11c-0.849,0.49-1.538,1.682-1.538,2.663c0,0.489,0.172,0.833,0.449,0.994v0l0.001,0.001 l0,0l0.755,0.432l0.136-0.228c0.14-0.032,0.286-0.082,0.441-0.172c0.849-0.49,1.538-1.683,1.538-2.663 c0-0.146-0.02-0.274-0.048-0.393L210.372,298.509z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3872_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M209.253,298.596c-0.849,0.49-1.538,1.682-1.538,2.663 s0.688,1.378,1.537,0.888c0.849-0.49,1.538-1.683,1.538-2.663C210.79,298.503,210.102,298.106,209.253,298.596z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3871_",
    style: {
      opacity: 0.8,
      fill: "#FAFAFA"
    },
    d: "M209.253,298.596c-0.849,0.49-1.538,1.682-1.538,2.663 s0.688,1.378,1.537,0.888c0.849-0.49,1.538-1.683,1.538-2.663C210.79,298.503,210.102,298.106,209.253,298.596z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3866_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3869_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M203.697,302.361l-0.811-0.468l-0.001,0l-0.006-0.003l0,0.001 c-0.278-0.157-0.659-0.133-1.081,0.11c-0.849,0.49-1.537,1.683-1.537,2.663c0,0.49,0.172,0.833,0.449,0.994v0l0.001,0.001l0,0 l0.755,0.432l0.136-0.227c0.14-0.032,0.287-0.082,0.441-0.172c0.849-0.49,1.538-1.682,1.538-2.663 c0-0.146-0.02-0.274-0.048-0.393L203.697,302.361z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3868_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M202.578,302.448c-0.849,0.49-1.538,1.683-1.538,2.663 c0,0.98,0.688,1.378,1.537,0.888c0.849-0.49,1.538-1.683,1.538-2.663C204.116,302.355,203.427,301.958,202.578,302.448z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3867_",
    style: {
      opacity: 0.8,
      fill: "#FAFAFA"
    },
    d: "M202.578,302.448c-0.849,0.49-1.538,1.683-1.538,2.663 c0,0.98,0.688,1.378,1.537,0.888c0.849-0.49,1.538-1.683,1.538-2.663C204.116,302.355,203.427,301.958,202.578,302.448z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3799_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3814_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M202.335,186.005c-0.244,0-0.473-0.059-0.676-0.176c-0.465-0.268-0.733-0.816-0.733-1.503 l-0.001-14.189c0-1.236,0.839-2.689,1.91-3.309l41.342-23.867c0.593-0.342,1.2-0.387,1.668-0.118 c0.466,0.27,0.734,0.817,0.734,1.503l-0.001,14.189c0,1.237-0.84,2.691-1.911,3.309l-41.34,23.868 C202.99,185.906,202.65,186.005,202.335,186.005z M245.163,143.648c-0.139,0-0.311,0.056-0.498,0.163l-41.341,23.867 c-0.769,0.445-1.418,1.572-1.418,2.459l0.001,14.189c0,0.322,0.09,0.566,0.242,0.654c0.153,0.088,0.404,0.046,0.687-0.117 l41.34-23.868c0.769-0.444,1.419-1.57,1.419-2.459l0.001-14.189c0-0.326-0.088-0.564-0.242-0.653 C245.3,143.663,245.236,143.648,245.163,143.648z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3813_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M242.962,149.638c0,0.996-0.745,2.234-1.665,2.765l-35.093,20.261 c-0.92,0.531-1.665,0.154-1.665-0.842c0-0.996,0.746-2.234,1.665-2.765l35.093-20.261 C242.217,148.265,242.962,148.642,242.962,149.638z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3804_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M242.962,156.852c0,0.996-0.745,2.234-1.665,2.764l-35.093,20.261 c-0.92,0.531-1.665,0.154-1.665-0.842c0-0.996,0.746-2.234,1.665-2.765l35.093-20.261 C242.217,155.479,242.962,155.856,242.962,156.852z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3803_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M241.298,156.01l-14.893,8.598l0,3.606l14.893-8.598 c0.92-0.531,1.665-1.769,1.665-2.764C242.962,155.856,242.217,155.479,241.298,156.01z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3761_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3762_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3763_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3781_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M147.872,275.129l0.811-0.468l0.001,0l0.006-0.003l0.001,0.001 c0.278-0.157,0.659-0.133,1.081,0.11c0.849,0.49,1.537,1.683,1.537,2.663c0,0.489-0.172,0.833-0.449,0.994v0l-0.001,0.001l0,0 l-0.755,0.432l-0.136-0.227c-0.14-0.032-0.287-0.082-0.441-0.171c-0.849-0.49-1.538-1.683-1.538-2.663 c0-0.146,0.02-0.274,0.048-0.393L147.872,275.129z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3764_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M148.991,275.217c0.849,0.49,1.538,1.682,1.538,2.663 s-0.688,1.378-1.538,0.888c-0.849-0.49-1.538-1.682-1.538-2.663C147.453,275.124,148.142,274.726,148.991,275.217z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3786_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3798_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M146.19,271.093l6.239,3.585c0.977,0.564,1.769,1.936,1.769,3.064v3.579 c0,1.128-0.792,1.585-1.769,1.021l-6.239-3.585c-0.977-0.564-1.769-1.936-1.769-3.064v-3.579 C144.421,270.986,145.213,270.529,146.19,271.093z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3597_",
    style: {
      opacity: 0.1
    },
    d: "M146.19,271.093l6.239,3.585c0.977,0.564,1.769,1.936,1.769,3.064v3.579 c0,1.128-0.792,1.585-1.769,1.021l-6.239-3.585c-0.977-0.564-1.769-1.936-1.769-3.064v-3.579 C144.421,270.986,145.213,270.529,146.19,271.093z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3787_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3788_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3794_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M147.872,275.129l0.811-0.468l0.001,0l0.006-0.003l0.001,0.001 c0.278-0.157,0.659-0.133,1.081,0.11c0.849,0.49,1.537,1.683,1.537,2.663c0,0.489-0.172,0.833-0.449,0.994v0l-0.001,0.001l0,0 l-0.755,0.432l-0.136-0.227c-0.14-0.032-0.287-0.082-0.441-0.171c-0.849-0.49-1.538-1.683-1.538-2.663 c0-0.146,0.02-0.274,0.048-0.393L147.872,275.129z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3789_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M148.991,275.217c0.849,0.49,1.538,1.682,1.538,2.663 s-0.688,1.378-1.538,0.888c-0.849-0.49-1.538-1.682-1.538-2.663C147.453,275.124,148.142,274.726,148.991,275.217z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3756_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3760_",
    style: {
      opacity: 0.15
    },
    d: "M159.211,277.213l30.257,17.454c0.541,0.313,0.98,1.073,0.98,1.698l0,8.355 c0,0.625-0.439,0.879-0.98,0.566l-30.256-17.454c-0.541-0.313-0.98-1.073-0.98-1.698l0-8.355 C158.23,277.154,158.669,276.9,159.211,277.213z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3759_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M160.07,280.895c0,0.586,0.439,1.315,0.98,1.628l26.578,15.33 c0.541,0.313,0.98,0.091,0.98-0.496c0-0.587-0.439-1.315-0.98-1.628l-26.578-15.33 C160.509,280.086,160.07,280.308,160.07,280.895z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3758_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M160.07,285.142c0,0.586,0.439,1.315,0.98,1.628l26.578,15.33 c0.541,0.313,0.98,0.09,0.98-0.496c0-0.586-0.439-1.315-0.98-1.628l-26.578-15.33 C160.509,284.334,160.07,284.556,160.07,285.142z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3757_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M161.05,284.646l14.683,8.462l0,2.124l-14.683-8.462 c-0.541-0.313-0.98-1.041-0.98-1.628C160.07,284.556,160.509,284.334,161.05,284.646z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8020_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8026_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M146.19,253.759l6.239,3.585c0.977,0.564,1.769,1.936,1.769,3.064v3.579 c0,1.128-0.792,1.585-1.769,1.021l-6.239-3.585c-0.977-0.564-1.769-1.936-1.769-3.064v-3.579 C144.421,253.652,145.213,253.195,146.19,253.759z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3596_",
    style: {
      opacity: 0.1
    },
    d: "M146.19,253.759l6.239,3.585c0.977,0.564,1.769,1.936,1.769,3.064v3.579 c0,1.128-0.792,1.585-1.769,1.021l-6.239-3.585c-0.977-0.564-1.769-1.936-1.769-3.064v-3.579 C144.421,253.652,145.213,253.195,146.19,253.759z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8021_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8022_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8025_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M147.872,257.795l0.811-0.468l0.001,0l0.006-0.003l0.001,0.001 c0.278-0.157,0.659-0.133,1.081,0.11c0.849,0.49,1.537,1.683,1.537,2.663c0,0.49-0.172,0.834-0.449,0.994v0l-0.001,0.001l0,0 l-0.755,0.432l-0.136-0.227c-0.14-0.032-0.287-0.082-0.441-0.172c-0.849-0.49-1.538-1.682-1.538-2.663 c0-0.145,0.02-0.274,0.048-0.393L147.872,257.795z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8023_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M148.991,257.883c0.849,0.49,1.538,1.683,1.538,2.663 c0,0.98-0.688,1.378-1.538,0.888c-0.849-0.49-1.538-1.683-1.538-2.663S148.142,257.393,148.991,257.883z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8011_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8019_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M146.19,236.525l6.239,3.585c0.977,0.564,1.769,1.936,1.769,3.064v3.579 c0,1.128-0.792,1.585-1.769,1.021l-6.239-3.585c-0.977-0.564-1.769-1.936-1.769-3.064v-3.579 C144.421,236.417,145.213,235.96,146.19,236.525z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1406_",
    style: {
      opacity: 0.1
    },
    d: "M146.19,236.525l6.239,3.585c0.977,0.564,1.769,1.936,1.769,3.064v3.579 c0,1.128-0.792,1.585-1.769,1.021l-6.239-3.585c-0.977-0.564-1.769-1.936-1.769-3.064v-3.579 C144.421,236.417,145.213,235.96,146.19,236.525z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8014_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8015_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8018_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M147.872,240.561l0.811-0.468l0.001-0.001l0.006-0.003l0.001,0.001 c0.278-0.157,0.659-0.133,1.081,0.11c0.849,0.49,1.537,1.683,1.537,2.663c0,0.49-0.172,0.833-0.449,0.995v0l-0.001,0.001l0,0 l-0.755,0.432l-0.136-0.228c-0.14-0.032-0.287-0.082-0.441-0.171c-0.849-0.49-1.538-1.683-1.538-2.663 c0-0.146,0.02-0.274,0.048-0.393L147.872,240.561z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8017_",
    style: {
      opacity: 0.2
    },
    d: "M147.872,240.561l0.811-0.468l0.001-0.001l0.006-0.003l0.001,0.001 c0.278-0.157,0.659-0.133,1.081,0.11c0.849,0.49,1.537,1.683,1.537,2.663c0,0.49-0.172,0.833-0.449,0.995v0l-0.001,0.001l0,0 l-0.755,0.432l-0.136-0.228c-0.14-0.032-0.287-0.082-0.441-0.171c-0.849-0.49-1.538-1.683-1.538-2.663 c0-0.146,0.02-0.274,0.048-0.393L147.872,240.561z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8016_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M148.991,240.648c0.849,0.49,1.538,1.682,1.538,2.663 s-0.688,1.378-1.538,0.888c-0.849-0.49-1.538-1.683-1.538-2.663S148.142,240.158,148.991,240.648z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3862_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3865_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M159.211,242.645l30.257,17.453c0.541,0.313,0.98,1.073,0.98,1.698l0,8.355 c0,0.625-0.439,0.879-0.98,0.566l-30.256-17.454c-0.541-0.313-0.98-1.073-0.98-1.698l0-8.355 C158.23,242.585,158.669,242.332,159.211,242.645z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3864_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M160.07,246.326c0,0.587,0.439,1.315,0.98,1.628l26.578,15.33 c0.541,0.313,0.98,0.091,0.98-0.496c0-0.586-0.439-1.315-0.98-1.628l-26.578-15.33 C160.509,245.518,160.07,245.74,160.07,246.326z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3863_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M161.05,250.078l14.683,8.462l0,2.124l-14.683-8.462 c-0.541-0.313-0.98-1.041-0.98-1.628C160.07,249.987,160.509,249.765,161.05,250.078z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3837_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3845_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3846_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3860_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M147.872,240.561l0.811-0.468l0.001-0.001l0.006-0.003l0.001,0.001 c0.278-0.157,0.659-0.133,1.081,0.11c0.849,0.49,1.537,1.683,1.537,2.663c0,0.49-0.172,0.833-0.449,0.995v0l-0.001,0.001l0,0 l-0.755,0.432l-0.136-0.228c-0.14-0.032-0.287-0.082-0.441-0.171c-0.849-0.49-1.538-1.683-1.538-2.663 c0-0.146,0.02-0.274,0.048-0.393L147.872,240.561z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3850_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M148.991,240.648c0.849,0.49,1.538,1.682,1.538,2.663 s-0.688,1.378-1.538,0.888c-0.849-0.49-1.538-1.683-1.538-2.663S148.142,240.158,148.991,240.648z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3825_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3836_",
    style: {
      opacity: 0.15
    },
    d: "M159.211,242.645l30.257,17.453c0.541,0.313,0.98,1.073,0.98,1.698l0,8.355 c0,0.625-0.439,0.879-0.98,0.566l-30.256-17.454c-0.541-0.313-0.98-1.073-0.98-1.698l0-8.355 C158.23,242.585,158.669,242.332,159.211,242.645z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3833_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M160.07,246.326c0,0.587,0.439,1.315,0.98,1.628l26.578,15.33 c0.541,0.313,0.98,0.091,0.98-0.496c0-0.586-0.439-1.315-0.98-1.628l-26.578-15.33 C160.509,245.518,160.07,245.74,160.07,246.326z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3831_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M160.07,250.574c0,0.587,0.439,1.315,0.98,1.628l26.578,15.33 c0.541,0.313,0.98,0.091,0.98-0.496c0-0.586-0.439-1.315-0.98-1.628l-26.578-15.33 C160.509,249.765,160.07,249.987,160.07,250.574z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3829_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M161.05,250.078l14.683,8.462l0,2.124l-14.683-8.462 c-0.541-0.313-0.98-1.041-0.98-1.628C160.07,249.987,160.509,249.765,161.05,250.078z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3815_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3819_",
    style: {
      opacity: 0.15
    },
    d: "M159.211,259.926l30.257,17.453c0.541,0.313,0.98,1.073,0.98,1.698l0,8.355 c0,0.625-0.439,0.879-0.98,0.566l-30.256-17.454c-0.541-0.313-0.98-1.073-0.98-1.698l0-8.355 C158.23,259.867,158.669,259.613,159.211,259.926z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3818_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M160.07,263.608c0,0.587,0.439,1.315,0.98,1.628l26.578,15.33 c0.541,0.313,0.98,0.091,0.98-0.496c0-0.586-0.439-1.315-0.98-1.628l-26.578-15.33 C160.509,262.799,160.07,263.021,160.07,263.608z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3817_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M160.07,267.855c0,0.587,0.439,1.315,0.98,1.628l26.578,15.33 c0.541,0.313,0.98,0.091,0.98-0.496s-0.439-1.315-0.98-1.628l-26.578-15.33C160.509,267.047,160.07,267.269,160.07,267.855z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3816_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M161.05,267.359l18.362,10.586l0,2.124l-18.362-10.586 c-0.541-0.313-0.98-1.042-0.98-1.628C160.07,267.269,160.509,267.047,161.05,267.359z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_9_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Speech_Bubble_8_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M158.714,110.162c-0.837,0-1.557-0.501-1.85-1.292l-2.202-5.954 l-10.585,6.111c-0.574,0.33-1.158,0.371-1.605,0.113c-0.448-0.259-0.705-0.786-0.705-1.447l0.001-48.676 c0-1.195,0.811-2.599,1.845-3.196l53.498-30.888c0.573-0.331,1.156-0.372,1.606-0.113c0.447,0.259,0.705,0.786,0.705,1.447v48.676 c0,1.195-0.811,2.599-1.846,3.196l-33.765,19.494l-3.191,11.097c-0.24,0.836-0.958,1.398-1.828,1.43 C158.766,110.162,158.74,110.162,158.714,110.162z M155.153,101.558l2.584,6.989c0.195,0.525,0.681,0.697,1.021,0.683 c0.367-0.014,0.814-0.219,0.968-0.757l3.295-11.457l34.09-19.683c0.748-0.431,1.38-1.526,1.38-2.39V26.267 c0-0.319-0.087-0.553-0.239-0.641c-0.154-0.087-0.4-0.046-0.676,0.113l-53.498,30.888c-0.748,0.431-1.38,1.526-1.38,2.39 l-0.001,48.676c0,0.32,0.087,0.553,0.239,0.641c0.151,0.085,0.396,0.047,0.675-0.113L155.153,101.558z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Chart_10_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M169.438,48.556l0.023,18.352l-11.157,17.786c-3.935-5.042-2.785-17.635,3.358-27.595 C164.143,53.087,166.344,50.517,169.438,48.556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M184.583,64.736c-2.208,11.156-9.903,21.516-17.478,23.368c-3.05,0.755-5.52,0.141-7.531-1.846 l11.215-18.149L184.583,64.736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M184.872,62.809l-13.204,3.237l7.411-19.509C183.8,48.314,186.03,54.561,184.872,62.809z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M177.682,46.399l-6.69,17.606V47.624C173.485,46.301,175.551,45.925,177.682,46.399z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Server_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Server"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1914_",
    style: {
      fill: "#5f95fa"
    },
    points: "147.929,324.168 92.805,355.994 37.681,324.168 92.805,292.342  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2779_",
    style: {
      opacity: 0.1
    },
    points: "147.929,324.168 92.805,355.994 37.681,324.168 92.805,292.342  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2775_",
    style: {
      opacity: 0.1
    },
    points: "92.808,355.99 92.805,352.016 41.127,322.179 37.678,324.167  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1907_",
    style: {
      fill: "#5f95fa"
    },
    d: "M92.808,355.99v21.782c1.323,0,2.653-0.289,3.671-0.874l0.001,0.001 l23.884-13.791l25.36-14.648c1.221-0.704,2.205-2.409,2.205-3.817v-20.475L92.808,355.99z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2650_",
    style: {
      opacity: 0.65,
      fill: "#FFFFFF"
    },
    d: "M92.808,355.99v21.782c1.323,0,2.653-0.289,3.671-0.874 l0.001,0.001l23.884-13.791l25.36-14.648c1.221-0.704,2.205-2.409,2.205-3.817v-20.475L92.808,355.99z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1902_",
    style: {
      fill: "#5f95fa"
    },
    d: "M37.678,324.167v20.475c0,1.408,0.992,3.113,2.205,3.817L61.8,361.113 l27.336,15.784c1.018,0.585,2.341,0.874,3.673,0.874V355.99L37.678,324.167z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1877_",
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M37.678,324.167v20.475c0,1.408,0.992,3.113,2.205,3.817 L61.8,361.113l27.336,15.784c1.018,0.585,2.341,0.874,3.673,0.874V355.99L37.678,324.167z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1845_",
    style: {
      fill: "#5f95fa"
    },
    points: "147.929,300.299 92.805,332.125 37.681,300.299 92.805,268.473  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1843_",
    style: {
      opacity: 0.1
    },
    points: "147.929,300.299 92.805,332.125 37.681,300.299 92.805,268.473  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1812_",
    style: {
      opacity: 0.1
    },
    points: "92.805,332.125 92.805,328.146 41.127,298.309 37.681,300.299  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1811_",
    style: {
      fill: "#5f95fa"
    },
    points: "147.928,316.212 92.804,348.038 92.805,332.125 147.929,300.299  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1694_",
    style: {
      opacity: 0.65,
      fill: "#FFFFFF"
    },
    points: "147.928,316.212 92.804,348.038 92.805,332.125  147.929,300.299  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1693_",
    style: {
      fill: "#5f95fa"
    },
    points: "92.804,348.038 37.681,316.212 37.681,300.299 92.805,332.125  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1486_",
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "92.804,348.038 37.681,316.212 37.681,300.299  92.805,332.125  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1483_",
    style: {
      fill: "#455A64"
    },
    points: "141.038,324.168 141.038,320.19 92.804,348.038 92.805,352.016  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1470_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1482_",
    style: {
      fill: "#5f95fa"
    },
    points: "41.125,318.2 41.127,322.179 92.805,352.016 92.804,348.038  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1480_",
    style: {
      fill: "#37474F"
    },
    points: "41.125,318.2 41.127,322.179 92.805,352.016 92.804,348.038  "
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1431_",
    style: {
      fill: "#5f95fa"
    },
    points: "147.929,276.43 92.805,308.255 37.681,276.43 92.805,244.604  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1428_",
    style: {
      opacity: 0.1
    },
    points: "147.929,276.43 92.805,308.255 37.681,276.43 92.805,244.604  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1426_",
    style: {
      opacity: 0.1
    },
    points: "92.805,308.255 92.805,304.277 41.127,274.44 37.681,276.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1425_",
    style: {
      fill: "#5f95fa"
    },
    points: "147.928,292.342 92.804,324.168 92.805,308.255 147.929,276.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1423_",
    style: {
      opacity: 0.65,
      fill: "#FFFFFF"
    },
    points: "147.928,292.342 92.804,324.168 92.805,308.255  147.929,276.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1422_",
    style: {
      fill: "#5f95fa"
    },
    points: "92.804,324.168 37.681,292.342 37.681,276.43 92.805,308.255  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1420_",
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "92.804,324.168 37.681,292.342 37.681,276.43  92.805,308.255  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1419_",
    style: {
      fill: "#455A64"
    },
    points: "141.038,300.299 141.038,296.32 92.804,324.168 92.805,328.146  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1417_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1418_",
    style: {
      fill: "#37474F"
    },
    points: "41.125,294.331 41.127,298.309 92.805,328.146 92.804,324.168  "
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1416_",
    style: {
      fill: "#455A64"
    },
    points: "141.038,276.429 141.038,272.451 92.804,300.299 92.805,304.277  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1414_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1415_",
    style: {
      fill: "#37474F"
    },
    points: "41.125,270.462 41.127,274.44 92.805,304.277 92.804,300.299  "
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1413_",
    style: {
      fill: "#5f95fa"
    },
    points: "147.929,252.56 92.805,284.386 37.681,252.56 92.805,220.734  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1412_",
    style: {
      opacity: 0.15,
      fill: "#FFFFFF"
    },
    points: "147.929,252.56 92.805,284.386 37.681,252.56  92.805,220.734  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1410_",
    style: {
      opacity: 0.1
    },
    points: "147.929,252.56 92.805,284.386 37.681,252.56 92.805,220.734  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1408_",
    style: {
      opacity: 0.1
    },
    points: "92.805,280.414 92.805,284.386 37.681,252.56 41.127,250.577  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1407_",
    style: {
      fill: "#5f95fa"
    },
    points: "147.928,268.473 92.804,300.299 92.805,284.386 147.929,252.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1405_",
    style: {
      opacity: 0.65,
      fill: "#FFFFFF"
    },
    points: "147.928,268.473 92.804,300.299 92.805,284.386  147.929,252.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1404_",
    style: {
      fill: "#5f95fa"
    },
    points: "92.804,300.299 37.681,268.473 37.681,252.56 92.805,284.386  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1401_",
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "92.804,300.299 37.681,268.473 37.681,252.56  92.805,284.386  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1400_",
    style: {
      fill: "#455A64"
    },
    points: "141.038,252.567 141.038,248.588 92.804,276.436 92.805,280.414  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1398_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1399_",
    style: {
      fill: "#37474F"
    },
    points: "41.125,246.599 41.127,250.577 92.805,280.414 92.804,276.436  "
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5222_",
    style: {
      fill: "#5f95fa"
    },
    points: "147.929,228.647 92.805,260.472 37.681,228.647 92.805,196.821  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5220_",
    style: {
      opacity: 0.15,
      fill: "#FFFFFF"
    },
    points: "147.929,228.647 92.805,260.472 37.681,228.647  92.805,196.821  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5218_",
    style: {
      opacity: 0.1
    },
    points: "147.929,228.647 92.805,260.472 37.681,228.647 92.805,196.821  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5216_",
    style: {
      opacity: 0.1
    },
    points: "92.805,256.501 92.805,260.472 37.681,228.647 41.127,226.664  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5215_",
    style: {
      fill: "#5f95fa"
    },
    points: "147.928,244.559 92.804,276.385 92.805,260.472 147.929,228.647  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5213_",
    style: {
      opacity: 0.65,
      fill: "#FFFFFF"
    },
    points: "147.928,244.559 92.804,276.385 92.805,260.472  147.929,228.647  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5212_",
    style: {
      fill: "#5f95fa"
    },
    points: "92.804,276.385 37.681,244.56 37.681,228.647 92.805,260.472  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5210_",
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "92.804,276.385 37.681,244.56 37.681,228.647  92.805,260.472  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5209_",
    style: {
      fill: "#5f95fa"
    },
    d: "M39.882,203.512l50.751-29.282c1.212-0.7,3.195-0.7,4.407,0l50.686,29.282 c1.212,0.7,2.203,2.417,2.203,3.817v13.369l-55.158,31.826l0,0l-55.093-31.826v-13.369 C37.678,205.929,38.67,204.211,39.882,203.512z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5207_",
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M39.882,203.512l50.751-29.282c1.212-0.7,3.195-0.7,4.407,0 l50.686,29.282c1.212,0.7,2.203,2.417,2.203,3.817v13.369l-55.158,31.826l0,0l-55.093-31.826v-13.369 C37.678,205.929,38.67,204.211,39.882,203.512z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5189_",
    style: {
      fill: "#5f95fa"
    },
    d: "M92.775,235.863v16.659l55.153-31.825v-13.368c0-1.238-0.78-2.739-1.806-3.537 c0.806,0.704,0.67,1.645-0.399,2.264l-50.751,29.28C94.37,235.685,93.573,235.863,92.775,235.863z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5187_",
    style: {
      opacity: 0.65,
      fill: "#FFFFFF"
    },
    d: "M92.775,235.863v16.659l55.153-31.825v-13.368 c0-1.238-0.78-2.739-1.806-3.537c0.806,0.704,0.67,1.645-0.399,2.264l-50.751,29.28C94.37,235.685,93.573,235.863,92.775,235.863 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5139_",
    style: {
      fill: "#5f95fa"
    },
    d: "M145.726,206.056l-50.751,29.282c-1.217,0.703-3.19,0.703-4.407,0 l-50.686-29.282c-1.217-0.703-1.217-1.842,0-2.544l50.751-29.282c1.217-0.702,3.19-0.702,4.407,0l50.686,29.282 C146.943,204.214,146.943,205.353,145.726,206.056z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5137_",
    style: {
      opacity: 0.85,
      fill: "#FFFFFF"
    },
    d: "M145.726,206.056l-50.751,29.282c-1.217,0.703-3.19,0.703-4.407,0 l-50.686-29.282c-1.217-0.703-1.217-1.842,0-2.544l50.751-29.282c1.217-0.702,3.19-0.702,4.407,0l50.686,29.282 C146.943,204.214,146.943,205.353,145.726,206.056z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5136_",
    style: {
      fill: "#455A64"
    },
    points: "141.038,228.653 141.038,224.675 92.804,252.523 92.805,256.501  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1397_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5114_",
    style: {
      fill: "#37474F"
    },
    points: "41.125,222.686 41.127,226.664 92.805,256.501 92.804,252.523  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1396_",
    style: {
      fill: "#455A64"
    },
    d: "M49.672,349.537c0.423,0.244,0.765,0.837,0.765,1.325 c0,0.488-0.342,0.686-0.765,0.442c-0.423-0.244-0.765-0.837-0.765-1.325S49.25,349.293,49.672,349.537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M56.044,353.223c0.421,0.243,0.762,0.834,0.762,1.32c0,0.486-0.341,0.683-0.762,0.44 c-0.421-0.243-0.762-0.834-0.762-1.32C55.282,353.177,55.623,352.98,56.044,353.223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M62.31,356.839c0.419,0.242,0.76,0.831,0.76,1.315c0,0.484-0.34,0.681-0.759,0.438 c-0.419-0.242-0.759-0.831-0.759-1.315C61.55,356.793,61.89,356.597,62.31,356.839z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2039_",
    style: {
      fill: "#455A64"
    },
    d: "M68.629,360.49c0.418,0.241,0.757,0.828,0.757,1.311 c0,0.483-0.339,0.678-0.757,0.437c-0.418-0.241-0.757-0.828-0.757-1.311C67.872,360.444,68.21,360.249,68.629,360.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2030_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1395_",
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M42.236,330.751l6.477,3.721c1.014,0.585,1.836,2.009,1.836,3.181v3.716 c0,1.171-0.822,1.646-1.836,1.06l-6.477-3.721c-1.014-0.586-1.836-2.01-1.836-3.181v-3.716 C40.4,330.64,41.222,330.165,42.236,330.751z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2031_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1391_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1394_",
    style: {
      fill: "#5f95fa"
    },
    d: "M43.982,334.941l0.842-0.486l0.001,0l0.006-0.003l0.001,0.001 c0.288-0.163,0.684-0.138,1.122,0.114c0.881,0.509,1.596,1.747,1.596,2.765c0,0.508-0.178,0.865-0.466,1.032v0l-0.001,0.001 l0,0l-0.784,0.449l-0.141-0.236c-0.146-0.034-0.298-0.086-0.458-0.178c-0.881-0.509-1.596-1.747-1.596-2.765 c0-0.151,0.02-0.284,0.05-0.408L43.982,334.941z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1393_",
    style: {
      opacity: 0.2
    },
    d: "M43.982,334.941l0.842-0.486l0.001,0l0.006-0.003l0.001,0.001 c0.288-0.163,0.684-0.138,1.122,0.114c0.881,0.509,1.596,1.747,1.596,2.765c0,0.508-0.178,0.865-0.466,1.032v0l-0.001,0.001 l0,0l-0.784,0.449l-0.141-0.236c-0.146-0.034-0.298-0.086-0.458-0.178c-0.881-0.509-1.596-1.747-1.596-2.765 c0-0.151,0.02-0.284,0.05-0.408L43.982,334.941z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1392_",
    style: {
      fill: "#5f95fa"
    },
    d: "M45.143,335.032c0.882,0.509,1.596,1.747,1.596,2.765 c0,1.018-0.715,1.43-1.596,0.921c-0.882-0.509-1.596-1.747-1.596-2.765C43.547,334.935,44.262,334.523,45.143,335.032z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1384_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1390_",
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M42.236,306.864l6.477,3.721c1.014,0.586,1.836,2.01,1.836,3.181v3.716 c0,1.171-0.822,1.646-1.836,1.06l-6.477-3.721c-1.014-0.586-1.836-2.01-1.836-3.181v-3.716 C40.4,306.753,41.222,306.278,42.236,306.864z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1385_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1386_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1389_",
    style: {
      fill: "#5f95fa"
    },
    d: "M43.982,311.054l0.842-0.486l0.001,0l0.006-0.003l0.001,0.001 c0.288-0.163,0.684-0.138,1.122,0.114c0.881,0.509,1.596,1.747,1.596,2.764c0,0.508-0.178,0.865-0.466,1.032v0l-0.001,0.001 l0,0l-0.784,0.449l-0.141-0.236c-0.146-0.033-0.298-0.086-0.458-0.178c-0.881-0.509-1.596-1.747-1.596-2.764 c0-0.151,0.02-0.284,0.05-0.408L43.982,311.054z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1388_",
    style: {
      opacity: 0.2
    },
    d: "M43.982,311.054l0.842-0.486l0.001,0l0.006-0.003l0.001,0.001 c0.288-0.163,0.684-0.138,1.122,0.114c0.881,0.509,1.596,1.747,1.596,2.764c0,0.508-0.178,0.865-0.466,1.032v0l-0.001,0.001 l0,0l-0.784,0.449l-0.141-0.236c-0.146-0.033-0.298-0.086-0.458-0.178c-0.881-0.509-1.596-1.747-1.596-2.764 c0-0.151,0.02-0.284,0.05-0.408L43.982,311.054z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1387_",
    style: {
      fill: "#5f95fa"
    },
    d: "M45.143,311.145c0.882,0.509,1.596,1.747,1.596,2.764 c0,1.018-0.715,1.43-1.596,0.921c-0.882-0.509-1.596-1.747-1.596-2.765C43.547,311.048,44.262,310.636,45.143,311.145z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1377_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1383_",
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M42.236,282.991l6.477,3.721c1.014,0.586,1.836,2.01,1.836,3.181v3.716 c0,1.171-0.822,1.646-1.836,1.06l-6.477-3.721c-1.014-0.586-1.836-2.009-1.836-3.181v-3.716 C40.4,282.88,41.222,282.405,42.236,282.991z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1378_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1379_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1382_",
    style: {
      fill: "#5f95fa"
    },
    d: "M43.982,287.181l0.842-0.486l0.001,0l0.006-0.003l0.001,0.001 c0.288-0.163,0.684-0.138,1.122,0.115c0.881,0.509,1.596,1.747,1.596,2.764c0,0.508-0.178,0.865-0.466,1.032v0l-0.001,0.001 l0,0l-0.784,0.449l-0.141-0.236c-0.146-0.034-0.298-0.085-0.458-0.178c-0.881-0.509-1.596-1.747-1.596-2.764 c0-0.151,0.02-0.284,0.05-0.408L43.982,287.181z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1381_",
    style: {
      opacity: 0.2
    },
    d: "M43.982,287.181l0.842-0.486l0.001,0l0.006-0.003l0.001,0.001 c0.288-0.163,0.684-0.138,1.122,0.115c0.881,0.509,1.596,1.747,1.596,2.764c0,0.508-0.178,0.865-0.466,1.032v0l-0.001,0.001 l0,0l-0.784,0.449l-0.141-0.236c-0.146-0.034-0.298-0.085-0.458-0.178c-0.881-0.509-1.596-1.747-1.596-2.764 c0-0.151,0.02-0.284,0.05-0.408L43.982,287.181z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1380_",
    style: {
      fill: "#5f95fa"
    },
    d: "M45.143,287.272c0.882,0.509,1.596,1.747,1.596,2.764 c0,1.018-0.715,1.43-1.596,0.921c-0.882-0.509-1.596-1.747-1.596-2.765C43.547,287.175,44.262,286.763,45.143,287.272z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1365_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1376_",
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M42.236,259.148l6.477,3.721c1.014,0.586,1.836,2.01,1.836,3.181v3.716 c0,1.171-0.822,1.646-1.836,1.06l-6.477-3.721c-1.014-0.586-1.836-2.01-1.836-3.181v-3.716 C40.4,259.037,41.222,258.563,42.236,259.148z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1367_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1371_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1375_",
    style: {
      fill: "#5f95fa"
    },
    d: "M43.982,263.339l0.842-0.486l0.001-0.001l0.006-0.003l0.001,0.001 c0.288-0.163,0.684-0.138,1.122,0.114c0.881,0.509,1.596,1.747,1.596,2.765c0,0.508-0.178,0.865-0.466,1.032v0l-0.001,0.001 l0,0l-0.784,0.449l-0.141-0.236c-0.146-0.034-0.298-0.086-0.458-0.178c-0.881-0.509-1.596-1.747-1.596-2.764 c0-0.151,0.02-0.284,0.05-0.408L43.982,263.339z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1374_",
    style: {
      opacity: 0.2
    },
    d: "M43.982,263.339l0.842-0.486l0.001-0.001l0.006-0.003l0.001,0.001 c0.288-0.163,0.684-0.138,1.122,0.114c0.881,0.509,1.596,1.747,1.596,2.765c0,0.508-0.178,0.865-0.466,1.032v0l-0.001,0.001 l0,0l-0.784,0.449l-0.141-0.236c-0.146-0.034-0.298-0.086-0.458-0.178c-0.881-0.509-1.596-1.747-1.596-2.764 c0-0.151,0.02-0.284,0.05-0.408L43.982,263.339z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1373_",
    style: {
      fill: "#5f95fa"
    },
    d: "M45.143,263.429c0.882,0.509,1.596,1.747,1.596,2.764 c0,1.018-0.715,1.431-1.596,0.922c-0.882-0.509-1.596-1.747-1.596-2.764C43.547,263.333,44.262,262.92,45.143,263.429z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5198_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5205_",
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M42.236,235.235l6.477,3.721c1.014,0.586,1.836,2.01,1.836,3.181v3.716 c0,1.171-0.822,1.646-1.836,1.06l-6.477-3.721c-1.014-0.586-1.836-2.009-1.836-3.181v-3.716 C40.4,235.124,41.222,234.649,42.236,235.235z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5199_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5200_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5204_",
    style: {
      fill: "#5f95fa"
    },
    d: "M43.982,239.425l0.842-0.486l0.001-0.001l0.006-0.003l0.001,0.001 c0.288-0.163,0.684-0.138,1.122,0.114c0.881,0.509,1.596,1.747,1.596,2.764c0,0.508-0.178,0.865-0.466,1.032v0l-0.001,0.001 l0,0l-0.784,0.449l-0.141-0.236c-0.146-0.034-0.298-0.086-0.458-0.178c-0.881-0.509-1.596-1.747-1.596-2.765 c0-0.151,0.02-0.284,0.05-0.408L43.982,239.425z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5203_",
    style: {
      opacity: 0.2
    },
    d: "M43.982,239.425l0.842-0.486l0.001-0.001l0.006-0.003l0.001,0.001 c0.288-0.163,0.684-0.138,1.122,0.114c0.881,0.509,1.596,1.747,1.596,2.764c0,0.508-0.178,0.865-0.466,1.032v0l-0.001,0.001 l0,0l-0.784,0.449l-0.141-0.236c-0.146-0.034-0.298-0.086-0.458-0.178c-0.881-0.509-1.596-1.747-1.596-2.765 c0-0.151,0.02-0.284,0.05-0.408L43.982,239.425z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5202_",
    style: {
      fill: "#5f95fa"
    },
    d: "M45.143,239.516c0.882,0.509,1.596,1.747,1.596,2.764 s-0.715,1.43-1.596,0.922c-0.882-0.509-1.596-1.747-1.596-2.765C43.547,239.419,44.262,239.007,45.143,239.516z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5190_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5196_",
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M42.236,211.345l6.477,3.721c1.014,0.586,1.836,2.01,1.836,3.181v3.716 c0,1.171-0.822,1.646-1.836,1.06l-6.477-3.721c-1.014-0.585-1.836-2.01-1.836-3.18v-3.716 C40.4,211.234,41.222,210.759,42.236,211.345z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5191_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5192_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5195_",
    style: {
      fill: "#5f95fa"
    },
    d: "M43.982,215.535l0.842-0.486l0.001-0.001l0.006-0.003l0.001,0.001 c0.288-0.163,0.684-0.138,1.122,0.114c0.881,0.509,1.596,1.747,1.596,2.764c0,0.508-0.178,0.865-0.466,1.032v0l-0.001,0.001 l0,0l-0.784,0.449l-0.141-0.236c-0.146-0.034-0.298-0.086-0.458-0.178c-0.881-0.509-1.596-1.747-1.596-2.764 c0-0.151,0.02-0.284,0.05-0.408L43.982,215.535z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5194_",
    style: {
      opacity: 0.2
    },
    d: "M43.982,215.535l0.842-0.486l0.001-0.001l0.006-0.003l0.001,0.001 c0.288-0.163,0.684-0.138,1.122,0.114c0.881,0.509,1.596,1.747,1.596,2.764c0,0.508-0.178,0.865-0.466,1.032v0l-0.001,0.001 l0,0l-0.784,0.449l-0.141-0.236c-0.146-0.034-0.298-0.086-0.458-0.178c-0.881-0.509-1.596-1.747-1.596-2.764 c0-0.151,0.02-0.284,0.05-0.408L43.982,215.535z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5193_",
    style: {
      fill: "#5f95fa"
    },
    d: "M45.143,215.626c0.882,0.509,1.596,1.747,1.596,2.764 s-0.715,1.431-1.596,0.922c-0.882-0.509-1.596-1.747-1.596-2.765C43.547,215.529,44.262,215.117,45.143,215.626z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1244_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2648_",
    style: {
      fill: "#455A64"
    },
    d: "M142.646,331.202l-27.334,15.782c-1.014,0.586-1.836,2.01-1.836,3.181l0,3.716 c0,1.171,0.822,1.646,1.836,1.06l27.335-15.782c1.014-0.586,1.836-2.01,1.836-3.181v-3.716 C144.483,331.091,143.66,330.616,142.646,331.202z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2145_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2647_",
    style: {
      fill: "#5f95fa"
    },
    d: "M142.546,334.349v1.803c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.238 C142.381,334.02,142.546,334.115,142.546,334.349z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2639_",
    style: {
      fill: "#5f95fa"
    },
    d: "M140.689,335.419v1.802c0,0.234-0.165,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.803c0-0.234,0.165-0.519,0.367-0.636l0.413-0.239 C140.525,335.09,140.689,335.185,140.689,335.419z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2638_",
    style: {
      fill: "#5f95fa"
    },
    d: "M138.833,336.489l0,1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C138.669,336.16,138.833,336.255,138.833,336.489z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2637_",
    style: {
      fill: "#37474F"
    },
    d: "M136.977,337.559v1.802c0,0.234-0.165,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C136.813,337.23,136.977,337.324,136.977,337.559z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2636_",
    style: {
      fill: "#37474F"
    },
    d: "M135.121,338.629l0,1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.165-0.519,0.367-0.636l0.413-0.239 C134.957,338.299,135.121,338.395,135.121,338.629z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1255_",
    style: {
      fill: "#5f95fa"
    },
    d: "M133.265,339.699l0,1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C133.101,339.37,133.265,339.464,133.265,339.699z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1254_",
    style: {
      fill: "#5f95fa"
    },
    d: "M131.409,340.769v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.165-0.519,0.367-0.636l0.413-0.239 C131.245,340.44,131.409,340.534,131.409,340.769z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1253_",
    style: {
      fill: "#5f95fa"
    },
    d: "M129.553,341.839l0,1.803c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C129.389,341.509,129.553,341.604,129.553,341.839z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1252_",
    style: {
      fill: "#5f95fa"
    },
    d: "M127.697,342.909v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.238 C127.533,342.579,127.697,342.674,127.697,342.909z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1251_",
    style: {
      fill: "#5f95fa"
    },
    d: "M125.841,343.979v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C125.676,343.649,125.841,343.744,125.841,343.979z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1250_",
    style: {
      fill: "#5f95fa"
    },
    d: "M123.985,345.048l0,1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C123.821,344.719,123.985,344.814,123.985,345.048z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2401_",
    style: {
      fill: "#5f95fa"
    },
    d: "M122.129,346.118v1.803c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C121.964,345.789,122.129,345.884,122.129,346.118z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1249_",
    style: {
      fill: "#37474F"
    },
    d: "M120.273,347.189v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C120.108,346.859,120.273,346.954,120.273,347.189z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1248_",
    style: {
      fill: "#5f95fa"
    },
    d: "M118.417,348.258v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C118.252,347.929,118.417,348.024,118.417,348.258z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1247_",
    style: {
      fill: "#5f95fa"
    },
    d: "M116.561,349.328v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C116.396,348.999,116.561,349.094,116.561,349.328z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_929_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1240_",
    style: {
      fill: "#455A64"
    },
    d: "M142.646,307.338l-27.334,15.782c-1.014,0.585-1.836,2.009-1.836,3.181l0,3.715 c0,1.171,0.822,1.646,1.836,1.06l27.335-15.782c1.014-0.585,1.836-2.009,1.836-3.18v-3.716 C144.483,307.227,143.66,306.752,142.646,307.338z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_930_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1234_",
    style: {
      fill: "#5f95fa"
    },
    d: "M142.546,310.484v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C142.381,310.155,142.546,310.25,142.546,310.484z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1232_",
    style: {
      fill: "#37474F"
    },
    d: "M140.689,311.554v1.802c0,0.234-0.165,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.803c0-0.234,0.165-0.519,0.367-0.636l0.413-0.238 C140.525,311.225,140.689,311.32,140.689,311.554z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1222_",
    style: {
      fill: "#5f95fa"
    },
    d: "M138.833,312.624l0,1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.238 C138.669,312.295,138.833,312.39,138.833,312.624z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1215_",
    style: {
      fill: "#37474F"
    },
    d: "M136.977,313.694v1.802c0,0.234-0.165,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C136.813,313.365,136.977,313.46,136.977,313.694z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1214_",
    style: {
      fill: "#37474F"
    },
    d: "M135.121,314.764l0,1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.165-0.519,0.367-0.636l0.413-0.239 C134.957,314.435,135.121,314.53,135.121,314.764z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1212_",
    style: {
      fill: "#5f95fa"
    },
    d: "M133.265,315.834l0,1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.238 C133.101,315.505,133.265,315.6,133.265,315.834z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1141_",
    style: {
      fill: "#5f95fa"
    },
    d: "M131.409,316.904v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.165-0.519,0.367-0.636l0.413-0.239 C131.245,316.575,131.409,316.67,131.409,316.904z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1137_",
    style: {
      fill: "#5f95fa"
    },
    d: "M129.553,317.974l0,1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C129.389,317.645,129.553,317.74,129.553,317.974z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1246_",
    style: {
      fill: "#37474F"
    },
    d: "M127.697,319.044v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.238 C127.533,318.715,127.697,318.81,127.697,319.044z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1245_",
    style: {
      fill: "#5f95fa"
    },
    d: "M125.841,320.114v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.238 C125.676,319.785,125.841,319.88,125.841,320.114z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1135_",
    style: {
      fill: "#37474F"
    },
    d: "M123.985,321.184l0,1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C123.821,320.855,123.985,320.95,123.985,321.184z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1134_",
    style: {
      fill: "#5f95fa"
    },
    d: "M122.129,322.254v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C121.964,321.925,122.129,322.02,122.129,322.254z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1133_",
    style: {
      fill: "#37474F"
    },
    d: "M120.273,323.324v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.238 C120.108,322.995,120.273,323.09,120.273,323.324z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1132_",
    style: {
      fill: "#5f95fa"
    },
    d: "M118.417,324.394v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C118.252,324.065,118.417,324.16,118.417,324.394z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1131_",
    style: {
      fill: "#5f95fa"
    },
    d: "M116.561,325.464v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C116.396,325.135,116.561,325.23,116.561,325.464z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_865_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_928_",
    style: {
      fill: "#455A64"
    },
    d: "M142.646,283.446l-27.334,15.782c-1.014,0.586-1.836,2.009-1.836,3.181l0,3.715 c0,1.171,0.822,1.646,1.836,1.06l27.335-15.782c1.014-0.585,1.836-2.009,1.836-3.18v-3.716 C144.483,283.335,143.66,282.86,142.646,283.446z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_866_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_926_",
    style: {
      fill: "#5f95fa"
    },
    d: "M142.546,286.592v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.238 C142.381,286.263,142.546,286.358,142.546,286.592z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_925_",
    style: {
      fill: "#5f95fa"
    },
    d: "M140.689,287.662v1.802c0,0.234-0.165,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.165-0.519,0.367-0.636l0.413-0.238 C140.525,287.333,140.689,287.428,140.689,287.662z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_924_",
    style: {
      fill: "#5f95fa"
    },
    d: "M138.833,288.732l0,1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.238 C138.669,288.403,138.833,288.498,138.833,288.732z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_920_",
    style: {
      fill: "#5f95fa"
    },
    d: "M136.977,289.802v1.802c0,0.234-0.165,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.238 C136.813,289.473,136.977,289.568,136.977,289.802z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_912_",
    style: {
      fill: "#37474F"
    },
    d: "M135.121,290.872l0,1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.165-0.519,0.367-0.636l0.413-0.239 C134.957,290.543,135.121,290.638,135.121,290.872z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_910_",
    style: {
      fill: "#37474F"
    },
    d: "M133.265,291.942l0,1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C133.101,291.613,133.265,291.708,133.265,291.942z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_909_",
    style: {
      fill: "#5f95fa"
    },
    d: "M131.409,293.012v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.165-0.519,0.367-0.636l0.413-0.239 C131.245,292.683,131.409,292.778,131.409,293.012z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_905_",
    style: {
      fill: "#5f95fa"
    },
    d: "M129.553,294.082l0,1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.238 C129.389,293.753,129.553,293.848,129.553,294.082z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_900_",
    style: {
      fill: "#5f95fa"
    },
    d: "M127.697,295.152v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C127.533,294.823,127.697,294.918,127.697,295.152z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_899_",
    style: {
      fill: "#37474F"
    },
    d: "M125.841,296.222v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C125.676,295.893,125.841,295.988,125.841,296.222z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_877_",
    style: {
      fill: "#5f95fa"
    },
    d: "M123.985,297.292l0,1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C123.821,296.963,123.985,297.058,123.985,297.292z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_875_",
    style: {
      fill: "#5f95fa"
    },
    d: "M122.129,298.362v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.803c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C121.964,298.033,122.129,298.128,122.129,298.362z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_872_",
    style: {
      fill: "#37474F"
    },
    d: "M120.273,299.432v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C120.108,299.103,120.273,299.198,120.273,299.432z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_871_",
    style: {
      fill: "#5f95fa"
    },
    d: "M118.417,300.502v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C118.252,300.173,118.417,300.268,118.417,300.502z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_867_",
    style: {
      fill: "#37474F"
    },
    d: "M116.561,301.572v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C116.396,301.243,116.561,301.338,116.561,301.572z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_535_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_864_",
    style: {
      fill: "#455A64"
    },
    d: "M142.646,259.595l-27.334,15.782c-1.014,0.585-1.836,2.009-1.836,3.181l0,3.716 c0,1.171,0.822,1.646,1.836,1.06l27.335-15.782c1.014-0.585,1.836-2.009,1.836-3.18v-3.716 C144.483,259.484,143.66,259.009,142.646,259.595z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_536_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_860_",
    style: {
      fill: "#5f95fa"
    },
    d: "M142.546,262.742v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C142.381,262.413,142.546,262.507,142.546,262.742z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_859_",
    style: {
      fill: "#37474F"
    },
    d: "M140.689,263.812v1.802c0,0.234-0.165,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.165-0.519,0.367-0.636l0.413-0.238 C140.525,263.482,140.689,263.577,140.689,263.812z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_858_",
    style: {
      fill: "#5f95fa"
    },
    d: "M138.833,264.882l0,1.803c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C138.669,264.552,138.833,264.647,138.833,264.882z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_857_",
    style: {
      fill: "#5f95fa"
    },
    d: "M136.977,265.952v1.802c0,0.234-0.165,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.238 C136.813,265.622,136.977,265.717,136.977,265.952z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_854_",
    style: {
      fill: "#5f95fa"
    },
    d: "M135.121,267.022l0,1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.165-0.519,0.367-0.636l0.413-0.238 C134.957,266.692,135.121,266.787,135.121,267.022z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_853_",
    style: {
      fill: "#37474F"
    },
    d: "M133.265,268.091l0,1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C133.101,267.762,133.265,267.857,133.265,268.091z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_852_",
    style: {
      fill: "#37474F"
    },
    d: "M131.409,269.161v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.165-0.519,0.367-0.636l0.413-0.239 C131.245,268.832,131.409,268.927,131.409,269.161z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_851_",
    style: {
      fill: "#5f95fa"
    },
    d: "M129.553,270.231l0,1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.238 C129.389,269.902,129.553,269.997,129.553,270.231z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_744_",
    style: {
      fill: "#37474F"
    },
    d: "M127.697,271.301v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C127.533,270.972,127.697,271.067,127.697,271.301z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_737_",
    style: {
      fill: "#5f95fa"
    },
    d: "M125.841,272.371v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C125.676,272.042,125.841,272.137,125.841,272.371z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_668_",
    style: {
      fill: "#5f95fa"
    },
    d: "M123.985,273.441l0,1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.238 C123.821,273.112,123.985,273.207,123.985,273.441z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_539_",
    style: {
      fill: "#5f95fa"
    },
    d: "M122.129,274.511v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C121.964,274.182,122.129,274.277,122.129,274.511z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_538_",
    style: {
      fill: "#37474F"
    },
    d: "M120.273,275.581v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C120.108,275.252,120.273,275.347,120.273,275.581z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_881_",
    style: {
      fill: "#5f95fa"
    },
    d: "M118.417,276.651v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.238 C118.252,276.322,118.417,276.417,118.417,276.651z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_537_",
    style: {
      fill: "#5f95fa"
    },
    d: "M116.561,277.721v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C116.396,277.392,116.561,277.487,116.561,277.721z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5169_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5186_",
    style: {
      fill: "#455A64"
    },
    d: "M142.646,235.681l-27.334,15.782c-1.014,0.585-1.836,2.009-1.836,3.18l0,3.716 c0,1.171,0.822,1.646,1.836,1.06l27.335-15.782c1.014-0.585,1.836-2.01,1.836-3.181v-3.716 C144.483,235.57,143.66,235.096,142.646,235.681z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5170_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5185_",
    style: {
      fill: "#5f95fa"
    },
    d: "M142.546,238.828v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.803c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C142.381,238.499,142.546,238.594,142.546,238.828z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5184_",
    style: {
      fill: "#37474F"
    },
    d: "M140.689,239.898v1.802c0,0.234-0.165,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.165-0.519,0.367-0.636l0.413-0.239 C140.525,239.569,140.689,239.664,140.689,239.898z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5183_",
    style: {
      fill: "#5f95fa"
    },
    d: "M138.833,240.968l0,1.803c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C138.669,240.639,138.833,240.734,138.833,240.968z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5182_",
    style: {
      fill: "#5f95fa"
    },
    d: "M136.977,242.038v1.802c0,0.234-0.165,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C136.813,241.709,136.977,241.804,136.977,242.038z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5181_",
    style: {
      fill: "#5f95fa"
    },
    d: "M135.121,243.108l0,1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.165-0.519,0.367-0.636l0.413-0.239 C134.957,242.779,135.121,242.874,135.121,243.108z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5180_",
    style: {
      fill: "#37474F"
    },
    d: "M133.265,244.178l0,1.803c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C133.101,243.849,133.265,243.944,133.265,244.178z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5179_",
    style: {
      fill: "#37474F"
    },
    d: "M131.409,245.248v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.165-0.519,0.367-0.636l0.413-0.239 C131.245,244.919,131.409,245.014,131.409,245.248z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5178_",
    style: {
      fill: "#5f95fa"
    },
    d: "M129.553,246.318l0,1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.803c0-0.234,0.164-0.519,0.367-0.636l0.413-0.238 C129.389,245.989,129.553,246.083,129.553,246.318z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5177_",
    style: {
      fill: "#37474F"
    },
    d: "M127.697,247.388v1.803c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C127.533,247.059,127.697,247.154,127.697,247.388z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5176_",
    style: {
      fill: "#5f95fa"
    },
    d: "M125.841,248.458v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.803c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C125.676,248.129,125.841,248.223,125.841,248.458z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5175_",
    style: {
      fill: "#5f95fa"
    },
    d: "M123.985,249.528l0,1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.238 C123.821,249.199,123.985,249.294,123.985,249.528z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5174_",
    style: {
      fill: "#5f95fa"
    },
    d: "M122.129,250.598v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C121.964,250.268,122.129,250.363,122.129,250.598z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5173_",
    style: {
      fill: "#37474F"
    },
    d: "M120.273,251.668v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C120.108,251.339,120.273,251.434,120.273,251.668z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5172_",
    style: {
      fill: "#5f95fa"
    },
    d: "M118.417,252.738v1.803c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212V253.4c0-0.234,0.164-0.519,0.367-0.636l0.413-0.238 C118.252,252.408,118.417,252.503,118.417,252.738z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5171_",
    style: {
      fill: "#5f95fa"
    },
    d: "M116.561,253.808v1.803c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C116.396,253.479,116.561,253.573,116.561,253.808z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_520_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5168_",
    style: {
      fill: "#455A64"
    },
    d: "M142.646,211.81l-27.334,15.782c-1.014,0.586-1.836,2.01-1.836,3.181l0,3.715 c0,1.171,0.822,1.646,1.836,1.06l27.335-15.782c1.014-0.585,1.836-2.01,1.836-3.18v-3.716 C144.483,211.699,143.66,211.225,142.646,211.81z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_522_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5167_",
    style: {
      fill: "#37474F"
    },
    d: "M142.546,214.957v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.803c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C142.381,214.628,142.546,214.723,142.546,214.957z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5166_",
    style: {
      fill: "#5f95fa"
    },
    d: "M140.689,216.027v1.802c0,0.234-0.165,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.165-0.519,0.367-0.636l0.413-0.239 C140.525,215.698,140.689,215.793,140.689,216.027z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5164_",
    style: {
      fill: "#37474F"
    },
    d: "M138.833,217.097l0,1.803c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C138.669,216.768,138.833,216.863,138.833,217.097z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5163_",
    style: {
      fill: "#37474F"
    },
    d: "M136.977,218.167v1.802c0,0.234-0.165,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.803c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C136.813,217.837,136.977,217.932,136.977,218.167z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5161_",
    style: {
      fill: "#37474F"
    },
    d: "M135.121,219.237l0,1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.165-0.519,0.367-0.636l0.413-0.239 C134.957,218.908,135.121,219.003,135.121,219.237z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5160_",
    style: {
      fill: "#5f95fa"
    },
    d: "M133.265,220.307l0,1.803c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C133.101,219.977,133.265,220.072,133.265,220.307z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_534_",
    style: {
      fill: "#5f95fa"
    },
    d: "M131.409,221.377v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.803c0-0.234,0.165-0.519,0.367-0.636l0.413-0.239 C131.245,221.048,131.409,221.142,131.409,221.377z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5157_",
    style: {
      fill: "#37474F"
    },
    d: "M129.553,222.447l0,1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.238 C129.389,222.117,129.553,222.212,129.553,222.447z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5156_",
    style: {
      fill: "#5f95fa"
    },
    d: "M127.697,223.516v1.803c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C127.533,223.188,127.697,223.282,127.697,223.516z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5154_",
    style: {
      fill: "#37474F"
    },
    d: "M125.841,224.587v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.238 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.803c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C125.676,224.257,125.841,224.352,125.841,224.587z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5153_",
    style: {
      fill: "#37474F"
    },
    d: "M123.985,225.656l0,1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.238 C123.821,225.327,123.985,225.422,123.985,225.656z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5151_",
    style: {
      fill: "#37474F"
    },
    d: "M122.129,226.727v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C121.964,226.397,122.129,226.492,122.129,226.727z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5149_",
    style: {
      fill: "#5f95fa"
    },
    d: "M120.273,227.796v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C120.108,227.467,120.273,227.562,120.273,227.796z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_525_",
    style: {
      fill: "#37474F"
    },
    d: "M118.417,228.867v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.238 C118.252,228.537,118.417,228.632,118.417,228.867z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_524_",
    style: {
      fill: "#37474F"
    },
    d: "M116.561,229.936v1.802c0,0.234-0.164,0.519-0.367,0.636l-0.413,0.239 c-0.203,0.117-0.367,0.022-0.367-0.212v-1.802c0-0.234,0.164-0.519,0.367-0.636l0.413-0.239 C116.396,229.607,116.561,229.702,116.561,229.936z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_514_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1990_",
    style: {
      fill: "#5f95fa"
    },
    d: "M108.587,353.783l-0.842-0.486l-0.001,0l-0.006-0.003l-0.001,0.001 c-0.288-0.163-0.684-0.138-1.122,0.114c-0.882,0.509-1.596,1.747-1.596,2.764c0,0.508,0.178,0.865,0.466,1.032v0l0.001,0.001 l0,0l0.784,0.449l0.141-0.236c0.146-0.034,0.298-0.086,0.458-0.178c0.881-0.509,1.596-1.747,1.596-2.764 c0-0.151-0.02-0.284-0.05-0.408L108.587,353.783z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1874_",
    style: {
      opacity: 0.4
    },
    d: "M108.587,353.783l-0.842-0.486l-0.001,0l-0.006-0.003l-0.001,0.001 c-0.288-0.163-0.684-0.138-1.122,0.114c-0.882,0.509-1.596,1.747-1.596,2.764c0,0.508,0.178,0.865,0.466,1.032v0l0.001,0.001 l0,0l0.784,0.449l0.141-0.236c0.146-0.034,0.298-0.086,0.458-0.178c0.881-0.509,1.596-1.747,1.596-2.764 c0-0.151-0.02-0.284-0.05-0.408L108.587,353.783z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1463_",
    style: {
      fill: "#5f95fa"
    },
    d: "M107.426,353.874c-0.882,0.509-1.596,1.747-1.596,2.765 c0,1.018,0.715,1.43,1.596,0.921c0.882-0.509,1.596-1.747,1.596-2.765C109.022,353.777,108.308,353.365,107.426,353.874z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_515_",
    style: {
      opacity: 0.2
    },
    d: "M107.426,353.874c-0.882,0.509-1.596,1.747-1.596,2.765 c0,1.018,0.715,1.43,1.596,0.921c0.882-0.509,1.596-1.747,1.596-2.765C109.022,353.777,108.308,353.365,107.426,353.874z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_495_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_513_",
    style: {
      fill: "#5f95fa"
    },
    d: "M101.659,357.782l-0.842-0.486l-0.001,0l-0.006-0.003l0,0.001 c-0.288-0.163-0.684-0.138-1.122,0.114c-0.881,0.509-1.596,1.747-1.596,2.764c0,0.508,0.178,0.865,0.466,1.032v0l0.001,0.001 l0,0l0.784,0.449l0.141-0.236c0.146-0.034,0.297-0.086,0.458-0.178c0.881-0.509,1.596-1.747,1.596-2.765 c0-0.151-0.02-0.284-0.05-0.408L101.659,357.782z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_511_",
    style: {
      opacity: 0.4
    },
    d: "M101.659,357.782l-0.842-0.486l-0.001,0l-0.006-0.003l0,0.001 c-0.288-0.163-0.684-0.138-1.122,0.114c-0.881,0.509-1.596,1.747-1.596,2.764c0,0.508,0.178,0.865,0.466,1.032v0l0.001,0.001 l0,0l0.784,0.449l0.141-0.236c0.146-0.034,0.297-0.086,0.458-0.178c0.881-0.509,1.596-1.747,1.596-2.765 c0-0.151-0.02-0.284-0.05-0.408L101.659,357.782z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_506_",
    style: {
      fill: "#5f95fa"
    },
    d: "M100.497,357.872c-0.882,0.509-1.596,1.747-1.596,2.765 c0,1.018,0.715,1.43,1.596,0.921c0.882-0.509,1.596-1.747,1.596-2.764C102.093,357.776,101.379,357.364,100.497,357.872z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_503_",
    style: {
      opacity: 0.2
    },
    d: "M100.497,357.872c-0.882,0.509-1.596,1.747-1.596,2.765 c0,1.018,0.715,1.43,1.596,0.921c0.882-0.509,1.596-1.747,1.596-2.764C102.093,357.776,101.379,357.364,100.497,357.872z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_488_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_492_",
    style: {
      fill: "#5f95fa"
    },
    d: "M108.587,329.914l-0.842-0.486l-0.001,0l-0.006-0.004l-0.001,0.001 c-0.288-0.163-0.684-0.138-1.122,0.114c-0.882,0.509-1.596,1.747-1.596,2.765c0,0.508,0.178,0.865,0.466,1.032v0l0.001,0.001 l0,0l0.784,0.449l0.141-0.236c0.146-0.034,0.298-0.086,0.458-0.178c0.881-0.509,1.596-1.747,1.596-2.765 c0-0.151-0.02-0.284-0.05-0.408L108.587,329.914z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_491_",
    style: {
      opacity: 0.4
    },
    d: "M108.587,329.914l-0.842-0.486l-0.001,0l-0.006-0.004l-0.001,0.001 c-0.288-0.163-0.684-0.138-1.122,0.114c-0.882,0.509-1.596,1.747-1.596,2.765c0,0.508,0.178,0.865,0.466,1.032v0l0.001,0.001 l0,0l0.784,0.449l0.141-0.236c0.146-0.034,0.298-0.086,0.458-0.178c0.881-0.509,1.596-1.747,1.596-2.765 c0-0.151-0.02-0.284-0.05-0.408L108.587,329.914z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_490_",
    style: {
      fill: "#5f95fa"
    },
    d: "M107.426,330.005c-0.882,0.509-1.596,1.747-1.596,2.764 c0,1.018,0.715,1.43,1.596,0.922c0.882-0.509,1.596-1.747,1.596-2.764C109.022,329.909,108.308,329.496,107.426,330.005z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_489_",
    style: {
      opacity: 0.2
    },
    d: "M107.426,330.005c-0.882,0.509-1.596,1.747-1.596,2.764 c0,1.018,0.715,1.43,1.596,0.922c0.882-0.509,1.596-1.747,1.596-2.764C109.022,329.909,108.308,329.496,107.426,330.005z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_479_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_483_",
    style: {
      fill: "#5f95fa"
    },
    d: "M101.659,333.913l-0.842-0.486l-0.001,0l-0.006-0.003l0,0.001 c-0.288-0.163-0.684-0.138-1.122,0.114c-0.881,0.509-1.596,1.747-1.596,2.765c0,0.508,0.178,0.865,0.466,1.032v0l0.001,0.001 l0,0l0.784,0.449l0.141-0.236c0.146-0.033,0.297-0.086,0.458-0.178c0.881-0.509,1.596-1.747,1.596-2.764 c0-0.151-0.02-0.284-0.05-0.408L101.659,333.913z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_482_",
    style: {
      opacity: 0.4
    },
    d: "M101.659,333.913l-0.842-0.486l-0.001,0l-0.006-0.003l0,0.001 c-0.288-0.163-0.684-0.138-1.122,0.114c-0.881,0.509-1.596,1.747-1.596,2.765c0,0.508,0.178,0.865,0.466,1.032v0l0.001,0.001 l0,0l0.784,0.449l0.141-0.236c0.146-0.033,0.297-0.086,0.458-0.178c0.881-0.509,1.596-1.747,1.596-2.764 c0-0.151-0.02-0.284-0.05-0.408L101.659,333.913z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_481_",
    style: {
      fill: "#5f95fa"
    },
    d: "M100.497,334.004c-0.882,0.509-1.596,1.747-1.596,2.765 c0,1.018,0.715,1.43,1.596,0.922c0.882-0.509,1.596-1.747,1.596-2.765C102.093,333.908,101.379,333.495,100.497,334.004z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_480_",
    style: {
      opacity: 0.2
    },
    d: "M100.497,334.004c-0.882,0.509-1.596,1.747-1.596,2.765 c0,1.018,0.715,1.43,1.596,0.922c0.882-0.509,1.596-1.747,1.596-2.765C102.093,333.908,101.379,333.495,100.497,334.004z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_470_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_477_",
    style: {
      fill: "#5f95fa"
    },
    d: "M108.587,306.045l-0.842-0.486l-0.001,0l-0.006-0.003l-0.001,0.001 c-0.288-0.163-0.684-0.138-1.122,0.114c-0.882,0.509-1.596,1.747-1.596,2.765c0,0.508,0.178,0.865,0.466,1.032v0l0.001,0.001 l0,0l0.784,0.449l0.141-0.236c0.146-0.034,0.298-0.085,0.458-0.178c0.881-0.509,1.596-1.747,1.596-2.765 c0-0.151-0.02-0.284-0.05-0.408L108.587,306.045z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_473_",
    style: {
      opacity: 0.4
    },
    d: "M108.587,306.045l-0.842-0.486l-0.001,0l-0.006-0.003l-0.001,0.001 c-0.288-0.163-0.684-0.138-1.122,0.114c-0.882,0.509-1.596,1.747-1.596,2.765c0,0.508,0.178,0.865,0.466,1.032v0l0.001,0.001 l0,0l0.784,0.449l0.141-0.236c0.146-0.034,0.298-0.085,0.458-0.178c0.881-0.509,1.596-1.747,1.596-2.765 c0-0.151-0.02-0.284-0.05-0.408L108.587,306.045z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_472_",
    style: {
      fill: "#5f95fa"
    },
    d: "M107.426,306.136c-0.882,0.509-1.596,1.747-1.596,2.764 c0,1.018,0.715,1.43,1.596,0.921c0.882-0.509,1.596-1.747,1.596-2.764C109.022,306.04,108.308,305.627,107.426,306.136z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_471_",
    style: {
      opacity: 0.2
    },
    d: "M107.426,306.136c-0.882,0.509-1.596,1.747-1.596,2.764 c0,1.018,0.715,1.43,1.596,0.921c0.882-0.509,1.596-1.747,1.596-2.764C109.022,306.04,108.308,305.627,107.426,306.136z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_447_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_467_",
    style: {
      fill: "#5f95fa"
    },
    d: "M101.659,310.044l-0.842-0.486l-0.001,0l-0.006-0.003l0,0.001 c-0.288-0.163-0.684-0.138-1.122,0.114c-0.881,0.509-1.596,1.747-1.596,2.764c0,0.508,0.178,0.865,0.466,1.032v0l0.001,0.001 l0,0l0.784,0.449l0.141-0.236c0.146-0.034,0.297-0.086,0.458-0.178c0.881-0.509,1.596-1.747,1.596-2.764 c0-0.151-0.02-0.284-0.05-0.408L101.659,310.044z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_466_",
    style: {
      opacity: 0.4
    },
    d: "M101.659,310.044l-0.842-0.486l-0.001,0l-0.006-0.003l0,0.001 c-0.288-0.163-0.684-0.138-1.122,0.114c-0.881,0.509-1.596,1.747-1.596,2.764c0,0.508,0.178,0.865,0.466,1.032v0l0.001,0.001 l0,0l0.784,0.449l0.141-0.236c0.146-0.034,0.297-0.086,0.458-0.178c0.881-0.509,1.596-1.747,1.596-2.764 c0-0.151-0.02-0.284-0.05-0.408L101.659,310.044z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_465_",
    style: {
      fill: "#5f95fa"
    },
    d: "M100.497,310.135c-0.882,0.509-1.596,1.747-1.596,2.764 c0,1.018,0.715,1.431,1.596,0.922c0.882-0.509,1.596-1.747,1.596-2.765C102.093,310.038,101.379,309.626,100.497,310.135z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_464_",
    style: {
      opacity: 0.2
    },
    d: "M100.497,310.135c-0.882,0.509-1.596,1.747-1.596,2.764 c0,1.018,0.715,1.431,1.596,0.922c0.882-0.509,1.596-1.747,1.596-2.765C102.093,310.038,101.379,309.626,100.497,310.135z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_843_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_442_",
    style: {
      fill: "#5f95fa"
    },
    d: "M108.587,282.176l-0.842-0.486l-0.001,0l-0.006-0.003l-0.001,0.001 c-0.288-0.163-0.684-0.138-1.122,0.114c-0.882,0.509-1.596,1.747-1.596,2.764c0,0.508,0.178,0.865,0.466,1.032v0l0.001,0.001 l0,0l0.784,0.449l0.141-0.236c0.146-0.034,0.298-0.086,0.458-0.178c0.881-0.509,1.596-1.747,1.596-2.765 c0-0.151-0.02-0.284-0.05-0.408L108.587,282.176z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_427_",
    style: {
      opacity: 0.4
    },
    d: "M108.587,282.176l-0.842-0.486l-0.001,0l-0.006-0.003l-0.001,0.001 c-0.288-0.163-0.684-0.138-1.122,0.114c-0.882,0.509-1.596,1.747-1.596,2.764c0,0.508,0.178,0.865,0.466,1.032v0l0.001,0.001 l0,0l0.784,0.449l0.141-0.236c0.146-0.034,0.298-0.086,0.458-0.178c0.881-0.509,1.596-1.747,1.596-2.765 c0-0.151-0.02-0.284-0.05-0.408L108.587,282.176z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_418_",
    style: {
      fill: "#5f95fa"
    },
    d: "M107.426,282.267c-0.882,0.509-1.596,1.747-1.596,2.764 c0,1.018,0.715,1.43,1.596,0.921c0.882-0.509,1.596-1.747,1.596-2.764C109.022,282.17,108.308,281.758,107.426,282.267z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_413_",
    style: {
      opacity: 0.2
    },
    d: "M107.426,282.267c-0.882,0.509-1.596,1.747-1.596,2.764 c0,1.018,0.715,1.43,1.596,0.921c0.882-0.509,1.596-1.747,1.596-2.764C109.022,282.17,108.308,281.758,107.426,282.267z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_400_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_412_",
    style: {
      fill: "#5f95fa"
    },
    d: "M101.659,286.174l-0.842-0.486l-0.001-0.001l-0.006-0.003l0,0.001 c-0.288-0.163-0.684-0.138-1.122,0.114c-0.881,0.509-1.596,1.747-1.596,2.765c0,0.508,0.178,0.865,0.466,1.032v0l0.001,0.001 l0,0l0.784,0.449l0.141-0.236c0.146-0.034,0.297-0.086,0.458-0.178c0.881-0.509,1.596-1.747,1.596-2.765 c0-0.151-0.02-0.284-0.05-0.408L101.659,286.174z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_409_",
    style: {
      opacity: 0.4
    },
    d: "M101.659,286.174l-0.842-0.486l-0.001-0.001l-0.006-0.003l0,0.001 c-0.288-0.163-0.684-0.138-1.122,0.114c-0.881,0.509-1.596,1.747-1.596,2.765c0,0.508,0.178,0.865,0.466,1.032v0l0.001,0.001 l0,0l0.784,0.449l0.141-0.236c0.146-0.034,0.297-0.086,0.458-0.178c0.881-0.509,1.596-1.747,1.596-2.765 c0-0.151-0.02-0.284-0.05-0.408L101.659,286.174z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_407_",
    style: {
      fill: "#5f95fa"
    },
    d: "M100.497,286.265c-0.882,0.509-1.596,1.747-1.596,2.765 c0,1.018,0.715,1.43,1.596,0.921c0.882-0.509,1.596-1.747,1.596-2.764C102.093,286.169,101.379,285.756,100.497,286.265z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_406_",
    style: {
      opacity: 0.2
    },
    d: "M100.497,286.265c-0.882,0.509-1.596,1.747-1.596,2.765 c0,1.018,0.715,1.43,1.596,0.921c0.882-0.509,1.596-1.747,1.596-2.764C102.093,286.169,101.379,285.756,100.497,286.265z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5104_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5111_",
    style: {
      fill: "#5f95fa"
    },
    d: "M108.587,258.262l-0.842-0.486l-0.001,0l-0.006-0.003l-0.001,0.001 c-0.288-0.163-0.684-0.138-1.122,0.114c-0.882,0.509-1.596,1.747-1.596,2.765c0,0.508,0.178,0.865,0.466,1.032v0l0.001,0.001 l0,0l0.784,0.449l0.141-0.236c0.146-0.033,0.298-0.086,0.458-0.178c0.881-0.509,1.596-1.747,1.596-2.764 c0-0.151-0.02-0.284-0.05-0.408L108.587,258.262z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5109_",
    style: {
      opacity: 0.4
    },
    d: "M108.587,258.262l-0.842-0.486l-0.001,0l-0.006-0.003l-0.001,0.001 c-0.288-0.163-0.684-0.138-1.122,0.114c-0.882,0.509-1.596,1.747-1.596,2.765c0,0.508,0.178,0.865,0.466,1.032v0l0.001,0.001 l0,0l0.784,0.449l0.141-0.236c0.146-0.033,0.298-0.086,0.458-0.178c0.881-0.509,1.596-1.747,1.596-2.764 c0-0.151-0.02-0.284-0.05-0.408L108.587,258.262z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5107_",
    style: {
      fill: "#5f95fa"
    },
    d: "M107.426,258.353c-0.882,0.509-1.596,1.747-1.596,2.765 c0,1.018,0.715,1.43,1.596,0.921c0.882-0.509,1.596-1.747,1.596-2.765C109.022,258.257,108.308,257.844,107.426,258.353z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5105_",
    style: {
      opacity: 0.2
    },
    d: "M107.426,258.353c-0.882,0.509-1.596,1.747-1.596,2.765 c0,1.018,0.715,1.43,1.596,0.921c0.882-0.509,1.596-1.747,1.596-2.765C109.022,258.257,108.308,257.844,107.426,258.353z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5092_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5103_",
    style: {
      fill: "#5f95fa"
    },
    d: "M101.659,262.261l-0.842-0.486l-0.001,0l-0.006-0.003l0,0.001 c-0.288-0.163-0.684-0.138-1.122,0.114c-0.881,0.509-1.596,1.747-1.596,2.764c0,0.508,0.178,0.865,0.466,1.032v0l0.001,0.001 l0,0l0.784,0.449l0.141-0.236c0.146-0.033,0.297-0.086,0.458-0.178c0.881-0.509,1.596-1.747,1.596-2.765 c0-0.151-0.02-0.284-0.05-0.408L101.659,262.261z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5100_",
    style: {
      opacity: 0.4
    },
    d: "M101.659,262.261l-0.842-0.486l-0.001,0l-0.006-0.003l0,0.001 c-0.288-0.163-0.684-0.138-1.122,0.114c-0.881,0.509-1.596,1.747-1.596,2.764c0,0.508,0.178,0.865,0.466,1.032v0l0.001,0.001 l0,0l0.784,0.449l0.141-0.236c0.146-0.033,0.297-0.086,0.458-0.178c0.881-0.509,1.596-1.747,1.596-2.765 c0-0.151-0.02-0.284-0.05-0.408L101.659,262.261z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5098_",
    style: {
      fill: "#5f95fa"
    },
    d: "M100.497,262.352c-0.882,0.509-1.596,1.747-1.596,2.764 c0,1.018,0.715,1.43,1.596,0.921c0.882-0.509,1.596-1.747,1.596-2.764C102.093,262.255,101.379,261.843,100.497,262.352z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5093_",
    style: {
      opacity: 0.2
    },
    d: "M100.497,262.352c-0.882,0.509-1.596,1.747-1.596,2.764 c0,1.018,0.715,1.43,1.596,0.921c0.882-0.509,1.596-1.747,1.596-2.764C102.093,262.255,101.379,261.843,100.497,262.352z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5062_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5090_",
    style: {
      fill: "#5f95fa"
    },
    d: "M108.587,234.4l-0.842-0.486l-0.001,0l-0.006-0.003l-0.001,0.001 c-0.288-0.163-0.684-0.138-1.122,0.114c-0.882,0.509-1.596,1.747-1.596,2.764c0,0.508,0.178,0.865,0.466,1.032v0l0.001,0.001 l0,0l0.784,0.449l0.141-0.236c0.146-0.034,0.298-0.086,0.458-0.178c0.881-0.509,1.596-1.747,1.596-2.765 c0-0.151-0.02-0.284-0.05-0.408L108.587,234.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5089_",
    style: {
      opacity: 0.4
    },
    d: "M108.587,234.4l-0.842-0.486l-0.001,0l-0.006-0.003l-0.001,0.001 c-0.288-0.163-0.684-0.138-1.122,0.114c-0.882,0.509-1.596,1.747-1.596,2.764c0,0.508,0.178,0.865,0.466,1.032v0l0.001,0.001 l0,0l0.784,0.449l0.141-0.236c0.146-0.034,0.298-0.086,0.458-0.178c0.881-0.509,1.596-1.747,1.596-2.765 c0-0.151-0.02-0.284-0.05-0.408L108.587,234.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_292_",
    style: {
      fill: "#5f95fa"
    },
    d: "M107.426,234.491c-0.882,0.509-1.596,1.747-1.596,2.764 c0,1.018,0.715,1.431,1.596,0.922c0.882-0.509,1.596-1.747,1.596-2.765S108.308,233.982,107.426,234.491z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5071_",
    style: {
      opacity: 0.2
    },
    d: "M107.426,234.491c-0.882,0.509-1.596,1.747-1.596,2.764 c0,1.018,0.715,1.431,1.596,0.922c0.882-0.509,1.596-1.747,1.596-2.765S108.308,233.982,107.426,234.491z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5042_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5060_",
    style: {
      fill: "#5f95fa"
    },
    d: "M101.659,238.398l-0.842-0.486l-0.001,0l-0.006-0.004l0,0.001 c-0.288-0.163-0.684-0.138-1.122,0.114c-0.881,0.509-1.596,1.747-1.596,2.765c0,0.508,0.178,0.865,0.466,1.032v0l0.001,0.001h0 l0.784,0.449l0.141-0.236c0.146-0.034,0.297-0.085,0.458-0.178c0.881-0.509,1.596-1.747,1.596-2.765 c0-0.151-0.02-0.284-0.05-0.408L101.659,238.398z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5056_",
    style: {
      opacity: 0.4
    },
    d: "M101.659,238.398l-0.842-0.486l-0.001,0l-0.006-0.004l0,0.001 c-0.288-0.163-0.684-0.138-1.122,0.114c-0.881,0.509-1.596,1.747-1.596,2.765c0,0.508,0.178,0.865,0.466,1.032v0l0.001,0.001h0 l0.784,0.449l0.141-0.236c0.146-0.034,0.297-0.085,0.458-0.178c0.881-0.509,1.596-1.747,1.596-2.765 c0-0.151-0.02-0.284-0.05-0.408L101.659,238.398z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5046_",
    style: {
      fill: "#5f95fa"
    },
    d: "M100.497,238.489c-0.882,0.509-1.596,1.747-1.596,2.764 c0,1.018,0.715,1.43,1.596,0.922c0.882-0.509,1.596-1.747,1.596-2.764C102.093,238.393,101.379,237.98,100.497,238.489z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5045_",
    style: {
      opacity: 0.2
    },
    d: "M100.497,238.489c-0.882,0.509-1.596,1.747-1.596,2.764 c0,1.018,0.715,1.43,1.596,0.922c0.882-0.509,1.596-1.747,1.596-2.764C102.093,238.393,101.379,237.98,100.497,238.489z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5121_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5125_",
    style: {
      fill: "#455A64"
    },
    d: "M55.752,289.344l31.41,18.118c0.562,0.324,1.018,1.114,1.018,1.763l0,8.674 c0,0.649-0.456,0.912-1.018,0.588l-31.409-18.119c-0.562-0.324-1.018-1.114-1.018-1.763l0-8.674 C54.735,289.283,55.19,289.02,55.752,289.344z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5124_",
    style: {
      fill: "#5f95fa"
    },
    d: "M56.644,293.166c0,0.609,0.456,1.366,1.018,1.69l27.591,15.914 c0.562,0.325,1.018,0.094,1.018-0.515c0-0.609-0.456-1.365-1.018-1.69l-27.591-15.914 C57.1,292.327,56.644,292.557,56.644,293.166z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5123_",
    style: {
      fill: "#263238"
    },
    d: "M56.644,297.576c0,0.609,0.456,1.365,1.018,1.69l27.591,15.914 c0.562,0.324,1.018,0.094,1.018-0.515c0-0.609-0.456-1.365-1.018-1.69l-27.591-15.914 C57.1,296.736,56.644,296.967,56.644,297.576z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5122_",
    style: {
      fill: "#5f95fa"
    },
    d: "M57.662,297.061l15.243,8.785l0,2.205l-15.243-8.785 c-0.562-0.324-1.018-1.081-1.018-1.69C56.644,296.967,57.1,296.736,57.662,297.061z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4901_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5120_",
    style: {
      fill: "#455A64"
    },
    d: "M55.752,313.266l31.41,18.118c0.562,0.325,1.018,1.114,1.018,1.763l0,8.674 c0,0.649-0.456,0.912-1.018,0.588l-31.409-18.119c-0.562-0.324-1.018-1.114-1.018-1.763l0-8.674 C54.735,313.204,55.19,312.941,55.752,313.266z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5119_",
    style: {
      fill: "#5f95fa"
    },
    d: "M56.644,317.087c0,0.609,0.456,1.366,1.018,1.69l27.591,15.914 c0.562,0.325,1.018,0.094,1.018-0.515c0-0.609-0.456-1.366-1.018-1.69l-27.591-15.914 C57.1,316.248,56.644,316.479,56.644,317.087z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5118_",
    style: {
      fill: "#263238"
    },
    d: "M56.644,321.497c0,0.609,0.456,1.365,1.018,1.69l27.591,15.914 c0.562,0.324,1.018,0.094,1.018-0.515c0-0.609-0.456-1.365-1.018-1.69l-27.591-15.914 C57.1,320.658,56.644,320.888,56.644,321.497z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5117_",
    style: {
      fill: "#5f95fa"
    },
    d: "M57.662,320.982l19.061,10.99l0,2.204l-19.062-10.989 c-0.562-0.325-1.018-1.081-1.018-1.69S57.1,320.658,57.662,320.982z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_286_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2890_",
    style: {
      fill: "#455A64"
    },
    d: "M55.752,337.014l31.41,18.118c0.562,0.325,1.018,1.114,1.018,1.763l0,8.674 c0,0.649-0.456,0.912-1.018,0.588l-31.409-18.119c-0.562-0.325-1.018-1.114-1.018-1.763l0-8.674 C54.735,336.952,55.19,336.689,55.752,337.014z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2855_",
    style: {
      fill: "#5f95fa"
    },
    d: "M56.644,340.836c0,0.609,0.456,1.366,1.018,1.69l27.591,15.914 c0.562,0.324,1.018,0.094,1.018-0.515c0-0.609-0.456-1.365-1.018-1.69l-27.591-15.914 C57.1,339.996,56.644,340.227,56.644,340.836z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_288_",
    style: {
      fill: "#263238"
    },
    d: "M56.644,345.245c0,0.609,0.456,1.365,1.018,1.69l27.591,15.914 c0.562,0.324,1.018,0.094,1.018-0.515c0-0.609-0.456-1.365-1.018-1.69L57.662,344.73 C57.1,344.406,56.644,344.637,56.644,345.245z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_287_",
    style: {
      fill: "#5f95fa"
    },
    d: "M57.662,344.73l22.88,13.194l0,2.205l-22.88-13.194 c-0.562-0.324-1.018-1.081-1.018-1.69S57.1,344.406,57.662,344.73z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5126_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5130_",
    style: {
      fill: "#455A64"
    },
    d: "M55.752,265.653l31.41,18.118c0.562,0.324,1.018,1.114,1.018,1.763l0,8.674 c0,0.649-0.456,0.912-1.018,0.587l-31.409-18.119c-0.562-0.325-1.018-1.114-1.018-1.763l0-8.674 C54.735,265.592,55.19,265.329,55.752,265.653z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5129_",
    style: {
      fill: "#5f95fa"
    },
    d: "M56.644,269.475c0,0.609,0.456,1.366,1.018,1.69l27.591,15.914 c0.562,0.325,1.018,0.094,1.018-0.515c0-0.609-0.456-1.365-1.018-1.69L57.662,268.96 C57.1,268.636,56.644,268.866,56.644,269.475z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5128_",
    style: {
      fill: "#263238"
    },
    d: "M56.644,273.885c0,0.609,0.456,1.365,1.018,1.69l27.591,15.914 c0.562,0.324,1.018,0.094,1.018-0.515c0-0.609-0.456-1.365-1.018-1.69L57.662,273.37 C57.1,273.045,56.644,273.276,56.644,273.885z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5127_",
    style: {
      fill: "#5f95fa"
    },
    d: "M57.662,273.37l24.79,14.297v2.204l-24.789-14.296 c-0.562-0.325-1.018-1.081-1.018-1.69S57.1,273.045,57.662,273.37z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4988_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5025_",
    style: {
      fill: "#455A64"
    },
    d: "M55.752,217.86l31.41,18.119c0.562,0.324,1.018,1.114,1.018,1.763l0,8.674 c0,0.649-0.456,0.912-1.018,0.588l-31.409-18.119c-0.562-0.325-1.018-1.114-1.018-1.763l0-8.674 C54.735,217.799,55.19,217.536,55.752,217.86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5024_",
    style: {
      fill: "#5f95fa"
    },
    d: "M56.644,221.682c0,0.609,0.456,1.366,1.018,1.69l27.591,15.914 c0.562,0.325,1.018,0.094,1.018-0.515c0-0.609-0.456-1.365-1.018-1.69l-27.591-15.914 C57.1,220.843,56.644,221.074,56.644,221.682z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4994_",
    style: {
      fill: "#263238"
    },
    d: "M56.644,226.092c0,0.609,0.456,1.365,1.018,1.69l27.591,15.914 c0.562,0.324,1.018,0.094,1.018-0.515c0-0.609-0.456-1.365-1.018-1.69l-27.591-15.914 C57.1,225.253,56.644,225.483,56.644,226.092z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4991_",
    style: {
      fill: "#5f95fa"
    },
    d: "M57.662,225.577l19.061,10.99l0,2.204l-19.062-10.989 c-0.562-0.324-1.018-1.081-1.018-1.69C56.644,225.483,57.1,225.253,57.662,225.577z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_281_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4979_",
    style: {
      fill: "#455A64"
    },
    d: "M55.752,241.74l31.41,18.118c0.562,0.325,1.018,1.114,1.018,1.763l0,8.674 c0,0.649-0.456,0.912-1.018,0.587l-31.409-18.119c-0.562-0.325-1.018-1.114-1.018-1.763l0-8.673 C54.735,241.678,55.19,241.415,55.752,241.74z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4978_",
    style: {
      fill: "#5f95fa"
    },
    d: "M56.644,245.561c0,0.609,0.456,1.366,1.018,1.69l27.591,15.914 c0.562,0.324,1.018,0.094,1.018-0.515c0-0.609-0.456-1.365-1.018-1.69l-27.591-15.914 C57.1,244.722,56.644,244.953,56.644,245.561z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_283_",
    style: {
      fill: "#263238"
    },
    d: "M56.644,249.971c0,0.609,0.456,1.365,1.018,1.69l27.591,15.914 c0.562,0.325,1.018,0.094,1.018-0.515c0-0.609-0.456-1.365-1.018-1.69l-27.591-15.914 C57.1,249.132,56.644,249.362,56.644,249.971z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_282_",
    style: {
      fill: "#5f95fa"
    },
    d: "M57.662,249.456l24.79,14.297v2.205l-24.789-14.297 c-0.562-0.324-1.018-1.081-1.018-1.69S57.1,249.132,57.662,249.456z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4865_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4900_",
    style: {
      fill: "#5f95fa"
    },
    d: "M94.097,226.269l36.905-21.307c0.527-0.304,0.955-1.045,0.955-1.654v-1.243 c0-0.609-0.427-1.349-0.955-1.654l-36.905-21.307c-0.527-0.304-1.382-0.304-1.91,0l-36.905,21.307 c-0.527,0.304-0.955,1.045-0.955,1.654v1.243c0,0.609,0.427,1.349,0.955,1.654l36.905,21.307 C92.715,226.574,93.57,226.574,94.097,226.269z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_280_",
    style: {
      opacity: 0.35
    },
    d: "M94.097,226.269l36.905-21.307c0.527-0.304,0.955-1.045,0.955-1.654v-1.243 c0-0.609-0.427-1.349-0.955-1.654l-36.905-21.307c-0.527-0.304-1.382-0.304-1.91,0l-36.905,21.307 c-0.527,0.304-0.955,1.045-0.955,1.654v1.243c0,0.609,0.427,1.349,0.955,1.654l36.905,21.307 C92.715,226.574,93.57,226.574,94.097,226.269z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4899_",
    style: {
      fill: "#5f95fa"
    },
    d: "M131.002,201.514l-36.905,21.307c-0.527,0.305-1.382,0.305-1.91,0 l-36.905-21.307c-0.527-0.304-0.527-0.798,0-1.103l36.905-21.307c0.527-0.304,1.382-0.304,1.91,0l36.905,21.307 C131.529,200.716,131.529,201.21,131.002,201.514z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4882_",
    style: {
      fill: "#5f95fa"
    },
    d: "M93.14,223.049v3.447c0.345,0,0.691-0.073,0.956-0.228l36.906-21.309 c0.529-0.301,0.956-1.044,0.956-1.654v-1.242c0-0.537-0.331-1.176-0.779-1.529c0.346,0.301,0.287,0.713-0.176,0.978 l-36.906,21.309C93.831,222.975,93.486,223.049,93.14,223.049z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_278_",
    style: {
      opacity: 0.2
    },
    d: "M93.14,223.049v3.447c0.345,0,0.691-0.073,0.956-0.228l36.906-21.309 c0.529-0.301,0.956-1.044,0.956-1.654v-1.242c0-0.537-0.331-1.176-0.779-1.529c0.346,0.301,0.287,0.713-0.176,0.978 l-36.906,21.309C93.831,222.975,93.486,223.049,93.14,223.049z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2905_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4535_",
    style: {
      fill: "#263238"
    },
    d: "M94.097,215.926l24.962-14.412c0.527-0.305,0.955-1.045,0.955-1.654v-1.243 c0-0.609-0.427-1.349-0.955-1.654l-16.005-9.24c-0.527-0.304-1.249-0.948-1.612-1.436l-7.644-10.297 c-0.363-0.489-1.085-0.639-1.612-0.334l-24.962,14.411c-0.527,0.304-0.955,1.045-0.955,1.654l0.001,8.138 c0,0.609,0.428,1.349,0.955,1.654l24.962,14.412C92.715,216.231,93.57,216.231,94.097,215.926z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4532_",
    style: {
      fill: "#455A64"
    },
    d: "M92.187,212.479l-16.005-9.24c-0.254-0.146-0.553-0.372-0.835-0.62 c-0.304-0.268-0.589-0.563-0.777-0.816l-7.644-10.297c-0.363-0.489-0.23-1.132,0.298-1.437l24.962-14.411 c0.527-0.305,1.249-0.155,1.612,0.334l7.644,10.297c0.363,0.489,0.952,1.19,1.48,1.494l16.137,9.182 c0.527,0.304,0.527,0.798,0,1.102l-24.962,14.412C93.57,212.783,92.715,212.783,92.187,212.479z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4531_",
    style: {
      fill: "#37474F"
    },
    d: "M67.224,190.069l24.962-14.411c0.527-0.305,1.249-0.155,1.612,0.334 l7.644,10.297c0.189,0.255,0.476,0.546,0.781,0.813c0,0-26.867,15.522-26.875,15.515c-0.304-0.268-0.59-0.56-0.778-0.814 l-7.644-10.297C66.564,191.016,66.697,190.373,67.224,190.069z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3665_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4168_",
    style: {
      fill: "#5f95fa"
    },
    d: "M113.003,197.217c-0.618-0.357-1.621-0.357-2.239,0s-0.618,0.936,0,1.293 c0.618,0.357,1.621,0.357,2.239,0C113.621,198.153,113.621,197.574,113.003,197.217z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_275_",
    style: {
      fill: "#5f95fa"
    },
    d: "M108.524,199.803c-0.618-0.357-1.621-0.357-2.239,0 c-0.618,0.357-0.618,0.936,0,1.293c0.618,0.357,1.621,0.357,2.239,0C109.142,200.739,109.142,200.16,108.524,199.803z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_274_",
    style: {
      fill: "#263238"
    },
    d: "M104.046,202.389c-0.618-0.357-1.621-0.357-2.239,0 c-0.618,0.357-0.618,0.936,0,1.293c0.618,0.357,1.621,0.357,2.239,0C104.664,203.324,104.664,202.746,104.046,202.389z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_273_",
    style: {
      fill: "#263238"
    },
    d: "M99.567,204.974c-0.618-0.357-1.621-0.357-2.239,0 c-0.618,0.357-0.618,0.936,0,1.293c0.618,0.357,1.621,0.357,2.239,0C100.185,205.91,100.185,205.331,99.567,204.974z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3921_",
    style: {
      fill: "#5f95fa"
    },
    d: "M109.644,195.278c-0.618-0.357-1.621-0.357-2.239,0 c-0.618,0.357-0.618,0.936,0,1.293c0.618,0.357,1.621,0.357,2.239,0C110.262,196.214,110.262,195.635,109.644,195.278z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3920_",
    style: {
      fill: "#263238"
    },
    d: "M105.165,197.864c-0.618-0.357-1.621-0.357-2.239,0 c-0.618,0.357-0.618,0.936,0,1.293c0.618,0.357,1.621,0.357,2.239,0C105.784,198.799,105.784,198.221,105.165,197.864z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3919_",
    style: {
      fill: "#5f95fa"
    },
    d: "M100.687,200.449c-0.618-0.357-1.621-0.357-2.239,0 c-0.618,0.357-0.618,0.936,0,1.293c0.618,0.357,1.621,0.357,2.239,0C101.305,201.385,101.305,200.806,100.687,200.449z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3726_",
    style: {
      fill: "#263238"
    },
    d: "M96.208,203.035c-0.618-0.357-1.621-0.357-2.239,0 c-0.618,0.357-0.618,0.936,0,1.293s1.621,0.357,2.239,0C96.827,203.971,96.827,203.392,96.208,203.035z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3725_",
    style: {
      fill: "#263238"
    },
    d: "M106.285,193.339c-0.618-0.357-1.621-0.357-2.239,0 c-0.618,0.357-0.618,0.936,0,1.293s1.621,0.357,2.239,0C106.903,194.274,106.903,193.696,106.285,193.339z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3724_",
    style: {
      fill: "#5f95fa"
    },
    d: "M101.807,195.924c-0.618-0.357-1.621-0.357-2.239,0 c-0.618,0.357-0.618,0.936,0,1.293c0.618,0.357,1.621,0.357,2.239,0C102.425,196.86,102.425,196.281,101.807,195.924z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3723_",
    style: {
      fill: "#263238"
    },
    d: "M97.328,198.51c-0.618-0.357-1.621-0.357-2.239,0 c-0.618,0.357-0.618,0.936,0,1.293c0.618,0.357,1.621,0.357,2.239,0C97.946,199.446,97.946,198.867,97.328,198.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3721_",
    style: {
      fill: "#5f95fa"
    },
    d: "M95.063,207.508c-0.618-0.357-1.621-0.357-2.239,0 c-0.618,0.357-0.618,0.936,0,1.293c0.618,0.357,1.621,0.357,2.239,0C95.682,208.444,95.682,207.865,95.063,207.508z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3720_",
    style: {
      fill: "#263238"
    },
    d: "M91.704,205.569c-0.618-0.357-1.621-0.357-2.239,0 c-0.618,0.357-0.618,0.936,0,1.293c0.618,0.357,1.621,0.357,2.239,0C92.323,206.505,92.323,205.926,91.704,205.569z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3719_",
    style: {
      fill: "#263238"
    },
    d: "M92.85,201.098c-0.618-0.357-1.621-0.357-2.239,0 c-0.618,0.357-0.618,0.936,0,1.293c0.618,0.357,1.621,0.357,2.239,0C93.468,202.033,93.468,201.455,92.85,201.098z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3718_",
    style: {
      fill: "#5f95fa"
    },
    d: "M102.926,191.401c-0.618-0.357-1.621-0.357-2.239,0 c-0.618,0.357-0.618,0.936,0,1.293c0.618,0.357,1.621,0.357,2.239,0C103.545,192.337,103.545,191.758,102.926,191.401z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3717_",
    style: {
      fill: "#263238"
    },
    d: "M98.448,193.987c-0.618-0.357-1.621-0.357-2.239,0 c-0.618,0.357-0.618,0.936,0,1.293c0.618,0.357,1.621,0.357,2.239,0C99.066,194.923,99.066,194.344,98.448,193.987z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3669_",
    style: {
      fill: "#5f95fa"
    },
    d: "M93.969,196.573c-0.618-0.357-1.621-0.357-2.239,0 c-0.618,0.357-0.618,0.936,0,1.293c0.618,0.357,1.621,0.357,2.239,0C94.588,197.508,94.588,196.93,93.969,196.573z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3668_",
    style: {
      fill: "#263238"
    },
    d: "M89.491,199.158c-0.618-0.357-1.621-0.357-2.239,0 c-0.618,0.357-0.618,0.936,0,1.293c0.618,0.357,1.621,0.357,2.239,0C90.109,200.094,90.109,199.515,89.491,199.158z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3667_",
    style: {
      fill: "#5f95fa"
    },
    d: "M88.346,203.632c-0.618-0.357-1.621-0.357-2.239,0 c-0.618,0.357-0.618,0.936,0,1.293c0.618,0.357,1.621,0.357,2.239,0C88.964,204.567,88.964,203.988,88.346,203.632z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3666_",
    style: {
      fill: "#263238"
    },
    d: "M84.987,201.692c-0.618-0.357-1.621-0.357-2.239,0 c-0.618,0.357-0.618,0.936,0,1.293c0.618,0.357,1.621,0.357,2.239,0C85.605,202.628,85.605,202.049,84.987,201.692z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3498_",
    style: {
      fill: "#37474F"
    },
    d: "M93.089,212.707v3.44c0.36,0.007,0.728-0.059,1.007-0.221l24.962-14.414 c0.529-0.301,0.956-1.044,0.956-1.654v-1.242c0-0.536-0.331-1.176-0.779-1.529c0.345,0.301,0.287,0.713-0.176,0.978 l-24.962,14.414C93.817,212.641,93.449,212.714,93.089,212.707z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2916_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3480_",
    style: {
      fill: "#263238"
    },
    d: "M98.141,185.857l-0.022-0.03c-0.241-0.326-0.722-0.426-1.073-0.223 l-21.723,12.542c-0.352,0.203-0.44,0.631-0.197,0.957l0.023,0.03c0.243,0.326,0.724,0.425,1.076,0.222l21.717-12.539 C98.293,186.613,98.382,186.184,98.141,185.857z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3044_",
    style: {
      fill: "#5f95fa"
    },
    d: "M98.141,185.857l-0.022-0.03c-0.241-0.326-0.722-0.426-1.073-0.223 l-16.15,9.324l0.901,1.209l16.145-9.321C98.293,186.613,98.382,186.184,98.141,185.857z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3036_",
    style: {
      fill: "#263238"
    },
    d: "M96.345,183.447l-0.022-0.03c-0.241-0.326-0.722-0.427-1.074-0.224 l-21.723,12.542c-0.352,0.203-0.44,0.631-0.197,0.957l0.023,0.03c0.243,0.326,0.724,0.425,1.076,0.222l21.717-12.539 C96.497,184.203,96.587,183.773,96.345,183.447z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3027_",
    style: {
      fill: "#5f95fa"
    },
    d: "M96.345,183.447l-0.022-0.03c-0.241-0.326-0.722-0.427-1.074-0.224 l-5.399,3.116l0.901,1.209l5.394-3.113C96.497,184.203,96.587,183.773,96.345,183.447z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3011_",
    style: {
      fill: "#263238"
    },
    d: "M94.55,181.037l-0.022-0.03c-0.241-0.326-0.722-0.426-1.073-0.224 l-21.723,12.542c-0.352,0.203-0.44,0.631-0.197,0.957l0.023,0.03c0.243,0.326,0.724,0.425,1.076,0.222l21.717-12.539 C94.701,181.792,94.791,181.363,94.55,181.037z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3010_",
    style: {
      fill: "#5f95fa"
    },
    d: "M94.55,181.037l-0.022-0.03c-0.241-0.326-0.722-0.427-1.074-0.225 l-11.314,6.512l0.901,1.209l11.309-6.509C94.701,181.792,94.791,181.363,94.55,181.037z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3009_",
    style: {
      fill: "#263238"
    },
    d: "M92.754,178.626l-0.022-0.03c-0.241-0.326-0.722-0.427-1.073-0.224 l-21.723,12.542c-0.352,0.203-0.44,0.631-0.197,0.957l0.023,0.03c0.243,0.326,0.724,0.425,1.076,0.222l21.717-12.539 C92.906,179.382,92.995,178.953,92.754,178.626z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2971_",
    style: {
      fill: "#5f95fa"
    },
    d: "M92.754,178.626l-0.022-0.03c-0.241-0.326-0.722-0.427-1.073-0.224 L71.94,189.757l0.901,1.209l19.713-11.381C92.906,179.382,92.995,178.953,92.754,178.626z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Cable"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f95fa"
    },
    d: "M166.693,384.774l-10.958-6.323c-1.05-0.607-2.699-0.607-3.757,0l-59.817,34.54 c-0.809,0.459-2.17,0.459-2.979,0l-72.455-41.835c-0.319-0.187-0.498-0.42-0.498-0.638c0-0.218,0.179-0.451,0.498-0.63 l33.084-19.101c0.016-0.008,0.023-0.016,0.039-0.023c0.023-0.008,0.039-0.023,0.062-0.039c0.023-0.039,0.039-0.085,0.039-0.148 c0-0.171-0.125-0.389-0.28-0.474c-0.07-0.039-0.132-0.047-0.179-0.023c-0.023,0-0.047,0.015-0.062,0.031l-33.092,19.101 c-0.568,0.334-0.887,0.793-0.887,1.307c0,0.513,0.319,0.98,0.887,1.314l72.455,41.827c0.529,0.303,1.205,0.459,1.882,0.459 c0.676,0,1.353-0.156,1.874-0.459l59.817-34.532c0.809-0.467,2.178-0.467,2.979,0l10.958,6.323 c0.187,0.109,0.42,0.039,0.529-0.148C166.942,385.124,166.88,384.883,166.693,384.774z M173.008,381.126l-17.274-9.971 c-1.05-0.607-2.699-0.607-3.757,0l-59.817,34.532c-0.809,0.467-2.17,0.467-2.979,0l-59.817-34.532 c-0.319-0.187-0.498-0.42-0.498-0.638c0-0.218,0.179-0.443,0.498-0.63l26.862-15.445c0.008,0,0.008,0,0.015-0.008 c0.047-0.023,0.078-0.085,0.078-0.171c0-0.179-0.124-0.389-0.28-0.482c-0.062-0.039-0.117-0.047-0.163-0.031 c-0.031,0.008-0.047,0.023-0.07,0.047l-26.823,15.414c-0.576,0.334-0.894,0.801-0.894,1.307c0,0.513,0.311,0.98,0.886,1.314 l59.817,34.532c0.529,0.303,1.205,0.459,1.882,0.459c0.676,0,1.353-0.156,1.874-0.459l59.817-34.532 c0.809-0.467,2.178-0.467,2.979,0l17.274,9.971c0.187,0.109,0.428,0.039,0.529-0.148 C173.257,381.468,173.195,381.235,173.008,381.126z M185.647,373.831l-29.912-17.266c-1.05-0.607-2.699-0.607-3.757,0 l-59.817,34.532c-0.809,0.467-2.17,0.467-2.979,0l-34.54-19.941c-0.319-0.187-0.506-0.42-0.506-0.638 c0-0.218,0.187-0.451,0.506-0.63l14.115-8.15c0.016-0.008,0.031-0.023,0.047-0.031c0.023-0.008,0.039-0.023,0.054-0.039 c0.031-0.031,0.047-0.085,0.047-0.148c0-0.171-0.124-0.389-0.28-0.474c-0.07-0.039-0.132-0.047-0.179-0.023l-14.192,8.189 c-0.576,0.334-0.894,0.793-0.894,1.307c0,0.513,0.319,0.98,0.894,1.314l34.54,19.941c0.529,0.303,1.205,0.451,1.882,0.451 c0.676,0,1.353-0.148,1.874-0.451l59.817-34.54c0.809-0.459,2.17-0.459,2.979,0l29.912,17.274 c0.187,0.109,0.428,0.039,0.529-0.148C185.896,374.173,185.833,373.94,185.647,373.831z M179.331,377.478l-23.597-13.618 c-1.05-0.607-2.699-0.607-3.757,0l-59.817,34.532c-0.809,0.467-2.17,0.467-2.979,0l-47.178-27.237 c-0.319-0.187-0.506-0.42-0.506-0.638c0-0.218,0.187-0.451,0.506-0.63l20.492-11.829c0,0,0.008-0.008,0.016-0.008 c0.039-0.031,0.07-0.093,0.07-0.179c0-0.171-0.116-0.389-0.272-0.474c-0.07-0.039-0.14-0.047-0.187-0.023c0,0,0,0-0.008,0 l-20.5,11.836c-0.576,0.334-0.894,0.793-0.894,1.307c0,0.513,0.319,0.98,0.894,1.314l47.178,27.237 c0.529,0.303,1.205,0.459,1.882,0.459c0.676,0,1.353-0.155,1.874-0.459l59.817-34.54c0.809-0.459,2.178-0.459,2.979,0 l23.597,13.626c0.187,0.101,0.42,0.039,0.529-0.148C179.58,377.821,179.518,377.587,179.331,377.478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M166.693,384.774l-10.958-6.323c-1.05-0.607-2.699-0.607-3.757,0l-59.817,34.54 c-0.809,0.459-2.17,0.459-2.979,0l-72.455-41.835c-0.319-0.187-0.498-0.42-0.498-0.638c0-0.218,0.179-0.451,0.498-0.63 l33.084-19.101c0.016-0.008,0.023-0.016,0.039-0.023c0.023-0.008,0.039-0.023,0.062-0.039c0.023-0.039,0.039-0.085,0.039-0.148 c0-0.171-0.125-0.389-0.28-0.474c-0.07-0.039-0.132-0.047-0.179-0.023c-0.023,0-0.047,0.015-0.062,0.031l-33.092,19.101 c-0.568,0.334-0.887,0.793-0.887,1.307c0,0.513,0.319,0.98,0.887,1.314l72.455,41.827c0.529,0.303,1.205,0.459,1.882,0.459 c0.676,0,1.353-0.156,1.874-0.459l59.817-34.532c0.809-0.467,2.178-0.467,2.979,0l10.958,6.323 c0.187,0.109,0.42,0.039,0.529-0.148C166.942,385.124,166.88,384.883,166.693,384.774z M173.008,381.126l-17.274-9.971 c-1.05-0.607-2.699-0.607-3.757,0l-59.817,34.532c-0.809,0.467-2.17,0.467-2.979,0l-59.817-34.532 c-0.319-0.187-0.498-0.42-0.498-0.638c0-0.218,0.179-0.443,0.498-0.63l26.862-15.445c0.008,0,0.008,0,0.015-0.008 c0.047-0.023,0.078-0.085,0.078-0.171c0-0.179-0.124-0.389-0.28-0.482c-0.062-0.039-0.117-0.047-0.163-0.031 c-0.031,0.008-0.047,0.023-0.07,0.047l-26.823,15.414c-0.576,0.334-0.894,0.801-0.894,1.307c0,0.513,0.311,0.98,0.886,1.314 l59.817,34.532c0.529,0.303,1.205,0.459,1.882,0.459c0.676,0,1.353-0.156,1.874-0.459l59.817-34.532 c0.809-0.467,2.178-0.467,2.979,0l17.274,9.971c0.187,0.109,0.428,0.039,0.529-0.148 C173.257,381.468,173.195,381.235,173.008,381.126z M179.331,377.478l-23.597-13.618c-1.05-0.607-2.699-0.607-3.757,0 l-59.817,34.532c-0.809,0.467-2.17,0.467-2.979,0l-47.178-27.237c-0.319-0.187-0.506-0.42-0.506-0.638 c0-0.218,0.187-0.451,0.506-0.63l20.492-11.829c0,0,0.008-0.008,0.016-0.008c0.039-0.031,0.07-0.093,0.07-0.179 c0-0.171-0.116-0.389-0.272-0.474c-0.07-0.039-0.14-0.047-0.187-0.023c0,0,0,0-0.008,0l-20.5,11.836 c-0.576,0.334-0.894,0.793-0.894,1.307c0,0.513,0.319,0.98,0.894,1.314l47.178,27.237c0.529,0.303,1.205,0.459,1.882,0.459 c0.676,0,1.353-0.155,1.874-0.459l59.817-34.54c0.809-0.459,2.178-0.459,2.979,0l23.597,13.626 c0.187,0.101,0.42,0.039,0.529-0.148C179.58,377.821,179.518,377.587,179.331,377.478z M185.647,373.831l-29.912-17.266 c-1.05-0.607-2.699-0.607-3.757,0l-59.817,34.532c-0.809,0.467-2.17,0.467-2.979,0l-34.54-19.941 c-0.319-0.187-0.506-0.42-0.506-0.638c0-0.218,0.187-0.451,0.506-0.63l14.115-8.15c0.016-0.008,0.031-0.023,0.047-0.031 c0.023-0.008,0.039-0.023,0.054-0.039c0.031-0.031,0.047-0.085,0.047-0.148c0-0.171-0.124-0.389-0.28-0.474 c-0.07-0.039-0.132-0.047-0.179-0.023l-14.192,8.189c-0.576,0.334-0.894,0.793-0.894,1.307c0,0.513,0.319,0.98,0.894,1.314 l34.54,19.941c0.529,0.303,1.205,0.451,1.882,0.451c0.676,0,1.353-0.148,1.874-0.451l59.817-34.54c0.809-0.459,2.17-0.459,2.979,0 l29.912,17.274c0.187,0.109,0.428,0.039,0.529-0.148C185.896,374.173,185.833,373.94,185.647,373.831z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Folder"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f95fa"
    },
    d: "M70.331,130.337c-0.257,0-0.465,0.208-0.465,0.465v42.916c0,0.257,0.208,0.465,0.465,0.465 s0.465-0.208,0.465-0.465v-42.916C70.797,130.545,70.588,130.337,70.331,130.337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M70.331,130.337c-0.257,0-0.465,0.208-0.465,0.465v42.916 c0,0.257,0.208,0.465,0.465,0.465s0.465-0.208,0.465-0.465v-42.916C70.797,130.545,70.588,130.337,70.331,130.337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f95fa"
    },
    d: "M68.3,133.532c0-1.295,0.909-2.87,2.031-3.518c1.122-0.648,2.031-0.123,2.031,1.173 c0,1.295-0.909,2.87-2.031,3.518C69.209,135.352,68.3,134.827,68.3,133.532z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Folder_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f95fa"
    },
    d: "M95.791,105.065l-1.362-0.786c-0.668-0.386-1.292-1.318-1.394-2.083l-5.93-44.504 c-0.204-1.529-1.452-2.143-2.787-1.372L54.041,73.801c-1.336,0.771-3.044,0.314-3.815-1.022l-0.989-1.713 c-0.771-1.336-2.479-1.794-3.815-1.022l-14.07,8.124c-1.336,0.771-2.253,2.636-2.05,4.165l7.01,52.613 c0.102,0.764,0.726,1.697,1.394,2.082l1.363,0.787c0.334,0.193,0.635,0.211,0.854,0.085l56.725-32.751 C96.429,105.276,96.126,105.258,95.791,105.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25
    },
    d: "M95.791,105.065l-1.362-0.786c-0.668-0.386-1.292-1.318-1.394-2.083l-5.93-44.504 c-0.204-1.529-1.452-2.143-2.787-1.372L54.041,73.801c-1.336,0.771-3.044,0.314-3.815-1.022l-0.989-1.713 c-0.771-1.336-2.479-1.794-3.815-1.022l-14.07,8.124c-1.336,0.771-2.253,2.636-2.05,4.165l7.01,52.613 c0.102,0.764,0.726,1.697,1.394,2.082l1.363,0.787c0.334,0.193,0.635,0.211,0.854,0.085l56.725-32.751 C96.429,105.276,96.126,105.258,95.791,105.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25
    },
    d: "M37.705,137.028l1.363,0.787c0.334,0.193,0.635,0.211,0.854,0.085l56.725-32.751 c-0.219,0.127-0.522,0.109-0.856-0.084l-1.362-0.786c-0.328-0.189-0.644-0.512-0.894-0.881l-56.724,32.749 C37.061,136.516,37.377,136.839,37.705,137.028z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M38.035,132.285V87.976c0-1.028,0.722-2.279,1.612-2.793l49.717-28.704 c0.89-0.514,1.612-0.097,1.612,0.931v44.309c0,1.028-0.722,2.279-1.612,2.793l-49.717,28.704 C38.757,133.73,38.035,133.313,38.035,132.285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f95fa"
    },
    d: "M39.922,137.9c0.219-0.126,0.355-0.397,0.355-0.783V93.274c0-1.542,1.083-3.418,2.419-4.189 l51.886-29.957C95.917,58.356,97,58.981,97,60.524l0,43.843c0,0.385-0.135,0.656-0.353,0.782L39.922,137.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#FFFFFF"
    },
    d: "M39.922,137.9c0.219-0.126,0.355-0.397,0.355-0.783V93.274 c0-1.542,1.083-3.418,2.419-4.189l51.886-29.957C95.917,58.356,97,58.981,97,60.524l0,43.843c0,0.385-0.135,0.656-0.353,0.782 L39.922,137.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Device_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Laptop_4_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3579_",
    style: {
      fill: "#37474F"
    },
    d: "M142.823,407.962c0,2.743,2.053,4.502,4.586,5.964l103.8,59.93 c2.533,1.462,6.639,1.462,9.171,0l167.454-96.68c2.532-1.462,4.586-3.344,4.586-6.088c0-2.743-2.053-4.441-4.586-5.903 l-103.801-59.929c-2.533-1.462-6.639-1.462-9.172,0l-167.455,96.68C144.875,403.398,142.822,405.219,142.823,407.962z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3578_",
    style: {
      fill: "#455A64"
    },
    d: "M147.407,407.231l103.801,59.93c2.533,1.462,6.639,1.462,9.171,0l167.455-96.68 c2.533-1.462,2.533-3.833,0-5.295l-103.801-59.929c-2.533-1.462-6.639-1.462-9.172,0l-167.455,96.68 C144.875,403.398,144.875,405.769,147.407,407.231z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3575_",
    style: {
      fill: "#263238"
    },
    d: "M255.798,468.266v6.684c-1.663,0-3.325-0.36-4.586-1.091l-103.805-59.932 c-2.531-1.461-4.585-3.221-4.585-5.964c0-2.574,1.846-4.367,4.227-5.823c-1.967,1.39-2.004,3.726,0.358,5.092l103.805,59.932 C252.472,467.895,254.135,468.266,255.798,468.266z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3574_",
    style: {
      fill: "#37474F"
    },
    d: "M140.83,402.645c-2.011-0.926-2.556-2.524-2.748-5.337l-8.999-131.648 c-0.192-2.814,1.706-6.28,4.238-7.742l167.454-96.68c2.533-1.462,4.388-2.256,6.728-0.658c2.447,1.672,2.389,2.483,2.581,5.297 l8.998,131.648c0.192,2.814-1.706,6.28-4.238,7.742l-167.455,96.68C144.856,403.408,143.421,403.839,140.83,402.645z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3573_",
    style: {
      fill: "#455A64"
    },
    d: "M310.086,165.873c-0.191-2.808-2.402-3.902-4.935-2.447l-167.458,96.685 c-1.266,0.732-2.378,1.967-3.137,3.369l-4.37-2.197l-0.009,0c0.767-1.402,1.88-2.638,3.145-3.37l167.45-96.676 c2.532-1.463,4.398-2.271,6.727-0.658C309.958,162.282,309.894,163.065,310.086,165.873z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3571_",
    style: {
      fill: "#263238"
    },
    d: "M147.048,402.14c-2.305,1.362-3.765,1.53-6.218,0.5 c-1.876-0.787-2.554-2.52-2.746-5.332l-8.998-131.653c-0.096-1.406,0.325-2.976,1.1-4.37l4.369,2.181l0.001,0.01 c-0.763,1.404-1.196,2.964-1.1,4.37l8.998,131.653C142.632,402.109,144.885,403.418,147.048,402.14z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3568_",
    d: "M140.603,265.145l161.15-93.014c1.52-0.877,2.845-0.22,2.96,1.468l8.395,122.814 c0.115,1.688-1.023,3.768-2.543,4.645l-161.15,93.013c-1.52,0.877-2.845,0.22-2.96-1.468L138.06,269.79 C137.945,268.102,139.083,266.022,140.603,265.145z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f95fa"
    },
    d: "M140.603,265.145c-1.52,0.877-2.658,2.957-2.543,4.645l8.256,120.767l159.309-91.95 c1.52-0.877,2.658-2.957,2.543-4.645l-8.256-120.768L140.603,265.145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M140.603,265.145c-1.52,0.877-2.658,2.957-2.543,4.645l8.256,120.767l159.309-91.95 c1.52-0.877,2.658-2.957,2.543-4.645l-8.256-120.768L140.603,265.145z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3567_",
    style: {
      fill: "#263238"
    },
    d: "M161.571,402.714l153.884-88.844c1.194-0.689,3.13-0.689,4.324,0l5.605,3.144 c1.194,0.69,1.194,1.807,0,2.496l-153.907,88.83c-1.194,0.689-3.131,0.689-4.325,0l-5.582-3.13 C160.377,404.522,160.377,403.404,161.571,402.714z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2776_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3566_",
    style: {
      fill: "#263238"
    },
    d: "M176.683,411.628l153.882-88.845c1.194-0.689,2.963-0.786,3.951-0.215 l40.054,23.126c0.988,0.57,0.821,1.592-0.373,2.281l-153.704,88.724c-1.194,0.689-2.965,0.789-3.956,0.222l-40.223-23.018 C175.324,413.336,175.489,412.317,176.683,411.628z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2782_",
    style: {
      fill: "#455A64"
    },
    d: "M310.025,360.099l4.818-2.782c0.205-0.118,0.223-0.299,0.042-0.404l-4.61-2.661 c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.782c-0.205,0.118-0.223,0.299-0.041,0.404l4.609,2.661 C309.507,360.228,309.82,360.217,310.025,360.099z M302.99,350.474l-4.818,2.781c-0.204,0.118-0.223,0.299-0.041,0.404 l4.609,2.661c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.782c0.205-0.118,0.224-0.299,0.042-0.404l-4.61-2.662 C303.508,350.345,303.194,350.356,302.99,350.474z M287.424,359.461l-8.154,4.708c-0.204,0.118-0.223,0.299-0.041,0.404 l4.61,2.661c0.182,0.105,0.495,0.094,0.7-0.024l8.154-4.707c0.205-0.118,0.223-0.299,0.041-0.404l-4.609-2.662 C287.942,359.332,287.629,359.343,287.424,359.461z M295.948,354.539l-4.818,2.782c-0.204,0.118-0.223,0.299-0.041,0.404 l4.61,2.661c0.181,0.105,0.495,0.094,0.699-0.024l4.818-2.782c0.205-0.118,0.224-0.299,0.042-0.404l-4.61-2.661 C296.466,354.411,296.152,354.422,295.948,354.539z M277.046,365.453l-4.818,2.782c-0.205,0.118-0.223,0.299-0.042,0.404 l4.61,2.661c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.782c0.204-0.118,0.223-0.299,0.041-0.404l-4.609-2.661 C277.564,365.324,277.251,365.335,277.046,365.453z M270.004,369.518l-4.818,2.782c-0.205,0.118-0.223,0.299-0.042,0.404 l4.61,2.661c0.182,0.105,0.495,0.095,0.7-0.024l4.818-2.782c0.205-0.118,0.223-0.299,0.041-0.404l-4.609-2.661 C270.522,369.389,270.209,369.4,270.004,369.518z M288.072,380.378l4.818-2.782c0.204-0.118,0.223-0.299,0.041-0.404 l-4.609-2.661c-0.182-0.105-0.496-0.094-0.7,0.024l-4.818,2.782c-0.205,0.118-0.224,0.299-0.042,0.404l4.61,2.661 C287.553,380.506,287.867,380.496,288.072,380.378z M281.03,384.443l4.818-2.782c0.205-0.118,0.223-0.299,0.041-0.404 l-4.609-2.661c-0.182-0.105-0.495-0.095-0.7,0.023l-4.818,2.782c-0.205,0.118-0.223,0.299-0.042,0.404l4.609,2.661 C280.512,384.572,280.825,384.561,281.03,384.443z M273.988,388.509l4.818-2.782c0.205-0.118,0.223-0.299,0.041-0.404 l-4.609-2.662c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.782c-0.205,0.118-0.223,0.299-0.041,0.404l4.609,2.661 C273.47,388.637,273.783,388.627,273.988,388.509z M266.946,392.574l4.818-2.782c0.205-0.118,0.223-0.299,0.041-0.404 l-4.609-2.661c-0.182-0.105-0.495-0.095-0.7,0.024l-4.818,2.782c-0.205,0.118-0.223,0.299-0.041,0.404l4.609,2.661 C266.428,392.703,266.741,392.693,266.946,392.574z M302.983,364.165l4.818-2.782c0.204-0.118,0.223-0.299,0.042-0.404 l-4.61-2.661c-0.182-0.105-0.495-0.094-0.699,0.024l-4.818,2.781c-0.205,0.118-0.224,0.299-0.042,0.404l4.609,2.661 C302.465,364.294,302.778,364.283,302.983,364.165z M295.114,376.312l10.748-6.205c0.205-0.118,0.223-0.299,0.041-0.404 l-11.194-6.463c-0.182-0.105-0.495-0.094-0.7,0.024l-5.559,3.209c-0.205,0.118-0.223,0.299-0.042,0.404l5.927,3.421 c0.182,0.105,0.163,0.286-0.042,0.404l-4.447,2.568c-0.205,0.118-0.224,0.299-0.041,0.404l4.61,2.661 C294.595,376.441,294.909,376.43,295.114,376.312z M262.963,373.584l-4.818,2.782c-0.205,0.118-0.223,0.299-0.041,0.404 l4.609,2.661c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.781c0.205-0.118,0.223-0.299,0.041-0.404l-4.609-2.661 C263.481,373.455,263.167,373.466,262.963,373.584z M255.921,377.65l-4.818,2.781c-0.205,0.118-0.223,0.299-0.041,0.404 l4.609,2.661c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.782c0.205-0.118,0.223-0.299,0.042-0.404l-4.61-2.661 C256.439,377.521,256.125,377.531,255.921,377.65z M216.954,421.057c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.782 c0.204-0.118,0.223-0.299,0.041-0.404l-4.609-2.661c-0.182-0.105-0.496-0.094-0.7,0.024l-4.818,2.782 c-0.205,0.118-0.223,0.299-0.042,0.404L216.954,421.057z M199.586,410.174l-4.818,2.782c-0.205,0.118-0.223,0.299-0.041,0.404 l4.609,2.661c0.182,0.105,0.495,0.095,0.7-0.023l4.818-2.782c0.205-0.118,0.223-0.299,0.041-0.404l-4.609-2.661 C200.104,410.046,199.791,410.056,199.586,410.174z M208.515,418.326c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.782 c0.204-0.118,0.223-0.299,0.041-0.404l-4.609-2.661c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.782 c-0.205,0.118-0.223,0.299-0.041,0.404L208.515,418.326z M227.944,422.695l4.818-2.782c0.205-0.118,0.223-0.299,0.042-0.404 l-4.61-2.662c-0.182-0.105-0.495-0.094-0.7,0.025l-4.818,2.781c-0.204,0.118-0.223,0.299-0.041,0.404l4.609,2.661 C227.426,422.824,227.74,422.814,227.944,422.695z M220.203,426.785c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.782 c0.204-0.118,0.223-0.299,0.042-0.404l-4.61-2.661c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.782 c-0.204,0.118-0.223,0.299-0.041,0.404L220.203,426.785z M206.628,406.109l-4.818,2.782c-0.205,0.118-0.223,0.299-0.041,0.404 l4.609,2.661c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.782c0.205-0.118,0.223-0.299,0.041-0.404l-4.609-2.661 C207.146,405.98,206.833,405.991,206.628,406.109z M241.837,385.781l-4.818,2.781c-0.204,0.118-0.223,0.299-0.041,0.404 l4.609,2.661c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.782c0.204-0.118,0.223-0.299,0.041-0.404l-4.61-2.661 C242.355,385.652,242.042,385.663,241.837,385.781z M213.67,402.043l-4.818,2.782c-0.205,0.118-0.223,0.299-0.041,0.404 l4.609,2.661c0.182,0.105,0.495,0.095,0.7-0.024l4.818-2.782c0.205-0.118,0.223-0.299,0.041-0.404l-4.609-2.661 C214.188,401.914,213.875,401.925,213.67,402.043z M248.879,381.715l-4.818,2.782c-0.205,0.118-0.223,0.299-0.041,0.404 l4.609,2.661c0.182,0.105,0.495,0.095,0.7-0.024l4.818-2.781c0.205-0.118,0.223-0.299,0.042-0.404l-4.609-2.661 C249.397,381.586,249.083,381.597,248.879,381.715z M234.795,389.846l-4.818,2.782c-0.205,0.118-0.224,0.299-0.042,0.404 l4.61,2.661c0.182,0.105,0.495,0.095,0.7-0.024l4.818-2.781c0.205-0.118,0.224-0.299,0.042-0.404l-4.61-2.661 C235.313,389.717,235,389.728,234.795,389.846z M227.753,393.912l-4.818,2.782c-0.205,0.118-0.224,0.299-0.042,0.404l4.61,2.661 c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.781c0.204-0.118,0.223-0.299,0.041-0.404l-4.609-2.661 C228.271,393.783,227.958,393.794,227.753,393.912z M220.712,397.978l-4.818,2.781c-0.205,0.118-0.223,0.299-0.042,0.404 l4.61,2.661c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.782c0.204-0.118,0.223-0.299,0.041-0.404l-4.609-2.661 C221.23,397.849,220.916,397.86,220.712,397.978z M252.862,400.706l4.818-2.782c0.205-0.118,0.223-0.299,0.042-0.404 l-4.61-2.661c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.781c-0.205,0.119-0.223,0.299-0.041,0.405l4.609,2.661 C252.344,400.835,252.658,400.823,252.862,400.706z M318.556,341.487l-4.818,2.782c-0.205,0.118-0.223,0.299-0.042,0.404 l4.61,2.661c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.782c0.205-0.118,0.223-0.299,0.041-0.404l-4.609-2.661 C319.074,341.358,318.761,341.369,318.556,341.487z M310.032,346.409l-4.818,2.782c-0.205,0.118-0.223,0.299-0.041,0.404 l4.609,2.661c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.781c0.205-0.118,0.223-0.299,0.042-0.404l-4.61-2.661 C310.55,346.28,310.236,346.29,310.032,346.409z M325.598,337.422l-4.818,2.781c-0.205,0.118-0.223,0.299-0.042,0.404 l4.61,2.661c0.182,0.105,0.495,0.095,0.699-0.024l4.818-2.781c0.205-0.118,0.224-0.299,0.042-0.404l-4.609-2.661 C326.116,337.293,325.803,337.303,325.598,337.422z M286.676,373.58l4.818-2.781c0.205-0.118,0.223-0.299,0.041-0.404 l-4.609-2.661c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.782c-0.205,0.118-0.223,0.299-0.042,0.404l4.61,2.661 C286.158,373.709,286.471,373.698,286.676,373.58z M333.339,333.332c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.782 c-0.205,0.118-0.224,0.299-0.042,0.404l4.61,2.661c0.182,0.105,0.495,0.094,0.699-0.024l4.818-2.782 c0.205-0.118,0.223-0.299,0.042-0.404L333.339,333.332z M259.904,396.64l4.818-2.782c0.205-0.118,0.223-0.299,0.041-0.404 l-4.609-2.661c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.782c-0.205,0.118-0.223,0.299-0.041,0.404l4.609,2.661 C259.386,396.769,259.699,396.758,259.904,396.64z M346.259,346.782l4.818-2.781c0.205-0.118,0.223-0.299,0.042-0.404 l-4.61-2.661c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.781c-0.204,0.118-0.223,0.299-0.041,0.404l4.609,2.661 C345.741,346.911,346.055,346.901,346.259,346.782z M332.633,347.047l4.818-2.782c0.204-0.118,0.223-0.299,0.041-0.404 l-4.61-2.661c-0.181-0.105-0.495-0.094-0.699,0.024l-4.818,2.781c-0.205,0.119-0.224,0.299-0.042,0.404l4.61,2.661 C332.114,347.176,332.428,347.165,332.633,347.047z M339.924,337.134c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.782 c-0.204,0.118-0.223,0.299-0.041,0.404l4.61,2.661c0.182,0.105,0.495,0.094,0.699-0.024l4.818-2.782 c0.205-0.118,0.224-0.299,0.042-0.404L339.924,337.134z M341.407,336.278l11.194,6.463c0.182,0.105,0.495,0.094,0.7-0.024 l4.818-2.781c0.205-0.118,0.223-0.299,0.042-0.404l-11.195-6.463c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.781 C341.244,335.992,341.225,336.173,341.407,336.278z M325.141,345.289l-4.818,2.781c-0.205,0.118-0.224,0.299-0.042,0.404 l4.61,2.661c0.182,0.105,0.495,0.095,0.7-0.024l4.818-2.781c0.205-0.118,0.223-0.299,0.041-0.404l-4.609-2.661 C325.659,345.16,325.345,345.171,325.141,345.289z M272.142,375.888l-4.818,2.782c-0.205,0.118-0.223,0.299-0.041,0.404 l4.609,2.661c0.182,0.105,0.495,0.095,0.7-0.023l4.818-2.782c0.205-0.118,0.223-0.299,0.041-0.404l-4.609-2.661 C272.66,375.759,272.347,375.77,272.142,375.888z M338.518,350.872c0.181,0.105,0.495,0.094,0.7-0.024l4.818-2.782 c0.204-0.119,0.223-0.299,0.041-0.404l-4.61-2.661c-0.181-0.105-0.495-0.094-0.699,0.024l-4.818,2.782 c-0.205,0.118-0.224,0.299-0.042,0.404L338.518,350.872z M279.184,371.822l-4.818,2.782c-0.205,0.118-0.223,0.299-0.041,0.404 l4.609,2.661c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.782c0.205-0.118,0.223-0.299,0.041-0.404l-4.609-2.661 C279.702,371.693,279.388,371.704,279.184,371.822z M223.995,416.992c0.182,0.105,0.496,0.094,0.7-0.024l4.818-2.782 c0.204-0.118,0.223-0.299,0.041-0.404l-4.609-2.661c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.782 c-0.205,0.118-0.223,0.299-0.042,0.404L223.995,416.992z M215.807,408.413l-4.818,2.782c-0.205,0.118-0.223,0.299-0.041,0.404 l4.609,2.661c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.781c0.205-0.119,0.223-0.299,0.041-0.404l-4.609-2.661 C216.325,408.284,216.012,408.295,215.807,408.413z M231.737,412.902l4.818-2.782c0.205-0.118,0.224-0.299,0.042-0.404 l-4.61-2.661c-0.182-0.105-0.495-0.095-0.7,0.024l-4.818,2.782c-0.204,0.118-0.223,0.299-0.041,0.404l4.61,2.661 C231.219,413.031,231.532,413.021,231.737,412.902z M238.779,408.837l4.818-2.782c0.205-0.118,0.223-0.299,0.042-0.404 l-4.61-2.661c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.782c-0.205,0.118-0.223,0.299-0.041,0.404l4.61,2.661 C238.26,408.966,238.574,408.955,238.779,408.837z M245.821,404.771l4.818-2.781c0.205-0.118,0.223-0.299,0.042-0.405 l-4.61-2.661c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.781c-0.205,0.118-0.223,0.299-0.041,0.404l4.609,2.661 C245.303,404.9,245.616,404.889,245.821,404.771z M222.849,404.347l-4.818,2.781c-0.205,0.118-0.223,0.299-0.042,0.404 l4.61,2.661c0.182,0.105,0.495,0.095,0.7-0.024l4.818-2.782c0.205-0.118,0.223-0.299,0.041-0.404l-4.61-2.661 C223.367,404.218,223.054,404.229,222.849,404.347z M229.891,400.281l-4.818,2.782c-0.205,0.118-0.224,0.299-0.042,0.404 l4.61,2.662c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.782c0.204-0.118,0.223-0.299,0.041-0.404l-4.609-2.661 C230.409,400.153,230.095,400.164,229.891,400.281z M258.058,384.019l-4.818,2.781c-0.205,0.118-0.223,0.299-0.041,0.404 l4.609,2.661c0.182,0.105,0.495,0.095,0.7-0.024l4.818-2.781c0.205-0.118,0.223-0.299,0.042-0.405l-4.61-2.661 C258.576,383.89,258.263,383.901,258.058,384.019z M251.016,388.085l-4.818,2.782c-0.204,0.118-0.223,0.299-0.041,0.404 l4.609,2.661c0.182,0.105,0.496,0.094,0.7-0.024l4.818-2.781c0.205-0.118,0.223-0.299,0.042-0.404l-4.61-2.661 C251.534,387.956,251.221,387.966,251.016,388.085z M265.1,379.953l-4.818,2.782c-0.205,0.118-0.223,0.299-0.041,0.404 l4.609,2.661c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.782c0.205-0.118,0.223-0.298,0.041-0.404l-4.609-2.661 C265.618,379.825,265.305,379.836,265.1,379.953z M236.933,396.216l-4.818,2.782c-0.205,0.118-0.224,0.299-0.042,0.404 l4.61,2.661c0.182,0.105,0.495,0.095,0.7-0.024l4.818-2.782c0.204-0.118,0.223-0.299,0.041-0.404l-4.61-2.661 C237.451,396.087,237.137,396.098,236.933,396.216z M243.974,392.15l-4.818,2.782c-0.204,0.118-0.223,0.299-0.041,0.404 l4.61,2.661c0.181,0.105,0.495,0.094,0.7-0.024l4.818-2.782c0.205-0.118,0.224-0.299,0.042-0.404l-4.61-2.661 C244.493,392.021,244.179,392.032,243.974,392.15z M234.986,418.63l4.818-2.782c0.205-0.118,0.223-0.299,0.042-0.404 l-4.61-2.661c-0.182-0.105-0.495-0.095-0.7,0.024l-4.818,2.781c-0.205,0.118-0.223,0.299-0.041,0.404l4.609,2.661 C234.468,418.759,234.781,418.748,234.986,418.63z M197.854,416.877l-4.61-2.661c-0.182-0.105-0.495-0.094-0.7,0.024 l-4.818,2.782c-0.205,0.118-0.223,0.299-0.041,0.404l4.609,2.661c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.781 C198.017,417.163,198.035,416.982,197.854,416.877z M207.033,419.181l-4.61-2.661c-0.182-0.105-0.495-0.095-0.7,0.024 l-7.412,4.279c-0.205,0.118-0.223,0.299-0.041,0.404l4.609,2.661c0.182,0.105,0.495,0.095,0.7-0.024l7.412-4.28 C207.196,419.467,207.214,419.286,207.033,419.181z M190.973,411.621l-4.609-2.661c-0.182-0.105-0.495-0.095-0.7,0.024 l-5.93,3.424c-0.204,0.118-0.223,0.299-0.041,0.404l4.609,2.661c0.182,0.105,0.496,0.094,0.7-0.024l5.93-3.424 C191.137,411.907,191.155,411.726,190.973,411.621z M195.52,408.996c0.181,0.105,0.495,0.094,0.699-0.024l4.818-2.782 c0.205-0.118,0.224-0.299,0.042-0.404l-4.61-2.661c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.781 c-0.205,0.119-0.223,0.299-0.042,0.404L195.52,408.996z M215.471,421.913l-4.609-2.661c-0.182-0.105-0.495-0.094-0.7,0.024 l-9.266,5.349c-0.205,0.119-0.223,0.299-0.041,0.404l4.609,2.661c0.182,0.105,0.495,0.094,0.7-0.024l9.266-5.35 C215.634,422.199,215.653,422.018,215.471,421.913z M218.72,427.641l-4.61-2.661c-0.181-0.105-0.495-0.095-0.7,0.024 l-5.93,3.424c-0.205,0.118-0.223,0.299-0.041,0.404l4.609,2.661c0.182,0.105,0.495,0.094,0.7-0.024l5.93-3.424 C218.883,427.927,218.902,427.746,218.72,427.641z M247.877,378.768c0.182,0.105,0.495,0.094,0.699-0.024l4.818-2.782 c0.205-0.118,0.224-0.299,0.041-0.404l-4.609-2.661c-0.182-0.105-0.496-0.094-0.7,0.024l-4.818,2.782 c-0.205,0.118-0.224,0.299-0.042,0.404L247.877,378.768z M233.793,386.9c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.782 c0.205-0.118,0.223-0.299,0.041-0.404l-4.609-2.661c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.781 c-0.205,0.118-0.223,0.299-0.042,0.404L233.793,386.9z M202.561,404.931c0.182,0.105,0.496,0.095,0.7-0.024l4.818-2.782 c0.205-0.118,0.223-0.299,0.042-0.404l-4.609-2.661c-0.182-0.104-0.495-0.094-0.7,0.024l-4.818,2.782 c-0.204,0.118-0.223,0.299-0.041,0.404L202.561,404.931z M240.835,382.834c0.182,0.105,0.495,0.095,0.7-0.024l4.818-2.782 c0.204-0.118,0.223-0.299,0.041-0.404l-4.609-2.661c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.782 c-0.205,0.118-0.223,0.299-0.042,0.404L240.835,382.834z M226.751,390.965c0.182,0.104,0.495,0.094,0.7-0.025l4.818-2.781 c0.205-0.118,0.223-0.299,0.042-0.404l-4.609-2.661c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.782 c-0.205,0.118-0.223,0.299-0.041,0.404L226.751,390.965z M222.178,427.926c-0.182-0.105-0.495-0.095-0.7,0.024l-7.412,4.28 c-0.205,0.118-0.223,0.299-0.041,0.404l4.609,2.661c0.182,0.105,0.495,0.095,0.7-0.024l7.412-4.279 c0.205-0.118,0.223-0.299,0.041-0.404L222.178,427.926z M216.645,396.8c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.781 c0.205-0.118,0.223-0.299,0.041-0.404l-4.609-2.661c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.782 c-0.205,0.118-0.223,0.299-0.042,0.404L216.645,396.8z M209.603,400.865c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.782 c0.205-0.118,0.223-0.299,0.042-0.404l-4.61-2.661c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.782 c-0.205,0.118-0.223,0.299-0.041,0.404L209.603,400.865z M352.637,352.605c-0.182-0.105-0.495-0.094-0.7,0.024l-11.859,6.847 c-0.205,0.118-0.224,0.299-0.042,0.405l4.61,2.661c0.181,0.105,0.495,0.094,0.7-0.024l11.86-6.847 c0.204-0.118,0.223-0.299,0.041-0.404L352.637,352.605z M337.071,361.592c-0.182-0.105-0.495-0.095-0.7,0.024l-4.818,2.781 c-0.205,0.118-0.223,0.299-0.041,0.404l4.609,2.661c0.182,0.104,0.495,0.094,0.7-0.024l4.818-2.782 c0.205-0.118,0.223-0.299,0.041-0.404L337.071,361.592z M242.028,414.564l4.818-2.782c0.204-0.118,0.223-0.299,0.041-0.404 l-4.609-2.661c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.782c-0.205,0.118-0.223,0.299-0.041,0.404l4.609,2.661 C241.51,414.693,241.823,414.682,242.028,414.564z M322.988,369.723c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.781 c-0.205,0.119-0.223,0.299-0.041,0.404l4.609,2.661c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.782 c0.205-0.118,0.223-0.299,0.042-0.404L322.988,369.723z M359.679,348.539c-0.182-0.105-0.495-0.094-0.7,0.023l-4.818,2.782 c-0.204,0.118-0.223,0.299-0.041,0.404l4.609,2.661c0.182,0.105,0.496,0.094,0.7-0.024l4.818-2.782 c0.205-0.118,0.223-0.299,0.042-0.404L359.679,348.539z M371.331,347.135l-11.195-6.464c-0.182-0.105-0.495-0.094-0.7,0.024 l-4.818,2.782c-0.205,0.118-0.223,0.299-0.041,0.404l11.194,6.463c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.782 C371.494,347.421,371.512,347.24,371.331,347.135z M296.673,384.916c-0.182-0.105-0.495-0.094-0.7,0.024l-5.93,3.423 c-0.205,0.118-0.223,0.299-0.041,0.404l4.609,2.661c0.182,0.105,0.495,0.094,0.7-0.024l5.93-3.424 c0.205-0.118,0.224-0.299,0.041-0.404L296.673,384.916z M314.464,374.645c-0.182-0.105-0.495-0.094-0.7,0.024l-7.413,4.28 c-0.205,0.118-0.223,0.299-0.042,0.404l4.61,2.661c0.182,0.105,0.495,0.094,0.7-0.024l7.413-4.28 c0.205-0.118,0.223-0.299,0.041-0.404L314.464,374.645z M280.366,394.331c-0.182-0.105-0.495-0.094-0.7,0.024L240.01,417.25 c-0.205,0.118-0.224,0.299-0.042,0.404l4.61,2.661c0.182,0.105,0.495,0.095,0.7-0.024l39.657-22.896 c0.205-0.118,0.223-0.299,0.041-0.404L280.366,394.331z M238.486,418.51c-0.182-0.105-0.496-0.094-0.7,0.024l-5.93,3.424 c-0.205,0.118-0.223,0.299-0.041,0.404l4.609,2.661c0.182,0.105,0.495,0.094,0.7-0.024l5.93-3.424 c0.204-0.118,0.223-0.299,0.041-0.404L238.486,418.51z M288.52,389.623c-0.182-0.105-0.495-0.094-0.7,0.024l-5.93,3.423 c-0.205,0.119-0.224,0.299-0.042,0.404l4.61,2.661c0.182,0.106,0.495,0.095,0.7-0.023l5.93-3.424 c0.205-0.118,0.223-0.299,0.041-0.404L288.52,389.623z M230.332,423.218c-0.181-0.105-0.495-0.094-0.7,0.024l-5.93,3.424 c-0.205,0.118-0.223,0.299-0.041,0.404l4.609,2.661c0.182,0.105,0.495,0.094,0.7-0.024l5.93-3.424 c0.205-0.118,0.224-0.299,0.042-0.404L230.332,423.218z M304.827,380.208c-0.182-0.105-0.495-0.095-0.7,0.024l-5.93,3.424 c-0.204,0.118-0.223,0.299-0.041,0.404l4.61,2.661c0.181,0.105,0.495,0.094,0.699-0.024l5.93-3.424 c0.205-0.118,0.223-0.299,0.041-0.404L304.827,380.208z M330.03,365.657c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.782 c-0.205,0.118-0.223,0.299-0.041,0.404l4.609,2.661c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.781 c0.205-0.118,0.223-0.299,0.042-0.404L330.03,365.657z M345.802,354.65l4.818-2.782c0.205-0.118,0.224-0.299,0.042-0.404 l-4.61-2.661c-0.182-0.105-0.495-0.095-0.7,0.024l-4.818,2.781c-0.204,0.118-0.223,0.299-0.041,0.404l4.61,2.661 C345.284,354.779,345.598,354.768,345.802,354.65z M317.066,356.033l4.818-2.782c0.205-0.118,0.223-0.299,0.042-0.404 l-4.61-2.661c-0.182-0.105-0.495-0.095-0.7,0.024l-4.818,2.782c-0.205,0.118-0.223,0.299-0.041,0.404l4.609,2.661 C316.548,356.162,316.862,356.152,317.066,356.033z M298.363,382.039l14.084-8.131c0.205-0.118,0.223-0.299,0.041-0.404 l-4.609-2.661c-0.182-0.105-0.495-0.094-0.7,0.024l-14.084,8.131c-0.205,0.118-0.223,0.299-0.041,0.404l4.609,2.661 C297.845,382.168,298.158,382.158,298.363,382.039z M338.061,358.74c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.782 c0.205-0.118,0.224-0.299,0.042-0.404l-4.61-2.661c-0.182-0.105-0.495-0.094-0.699,0.024l-4.819,2.782 c-0.204,0.118-0.223,0.299-0.041,0.404L338.061,358.74z M332.176,354.914l4.818-2.782c0.204-0.118,0.223-0.299,0.041-0.404 l-4.609-2.661c-0.182-0.105-0.496-0.094-0.7,0.024l-4.818,2.782c-0.205,0.118-0.224,0.299-0.042,0.404l4.61,2.661 C331.657,355.043,331.971,355.032,332.176,354.914z M291.321,386.105l4.818-2.782c0.205-0.118,0.223-0.299,0.041-0.404 l-4.609-2.661c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.782c-0.205,0.118-0.223,0.299-0.041,0.404l4.609,2.661 C290.803,386.234,291.116,386.223,291.321,386.105z M322.494,367.727c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.782 c0.205-0.118,0.223-0.299,0.041-0.404l-4.61-2.661c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.782 c-0.205,0.118-0.223,0.299-0.041,0.404L322.494,367.727z M256.112,406.433l4.818-2.782c0.204-0.118,0.223-0.299,0.041-0.404 l-4.61-2.661c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.782c-0.205,0.118-0.223,0.299-0.042,0.404l4.61,2.661 C255.594,406.562,255.907,406.551,256.112,406.433z M263.154,402.367l4.818-2.782c0.204-0.118,0.223-0.299,0.041-0.404 l-4.61-2.661c-0.182-0.104-0.495-0.094-0.7,0.024l-4.818,2.782c-0.205,0.118-0.223,0.299-0.042,0.404l4.61,2.661 C262.636,402.496,262.949,402.486,263.154,402.367z M249.07,410.498l4.818-2.782c0.205-0.118,0.223-0.299,0.041-0.404 l-4.609-2.661c-0.182-0.105-0.495-0.095-0.7,0.024l-4.818,2.782c-0.205,0.118-0.223,0.299-0.042,0.404l4.609,2.661 C248.552,410.627,248.865,410.617,249.07,410.498z M277.237,394.236l4.818-2.781c0.205-0.118,0.223-0.299,0.041-0.404 l-4.609-2.661c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.782c-0.204,0.118-0.223,0.299-0.041,0.404l4.609,2.662 C276.719,394.365,277.033,394.354,277.237,394.236z M270.195,398.301l4.818-2.781c0.205-0.118,0.224-0.299,0.042-0.404 l-4.61-2.661c-0.182-0.105-0.495-0.095-0.7,0.024l-4.818,2.781c-0.204,0.118-0.223,0.299-0.041,0.404l4.61,2.661 C269.677,398.43,269.991,398.42,270.195,398.301z M284.279,390.171l4.818-2.782c0.205-0.118,0.223-0.299,0.042-0.404 l-4.61-2.661c-0.182-0.105-0.495-0.095-0.7,0.024l-4.818,2.782c-0.204,0.118-0.223,0.299-0.041,0.404l4.609,2.662 C283.761,390.299,284.074,390.289,284.279,390.171z M322.706,333.612c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.782 c0.205-0.118,0.223-0.299,0.041-0.404l-1.227-0.709c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.782 c-0.204,0.118-0.223,0.299-0.041,0.404L322.706,333.612z M287.706,355.772c0.181,0.105,0.495,0.095,0.7-0.024l4.818-2.782 c0.204-0.118,0.223-0.299,0.041-0.404l-4.609-2.661c-0.182-0.106-0.495-0.095-0.7,0.023l-4.818,2.782 c-0.205,0.118-0.224,0.299-0.042,0.404L287.706,355.772z M301.79,347.642c0.182,0.105,0.495,0.094,0.699-0.024l4.818-2.781 c0.205-0.118,0.223-0.299,0.042-0.404l-4.61-2.661c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.782 c-0.204,0.118-0.223,0.299-0.041,0.404L301.79,347.642z M279.108,360.737c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.782 c0.204-0.118,0.223-0.299,0.041-0.404l-4.609-2.661c-0.182-0.104-0.495-0.094-0.7,0.024l-4.818,2.781 c-0.205,0.118-0.223,0.299-0.041,0.404L279.108,360.737z M294.748,351.707c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.782 c0.204-0.118,0.223-0.299,0.041-0.404l-4.61-2.661c-0.181-0.105-0.495-0.094-0.699,0.024l-4.818,2.782 c-0.205,0.118-0.224,0.299-0.042,0.404L294.748,351.707z M265.024,368.868c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.781 c0.205-0.118,0.223-0.299,0.042-0.405l-4.61-2.661c-0.182-0.105-0.495-0.095-0.7,0.024l-4.818,2.782 c-0.205,0.119-0.223,0.299-0.041,0.404L265.024,368.868z M272.065,364.803c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.782 c0.205-0.118,0.223-0.299,0.041-0.404l-4.609-2.661c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.782 c-0.205,0.118-0.223,0.299-0.041,0.404L272.065,364.803z M308.623,341.744c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.782 c0.204-0.118,0.223-0.299,0.041-0.404l-1.227-0.709c-0.182-0.105-0.495-0.094-0.699,0.024l-4.818,2.782 c-0.205,0.118-0.224,0.299-0.042,0.404L308.623,341.744z M329.748,329.547c0.182,0.105,0.495,0.095,0.7-0.024l4.818-2.782 c0.204-0.118,0.223-0.299,0.041-0.404l-1.227-0.709c-0.182-0.104-0.495-0.094-0.7,0.024l-4.818,2.781 c-0.205,0.118-0.223,0.299-0.041,0.404L329.748,329.547z M339.431,335.137c0.182,0.105,0.495,0.094,0.7-0.024l4.818-2.782 c0.205-0.118,0.223-0.299,0.042-0.404l-4.61-2.661c-0.181-0.105-0.495-0.094-0.7,0.024l-4.818,2.782 c-0.205,0.118-0.223,0.299-0.041,0.404L339.431,335.137z M352.844,350.585l4.818-2.782c0.205-0.118,0.224-0.299,0.042-0.404 l-4.61-2.661c-0.181-0.105-0.495-0.094-0.7,0.024l-4.818,2.782c-0.204,0.118-0.223,0.299-0.041,0.404l4.609,2.662 C352.326,350.714,352.639,350.702,352.844,350.585z M315.665,337.678c0.182,0.105,0.495,0.095,0.7-0.024l4.818-2.781 c0.205-0.118,0.223-0.299,0.041-0.404l-1.227-0.708c-0.182-0.105-0.495-0.095-0.7,0.024l-4.818,2.782 c-0.204,0.118-0.223,0.299-0.041,0.404L315.665,337.678z M257.982,372.934c0.182,0.105,0.496,0.095,0.7-0.024l4.818-2.782 c0.205-0.118,0.224-0.299,0.042-0.404l-4.61-2.661c-0.182-0.105-0.495-0.094-0.7,0.024l-4.818,2.782 c-0.204,0.118-0.223,0.299-0.041,0.404L257.982,372.934z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1402_",
    style: {
      fill: "#263238"
    },
    points: "278.151,413.006 279.198,413.611 307.025,429.673 356.51,401.102  357.54,400.515 328.667,383.848  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#37474F"
    },
    points: "355.875,401.469 328.667,385.772 279.833,413.977 307.024,429.673  "
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Screen"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Window_4_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M153.619,273.588c-1.52,0.877-2.658,2.957-2.543,4.645L159.332,399l159.309-91.95 c1.52-0.877,2.658-2.957,2.543-4.645l-8.256-120.768L153.619,273.588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M312.927,181.637l-4.068-2.342l-159.309,91.952c-1.52,0.877-2.658,2.957-2.543,4.645l8.256,120.767 l4.068,2.342l159.309-91.95c1.52-0.877,2.658-2.957,2.543-4.645L312.927,181.637z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M153.619,273.588c-1.52,0.877-2.658,2.957-2.543,4.645L159.332,399l159.309-91.95 c1.52-0.877,2.658-2.957,2.543-4.645l-8.256-120.768L153.619,273.588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M312.039,183.304l8.147,119.169c0.089,1.297-0.867,3.031-2.045,3.711L160.22,397.333 l-8.146-119.167c-0.089-1.297,0.867-3.031,2.045-3.711L312.039,183.304 M312.927,181.637l-159.309,91.951 c-1.52,0.877-2.658,2.957-2.543,4.645L159.331,399l159.309-91.95c1.52-0.877,2.658-2.957,2.543-4.645L312.927,181.637 L312.927,181.637z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M164.278,323.428c-0.189,0-0.369-0.043-0.532-0.129c-0.365-0.195-0.593-0.586-0.627-1.075 l-2.54-37.251c-0.059-0.864,0.501-1.892,1.275-2.338l58.593-33.829c0.451-0.259,0.924-0.292,1.299-0.093 c0.365,0.194,0.594,0.586,0.628,1.075l2.54,37.251c0.06,0.865-0.5,1.892-1.274,2.339l-58.594,33.829 C164.791,323.355,164.527,323.428,164.278,323.428z M161.544,284.908l2.54,37.25c0.009,0.145,0.055,0.255,0.117,0.288 c0.054,0.028,0.182,0.026,0.362-0.077l58.594-33.828c0.456-0.264,0.827-0.935,0.792-1.436l-2.54-37.251 c-0.009-0.144-0.055-0.254-0.117-0.288c-0.057-0.029-0.182-0.026-0.362,0.077l-58.593,33.828 C161.881,283.736,161.51,284.406,161.544,284.908L161.544,284.908z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M167.567,371.635c-0.19,0-0.37-0.043-0.534-0.129c-0.365-0.195-0.593-0.586-0.626-1.076 l-2.54-37.249c-0.059-0.865,0.501-1.893,1.274-2.339l141.471-81.68c0.451-0.258,0.924-0.291,1.299-0.092 c0.366,0.195,0.594,0.586,0.628,1.075l2.54,37.251c0.059,0.865-0.5,1.892-1.274,2.339l-141.471,81.678 C168.079,371.56,167.816,371.635,167.567,371.635z M307.378,249.907c-0.067,0-0.163,0.025-0.282,0.093l-141.471,81.678 c-0.456,0.264-0.827,0.935-0.792,1.436l2.54,37.25c0.009,0.145,0.054,0.254,0.116,0.287c0.056,0.03,0.185,0.026,0.363-0.077 l141.471-81.678c0.457-0.263,0.827-0.934,0.792-1.435l-2.54-37.251c-0.009-0.144-0.055-0.255-0.117-0.288 C307.439,249.913,307.412,249.907,307.378,249.907z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M166.986,292.742l3.606-2.082c0.549-0.317,1.025-0.11,1.064,0.462 c0.039,0.572-0.374,1.293-0.923,1.609l-3.605,2.082c-0.549,0.317-1.025,0.11-1.065-0.462 C166.025,293.779,166.438,293.059,166.986,292.742z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M167.113,285.621l20.718-11.962c0.614-0.354,1.147-0.123,1.191,0.517 c0.044,0.64-0.419,1.446-1.033,1.8l-20.718,11.962c-0.614,0.355-1.147,0.123-1.191-0.517 C166.037,286.781,166.499,285.975,167.113,285.621z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M167.411,298.964l3.606-2.082c0.549-0.317,1.025-0.11,1.064,0.462s-0.374,1.293-0.923,1.609 l-3.605,2.082c-0.549,0.317-1.025,0.11-1.065-0.462S166.862,299.281,167.411,298.964z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M167.835,305.182l3.606-2.082c0.549-0.317,1.025-0.11,1.064,0.462 c0.039,0.572-0.374,1.292-0.923,1.609l-3.605,2.082c-0.549,0.317-1.025,0.11-1.065-0.462S167.286,305.499,167.835,305.182z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M168.257,311.376l3.606-2.082c0.549-0.317,1.025-0.11,1.064,0.462 c0.039,0.572-0.374,1.293-0.923,1.609l-3.605,2.082c-0.549,0.317-1.025,0.11-1.065-0.462S167.709,311.693,168.257,311.376z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M174.878,309.943c-0.082,0.002-0.165-0.036-0.214-0.106c-0.073-0.104-0.043-0.24,0.066-0.303 l44.982-25.977c0.109-0.063,0.258-0.031,0.331,0.074c0.073,0.104,0.043,0.24-0.066,0.303l-44.983,25.977 C174.959,309.931,174.919,309.942,174.878,309.943z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M174.454,303.728c-0.083,0.002-0.165-0.036-0.214-0.106c-0.073-0.104-0.043-0.24,0.066-0.303 l44.982-25.977c0.109-0.063,0.258-0.031,0.331,0.074c0.073,0.104,0.043,0.24-0.066,0.303l-44.983,25.977 C174.535,303.717,174.495,303.728,174.454,303.728z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M174.032,297.535c-0.083,0.002-0.165-0.036-0.214-0.106c-0.073-0.104-0.043-0.24,0.067-0.303 l44.982-25.977c0.109-0.063,0.258-0.03,0.331,0.074c0.073,0.104,0.043,0.24-0.066,0.303l-44.983,25.977 C174.113,297.524,174.072,297.534,174.032,297.535z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M173.61,291.342c-0.082,0.002-0.165-0.036-0.214-0.106c-0.073-0.104-0.043-0.24,0.067-0.303 l44.982-25.977c0.109-0.063,0.258-0.031,0.331,0.074c0.073,0.104,0.043,0.24-0.066,0.303l-44.983,25.977 C173.69,291.331,173.65,291.341,173.61,291.342z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5f95fa"
    },
    points: "175.709,309.142 175.291,303.016 179.514,299.763 184.658,296.745 187.745,292.589  192.99,289.561 195.977,285.414 206.465,279.359 209.752,274.769 214.111,268.59 218.594,265.399 219.845,283.744  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5f95fa"
    },
    points: "175.709,309.142 175.396,304.563 181.034,301.262 185.886,297.295 191.095,294.317  196.331,290.093 201.539,287.047 204.526,282.9 209.898,279.787 212.758,275.726 216.394,271.204 218.891,269.762  219.845,283.744  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f95fa"
    },
    d: "M236.959,247.92c0.227,3.324-1.409,7.07-3.653,8.365c-2.244,1.296-4.247-0.349-4.474-3.673 c-0.227-3.324,1.409-7.07,3.653-8.365C234.729,242.952,236.732,244.596,236.959,247.92z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M232.583,253.603c-0.139,0-0.276-0.048-0.386-0.138l-1.583-1.299 c-0.26-0.213-0.298-0.596-0.084-0.856c0.214-0.261,0.597-0.297,0.857-0.085l0.909,0.747l1.948-5.566 c0.111-0.317,0.457-0.482,0.775-0.373c0.317,0.111,0.484,0.458,0.373,0.775l-2.235,6.387 c-0.065,0.187-0.218,0.331-0.41,0.385C232.693,253.596,232.638,253.603,232.583,253.603z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M238.508,270.635c0.227,3.324-1.409,7.07-3.653,8.365c-2.244,1.296-4.247-0.349-4.474-3.673 s1.409-7.069,3.653-8.365C236.278,265.666,238.281,267.311,238.508,270.635z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M233.177,276.492c-0.081,0-0.164-0.016-0.244-0.051c-0.308-0.134-0.449-0.493-0.313-0.801 l2.535-5.805c0.133-0.308,0.492-0.448,0.801-0.314c0.308,0.135,0.449,0.493,0.314,0.801l-2.535,5.805 C233.635,276.356,233.411,276.492,233.177,276.492z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M235.997,274.864c-0.136,0-0.273-0.045-0.386-0.138l-3.104-2.549 c-0.26-0.213-0.297-0.597-0.084-0.857c0.213-0.26,0.597-0.296,0.856-0.084l3.104,2.549c0.26,0.213,0.298,0.597,0.084,0.857 C236.347,274.788,236.172,274.864,235.997,274.864z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M263.389,228.832l-21.791,12.581c-0.353,0.204-0.663,0.002-0.694-0.45l-0.008-0.122 c-0.031-0.452,0.23-0.984,0.583-1.187l21.791-12.581c0.352-0.204,0.663-0.002,0.694,0.45l0.008,0.122 C264.002,228.097,263.741,228.628,263.389,228.832z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M263.7,233.396l-21.791,12.581c-0.353,0.204-0.663,0.002-0.694-0.45l-0.008-0.122 c-0.031-0.452,0.23-0.984,0.583-1.187l21.791-12.581c0.353-0.204,0.663-0.002,0.694,0.45l0.008,0.122 C264.313,232.661,264.052,233.192,263.7,233.396z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M264.011,237.96l-21.791,12.581c-0.352,0.204-0.663,0.002-0.694-0.45l-0.008-0.122 c-0.031-0.452,0.23-0.984,0.583-1.187l21.791-12.581c0.353-0.204,0.663-0.002,0.694,0.45l0.008,0.122 C264.625,237.225,264.364,237.756,264.011,237.96z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M264.938,251.547l-21.791,12.581c-0.353,0.203-0.663,0.002-0.694-0.45l-0.008-0.122 c-0.031-0.452,0.23-0.984,0.583-1.187l21.791-12.581c0.353-0.203,0.663-0.002,0.694,0.45l0.008,0.122 C265.551,250.812,265.29,251.343,264.938,251.547z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M265.249,256.111l-21.791,12.581c-0.352,0.204-0.663,0.002-0.694-0.45l-0.008-0.122 c-0.031-0.452,0.23-0.984,0.583-1.187l21.791-12.581c0.353-0.204,0.663-0.002,0.694,0.45l0.008,0.122 C265.862,255.376,265.602,255.907,265.249,256.111z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M265.56,260.675l-21.791,12.581c-0.353,0.203-0.663,0.002-0.694-0.45l-0.008-0.122 c-0.031-0.452,0.23-0.984,0.583-1.187l21.791-12.581c0.353-0.203,0.663-0.002,0.694,0.45l0.008,0.122 C266.174,259.94,265.913,260.471,265.56,260.675z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f95fa"
    },
    d: "M277.931,224.265c0.227,3.324-1.409,7.07-3.653,8.365s-4.247-0.349-4.474-3.673 c-0.227-3.324,1.409-7.07,3.653-8.365S277.704,220.941,277.931,224.265z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M273.555,229.948c-0.139,0-0.276-0.048-0.386-0.138l-1.583-1.299 c-0.26-0.214-0.297-0.597-0.084-0.857c0.213-0.259,0.597-0.297,0.857-0.084l0.909,0.747l1.948-5.565 c0.112-0.317,0.458-0.482,0.775-0.373c0.317,0.111,0.484,0.458,0.373,0.775l-2.235,6.386 c-0.065,0.188-0.218,0.331-0.41,0.385C273.665,229.94,273.609,229.948,273.555,229.948z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M279.48,246.98c0.227,3.324-1.409,7.069-3.653,8.365c-2.244,1.296-4.247-0.349-4.474-3.673 c-0.227-3.324,1.409-7.07,3.653-8.365C277.25,242.011,279.253,243.656,279.48,246.98z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M274.149,252.837c-0.081,0-0.164-0.017-0.244-0.051c-0.308-0.134-0.449-0.493-0.313-0.801 l2.535-5.804c0.133-0.308,0.493-0.448,0.801-0.314c0.308,0.135,0.449,0.493,0.314,0.801l-2.535,5.804 C274.607,252.7,274.383,252.837,274.149,252.837z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M276.969,251.209c-0.136,0-0.273-0.045-0.386-0.138l-3.104-2.549 c-0.26-0.213-0.298-0.597-0.084-0.856c0.213-0.259,0.597-0.297,0.857-0.084l3.104,2.549c0.26,0.213,0.297,0.597,0.084,0.857 C277.319,251.133,277.144,251.209,276.969,251.209z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M304.361,205.177l-21.791,12.581c-0.353,0.203-0.663,0.002-0.694-0.45l-0.008-0.122 c-0.031-0.452,0.23-0.984,0.582-1.187l21.791-12.581c0.353-0.204,0.663-0.002,0.694,0.45l0.008,0.122 C304.974,204.441,304.713,204.973,304.361,205.177z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M304.672,209.74l-21.791,12.581c-0.353,0.204-0.663,0.002-0.694-0.45l-0.008-0.122 c-0.031-0.452,0.23-0.984,0.582-1.187l21.791-12.581c0.353-0.204,0.663-0.002,0.694,0.45l0.008,0.122 C305.285,209.005,305.025,209.537,304.672,209.74z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M304.983,214.305l-21.791,12.581c-0.352,0.203-0.663,0.002-0.694-0.45l-0.008-0.122 c-0.031-0.452,0.23-0.984,0.582-1.187l21.791-12.581c0.353-0.204,0.663-0.002,0.694,0.45l0.008,0.122 C305.597,213.569,305.336,214.101,304.983,214.305z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M305.91,227.891l-21.791,12.581c-0.353,0.204-0.663,0.002-0.694-0.45l-0.008-0.122 c-0.031-0.452,0.23-0.984,0.582-1.187l21.791-12.581c0.352-0.204,0.663-0.002,0.694,0.45l0.008,0.122 C306.523,227.156,306.263,227.688,305.91,227.891z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M306.221,232.455l-21.791,12.581c-0.353,0.204-0.663,0.002-0.694-0.45l-0.008-0.122 c-0.031-0.452,0.23-0.984,0.583-1.187l21.791-12.581c0.353-0.204,0.663-0.002,0.694,0.45l0.008,0.122 C306.835,231.72,306.574,232.252,306.221,232.455z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M306.533,237.019L284.741,249.6c-0.353,0.204-0.663,0.002-0.694-0.45l-0.008-0.122 c-0.031-0.452,0.23-0.984,0.582-1.187l21.791-12.581c0.353-0.204,0.663-0.002,0.694,0.45l0.008,0.122 C307.146,236.284,306.885,236.816,306.533,237.019z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4013_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M287.347,279.234c-0.003-0.04,0.006-0.082,0.028-0.125c0.021-0.042,0.048-0.074,0.079-0.093 l1.63-0.941c0.032-0.019,0.061-0.018,0.086-0.003c0.025,0.016,0.039,0.044,0.042,0.085l0.027,0.395 c0.003,0.041-0.007,0.083-0.027,0.126c-0.022,0.042-0.048,0.073-0.08,0.092l-1.218,0.703l0.001,0.74 c0.075-0.086,0.15-0.155,0.227-0.206c0.075-0.052,0.138-0.092,0.187-0.121c0.162-0.093,0.315-0.152,0.457-0.177 c0.142-0.024,0.268-0.011,0.378,0.04c0.108,0.051,0.197,0.139,0.266,0.266c0.069,0.125,0.11,0.293,0.125,0.5 c0.016,0.237,0,0.458-0.047,0.66c-0.048,0.204-0.119,0.389-0.215,0.558c-0.095,0.169-0.21,0.318-0.345,0.449 c-0.136,0.13-0.281,0.241-0.438,0.33c-0.199,0.115-0.372,0.184-0.52,0.208c-0.147,0.023-0.271,0.011-0.372-0.037 c-0.1-0.048-0.179-0.124-0.236-0.227c-0.057-0.105-0.093-0.227-0.109-0.368c-0.005-0.043,0.003-0.085,0.026-0.127 c0.022-0.042,0.05-0.073,0.082-0.091l0.351-0.202c0.029-0.017,0.056-0.02,0.081-0.009c0.024,0.011,0.043,0.034,0.054,0.07 c0.023,0.076,0.056,0.129,0.096,0.161c0.041,0.032,0.087,0.049,0.14,0.053c0.05,0.002,0.108-0.008,0.169-0.032 c0.061-0.024,0.125-0.055,0.191-0.093c0.165-0.095,0.294-0.229,0.388-0.404c0.094-0.173,0.133-0.36,0.119-0.56 c-0.011-0.167-0.071-0.277-0.18-0.33c-0.109-0.053-0.245-0.034-0.411,0.058c-0.086,0.05-0.155,0.099-0.204,0.145 c-0.05,0.045-0.089,0.089-0.119,0.129c-0.031,0.041-0.059,0.077-0.083,0.108c-0.025,0.031-0.057,0.059-0.098,0.083 l-0.398,0.23c-0.032,0.018-0.061,0.019-0.085,0.003c-0.025-0.016-0.04-0.044-0.043-0.085L287.347,279.234z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M292.233,277.766c0.007,0.07,0.014,0.146,0.02,0.231s0.012,0.174,0.018,0.262 c0.006,0.088,0.012,0.175,0.018,0.261c0.006,0.085,0.009,0.165,0.012,0.236c0.005,0.221-0.006,0.435-0.036,0.643 c-0.029,0.207-0.085,0.406-0.167,0.594c-0.081,0.188-0.193,0.362-0.333,0.522c-0.141,0.161-0.316,0.302-0.528,0.423 c-0.215,0.124-0.396,0.19-0.546,0.197c-0.15,0.008-0.275-0.03-0.375-0.113c-0.099-0.082-0.177-0.203-0.232-0.362 c-0.055-0.161-0.094-0.345-0.117-0.556c-0.016-0.137-0.029-0.296-0.042-0.476c-0.012-0.18-0.021-0.341-0.024-0.487 c-0.007-0.219,0.005-0.435,0.035-0.647c0.029-0.211,0.085-0.412,0.166-0.602c0.082-0.19,0.192-0.365,0.331-0.529 c0.14-0.163,0.315-0.306,0.53-0.429c0.211-0.123,0.392-0.187,0.544-0.195c0.151-0.009,0.277,0.028,0.376,0.111 c0.101,0.083,0.178,0.204,0.233,0.364C292.17,277.372,292.209,277.557,292.233,277.766z M290.551,279.739 c0.033,0.258,0.096,0.436,0.191,0.534c0.095,0.097,0.244,0.088,0.447-0.03c0.203-0.116,0.341-0.273,0.417-0.468 c0.075-0.196,0.112-0.432,0.108-0.707c-0.004-0.144-0.012-0.301-0.024-0.472c-0.012-0.171-0.025-0.324-0.04-0.462 c-0.033-0.259-0.098-0.436-0.192-0.534c-0.096-0.098-0.244-0.087-0.447,0.03c-0.203,0.116-0.341,0.273-0.417,0.469 c-0.076,0.196-0.111,0.431-0.107,0.706c0.004,0.145,0.011,0.301,0.022,0.472 C290.521,279.447,290.535,279.601,290.551,279.739z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M293.207,275.667c0.107-0.062,0.201-0.095,0.282-0.1c0.081-0.003,0.151,0.011,0.208,0.045 c0.058,0.034,0.104,0.085,0.137,0.153c0.034,0.068,0.056,0.143,0.067,0.224c0.012,0.093,0.022,0.194,0.03,0.304 c0.007,0.109,0.011,0.214,0.012,0.314c0,0.089-0.01,0.182-0.033,0.282c-0.022,0.099-0.057,0.197-0.107,0.293 c-0.048,0.096-0.111,0.186-0.186,0.27c-0.076,0.084-0.166,0.156-0.274,0.218c-0.106,0.062-0.201,0.096-0.281,0.102 c-0.08,0.006-0.151-0.008-0.208-0.042c-0.058-0.034-0.103-0.084-0.136-0.153c-0.033-0.067-0.056-0.143-0.067-0.225 c-0.013-0.092-0.022-0.194-0.03-0.303c-0.007-0.109-0.012-0.214-0.012-0.313c0-0.089,0.011-0.184,0.033-0.283 c0.022-0.099,0.057-0.196,0.106-0.292c0.049-0.096,0.112-0.187,0.187-0.273C293.009,275.802,293.1,275.729,293.207,275.667z  M294.955,274.796c0.018-0.045,0.037-0.083,0.058-0.115c0.021-0.031,0.051-0.058,0.091-0.081l0.261-0.15 c0.031-0.019,0.058-0.023,0.078-0.013c0.02,0.01,0.031,0.031,0.034,0.065c0,0.007-0.001,0.017-0.002,0.03 c-0.003,0.013-0.007,0.027-0.012,0.041l-1.896,4.854c-0.018,0.045-0.037,0.082-0.058,0.114 c-0.02,0.031-0.051,0.059-0.091,0.081l-0.26,0.15c-0.032,0.019-0.058,0.023-0.078,0.014 c-0.021-0.01-0.031-0.031-0.034-0.065c-0.001-0.008,0-0.018,0.002-0.03c0.002-0.013,0.006-0.026,0.011-0.041 L294.955,274.796z M293.522,276.791c0.002-0.023,0-0.061-0.003-0.109s-0.007-0.098-0.01-0.149 c-0.004-0.053-0.007-0.102-0.01-0.151c-0.003-0.048-0.006-0.082-0.011-0.104c-0.011-0.07-0.034-0.122-0.069-0.156 c-0.036-0.034-0.095-0.026-0.179,0.022c-0.084,0.048-0.139,0.108-0.168,0.178c-0.028,0.07-0.043,0.144-0.044,0.222 c-0.002,0.024-0.001,0.061,0.001,0.109c0.002,0.05,0.004,0.1,0.008,0.152c0.004,0.052,0.008,0.101,0.013,0.149 c0.005,0.047,0.009,0.081,0.014,0.102c0.011,0.07,0.034,0.122,0.069,0.155c0.036,0.033,0.095,0.027,0.179-0.022 c0.084-0.048,0.139-0.108,0.168-0.178C293.507,276.942,293.521,276.869,293.522,276.791z M295.218,276.535 c0.107-0.062,0.201-0.095,0.282-0.1c0.081-0.003,0.15,0.011,0.208,0.045c0.058,0.034,0.104,0.085,0.137,0.152 c0.033,0.068,0.056,0.143,0.067,0.224c0.012,0.093,0.022,0.194,0.03,0.304c0.007,0.109,0.011,0.214,0.012,0.314 c0,0.089-0.011,0.183-0.033,0.282c-0.022,0.099-0.057,0.196-0.107,0.293c-0.049,0.096-0.111,0.186-0.186,0.27 c-0.076,0.084-0.166,0.156-0.273,0.218c-0.107,0.062-0.201,0.096-0.281,0.102c-0.081,0.005-0.151-0.008-0.208-0.042 c-0.058-0.034-0.104-0.084-0.136-0.152c-0.033-0.067-0.056-0.143-0.067-0.225c-0.013-0.092-0.022-0.194-0.03-0.303 c-0.007-0.11-0.012-0.214-0.012-0.313c0-0.089,0.011-0.184,0.033-0.283c0.021-0.099,0.057-0.196,0.106-0.292 c0.049-0.096,0.111-0.187,0.187-0.273C295.02,276.671,295.111,276.597,295.218,276.535z M295.534,277.659 c0.002-0.023,0-0.061-0.003-0.109s-0.007-0.098-0.01-0.149c-0.004-0.053-0.007-0.103-0.01-0.151 c-0.003-0.048-0.007-0.082-0.011-0.104c-0.012-0.07-0.034-0.122-0.069-0.156c-0.036-0.034-0.095-0.026-0.179,0.022 c-0.084,0.048-0.14,0.108-0.168,0.178c-0.028,0.07-0.043,0.144-0.044,0.222c-0.002,0.024-0.002,0.061,0.001,0.109 c0.002,0.05,0.004,0.1,0.008,0.152c0.004,0.052,0.008,0.101,0.013,0.149c0.004,0.047,0.009,0.081,0.014,0.101 c0.011,0.071,0.034,0.124,0.069,0.157c0.035,0.033,0.095,0.027,0.179-0.022c0.084-0.048,0.139-0.108,0.168-0.178 C295.518,277.811,295.532,277.737,295.534,277.659z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4014_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M284.754,279.406c0.357-1.831,1.042-3.644,1.971-5.253c0.169-0.293,0.346-0.578,0.53-0.856 c0.991-1.494,2.196-2.75,3.525-3.603l-0.246-3.606c-1.944,1.212-3.701,3.055-5.128,5.248 c-0.182,0.28-0.357,0.567-0.528,0.858c-1.37,2.326-2.379,4.974-2.875,7.641c-0.061,0.326-0.111,0.653-0.156,0.979 c-0.176,1.278-0.233,2.552-0.149,3.786c0.084,1.235,0.304,2.348,0.635,3.334c0.085,0.252,0.174,0.497,0.273,0.732 c0.808,1.914,2.089,3.24,3.66,3.868c0.196,0.078,0.396,0.15,0.601,0.206c1.607,0.441,3.473,0.193,5.428-0.847l-0.246-3.606 c-1.34,0.688-2.618,0.866-3.731,0.587c-0.207-0.052-0.408-0.119-0.602-0.202c-1.07-0.455-1.94-1.37-2.511-2.665 c-0.102-0.231-0.193-0.474-0.275-0.729c-0.219-0.685-0.371-1.447-0.429-2.295c-0.058-0.847-0.017-1.721,0.096-2.597 C284.637,280.059,284.69,279.733,284.754,279.406z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4017_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f95fa"
    },
    d: "M301.758,269.069c-0.085-0.251-0.174-0.497-0.272-0.732c-0.858-2.052-2.225-3.47-3.906-4.134 c-0.197-0.078-0.396-0.148-0.601-0.205c-1.713-0.475-3.706-0.208-5.797,0.909l0.053,0.778l0.246,3.606l0.055,0.812 c1.203-0.611,2.348-0.771,3.349-0.529c0.207,0.05,0.409,0.115,0.603,0.199c0.957,0.414,1.737,1.237,2.253,2.395 c0.102,0.23,0.193,0.474,0.274,0.731c0.194,0.617,0.329,1.301,0.381,2.062c0.052,0.76,0.017,1.543-0.081,2.329 c-0.041,0.326-0.093,0.653-0.157,0.979c-0.325,1.644-0.938,3.27-1.768,4.716c-0.168,0.293-0.347,0.577-0.532,0.854 c-0.893,1.336-1.973,2.46-3.164,3.232l0.055,0.813l0.246,3.606l0.053,0.777c2.079-1.29,3.956-3.257,5.477-5.599 c0.182-0.28,0.357-0.567,0.529-0.857c1.466-2.481,2.544-5.31,3.068-8.16c0.06-0.326,0.111-0.653,0.156-0.979 c0.189-1.364,0.251-2.724,0.161-4.043C302.347,271.308,302.112,270.119,301.758,269.069z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4015_",
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M301.758,269.069c-0.085-0.251-0.174-0.497-0.272-0.732c-0.858-2.052-2.225-3.47-3.906-4.134 c-0.197-0.078-0.396-0.148-0.601-0.205c-1.713-0.475-3.706-0.208-5.797,0.909l0.053,0.778l0.246,3.606l0.055,0.812 c1.203-0.611,2.348-0.771,3.349-0.529c0.207,0.05,0.409,0.115,0.603,0.199c0.957,0.414,1.737,1.237,2.253,2.395 c0.102,0.23,0.193,0.474,0.274,0.731c0.194,0.617,0.329,1.301,0.381,2.062c0.052,0.76,0.017,1.543-0.081,2.329 c-0.041,0.326-0.093,0.653-0.157,0.979c-0.325,1.644-0.938,3.27-1.768,4.716c-0.168,0.293-0.347,0.577-0.532,0.854 c-0.893,1.336-1.973,2.46-3.164,3.232l0.055,0.813l0.246,3.606l0.053,0.777c2.079-1.29,3.956-3.257,5.477-5.599 c0.182-0.28,0.357-0.567,0.529-0.857c1.466-2.481,2.544-5.31,3.068-8.16c0.06-0.326,0.111-0.653,0.156-0.979 c0.189-1.364,0.251-2.724,0.161-4.043C302.347,271.308,302.112,270.119,301.758,269.069z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4008_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M261.292,298.593c-0.032,0.019-0.061,0.02-0.085,0.003c-0.026-0.017-0.04-0.044-0.043-0.086 l-0.046-0.672l-1.344,0.776c-0.032,0.018-0.061,0.019-0.085,0.003c-0.026-0.017-0.04-0.046-0.043-0.086l-0.027-0.394 c-0.004-0.053,0.003-0.104,0.02-0.154c0.015-0.049,0.035-0.104,0.058-0.164l1.183-2.892 c0.052-0.126,0.107-0.207,0.168-0.242l0.331-0.19c0.031-0.018,0.059-0.018,0.085-0.003c0.025,0.017,0.038,0.044,0.041,0.086 l0.152,2.224l0.373-0.215c0.032-0.019,0.061-0.02,0.085-0.003c0.024,0.016,0.04,0.044,0.043,0.086l0.027,0.394 c0.003,0.04-0.008,0.083-0.028,0.127c-0.021,0.042-0.047,0.072-0.079,0.092l-0.373,0.215l0.046,0.674 c0.003,0.04-0.006,0.082-0.027,0.126c-0.022,0.043-0.049,0.073-0.079,0.092L261.292,298.593z M261.071,297.143l-0.081-1.191 l-0.659,1.618L261.071,297.143z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M264.802,294.028c0.008,0.068,0.015,0.146,0.021,0.231c0.006,0.085,0.012,0.172,0.018,0.261 c0.006,0.09,0.012,0.177,0.018,0.262c0.006,0.085,0.01,0.163,0.011,0.236c0.005,0.22-0.006,0.434-0.035,0.642 c-0.029,0.207-0.085,0.405-0.167,0.593c-0.081,0.188-0.193,0.362-0.333,0.523c-0.142,0.16-0.317,0.3-0.528,0.423 c-0.215,0.123-0.396,0.189-0.545,0.197c-0.15,0.007-0.275-0.03-0.377-0.113c-0.1-0.083-0.177-0.205-0.231-0.364 c-0.054-0.159-0.094-0.345-0.117-0.554c-0.016-0.137-0.03-0.296-0.042-0.476c-0.012-0.18-0.02-0.342-0.023-0.486 c-0.007-0.221,0.005-0.435,0.035-0.647c0.029-0.212,0.084-0.412,0.165-0.602c0.083-0.19,0.193-0.366,0.333-0.529 c0.138-0.164,0.315-0.307,0.529-0.431c0.211-0.121,0.391-0.186,0.543-0.195c0.15-0.008,0.277,0.029,0.376,0.112 c0.101,0.083,0.178,0.204,0.233,0.364C264.74,293.633,264.778,293.818,264.802,294.028z M263.121,295.999 c0.033,0.259,0.097,0.438,0.191,0.535c0.095,0.096,0.244,0.086,0.447-0.03c0.202-0.117,0.34-0.274,0.416-0.469 c0.075-0.196,0.111-0.432,0.108-0.708c-0.003-0.143-0.012-0.301-0.024-0.472c-0.012-0.171-0.024-0.324-0.04-0.462 c-0.033-0.258-0.097-0.436-0.192-0.533c-0.096-0.098-0.244-0.087-0.446,0.029c-0.203,0.118-0.342,0.273-0.417,0.469 c-0.074,0.196-0.11,0.431-0.106,0.706c0.003,0.145,0.011,0.302,0.022,0.473 C263.091,295.708,263.105,295.863,263.121,295.999z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M265.778,291.928c0.106-0.062,0.2-0.095,0.282-0.1c0.08-0.004,0.15,0.011,0.208,0.045 c0.058,0.034,0.103,0.084,0.136,0.152c0.035,0.068,0.057,0.143,0.067,0.225c0.013,0.093,0.023,0.194,0.031,0.303 c0.007,0.11,0.011,0.214,0.011,0.314c0.001,0.089-0.009,0.183-0.033,0.282c-0.022,0.1-0.057,0.197-0.106,0.293 c-0.049,0.096-0.112,0.186-0.186,0.27c-0.077,0.084-0.167,0.157-0.273,0.219c-0.107,0.061-0.201,0.096-0.281,0.102 c-0.08,0.006-0.151-0.008-0.209-0.042c-0.058-0.034-0.103-0.085-0.136-0.153c-0.033-0.068-0.055-0.143-0.067-0.225 c-0.013-0.092-0.022-0.195-0.029-0.303c-0.008-0.11-0.013-0.214-0.013-0.314c0.001-0.089,0.011-0.183,0.033-0.282 c0.022-0.099,0.057-0.197,0.106-0.293c0.049-0.096,0.113-0.187,0.188-0.273 C265.579,292.062,265.671,291.989,265.778,291.928z M267.526,291.057c0.017-0.045,0.036-0.084,0.058-0.115 c0.02-0.031,0.05-0.058,0.09-0.082l0.261-0.15c0.031-0.018,0.057-0.022,0.078-0.013c0.019,0.009,0.031,0.03,0.033,0.065 c0,0.006,0,0.017-0.001,0.029c-0.003,0.013-0.007,0.027-0.012,0.042l-1.896,4.854c-0.017,0.045-0.036,0.082-0.058,0.113 c-0.02,0.032-0.05,0.059-0.09,0.082l-0.26,0.15c-0.032,0.019-0.059,0.023-0.078,0.013c-0.021-0.01-0.032-0.03-0.035-0.065 c-0.001-0.008,0.001-0.017,0.003-0.03c0.002-0.014,0.005-0.027,0.011-0.041L267.526,291.057z M266.093,293.052 c0.002-0.024,0.001-0.061-0.002-0.109s-0.007-0.098-0.01-0.15c-0.003-0.052-0.007-0.102-0.01-0.151 c-0.003-0.048-0.007-0.082-0.012-0.103c-0.011-0.071-0.033-0.123-0.069-0.156c-0.036-0.033-0.094-0.026-0.178,0.022 s-0.14,0.107-0.169,0.178c-0.027,0.07-0.042,0.145-0.044,0.222c-0.002,0.025-0.001,0.061,0.001,0.109 c0.002,0.049,0.005,0.1,0.009,0.151c0.004,0.053,0.007,0.102,0.012,0.149c0.005,0.047,0.009,0.082,0.014,0.102 c0.012,0.07,0.035,0.122,0.069,0.156c0.036,0.033,0.096,0.027,0.18-0.022c0.084-0.048,0.138-0.109,0.167-0.179 C266.078,293.203,266.091,293.129,266.093,293.052z M267.789,292.796c0.106-0.062,0.2-0.095,0.282-0.1 c0.08-0.004,0.15,0.011,0.208,0.045c0.058,0.034,0.103,0.084,0.136,0.152c0.033,0.068,0.057,0.143,0.067,0.225 c0.013,0.093,0.023,0.194,0.031,0.303c0.007,0.109,0.011,0.214,0.011,0.314c0.001,0.089-0.011,0.184-0.033,0.282 c-0.022,0.1-0.057,0.197-0.106,0.293c-0.049,0.096-0.111,0.186-0.186,0.27c-0.076,0.084-0.167,0.157-0.273,0.219 c-0.108,0.061-0.201,0.096-0.281,0.102c-0.082,0.006-0.151-0.008-0.209-0.042c-0.058-0.034-0.103-0.085-0.136-0.152 c-0.033-0.068-0.055-0.143-0.067-0.225c-0.013-0.092-0.022-0.195-0.029-0.303c-0.008-0.11-0.013-0.214-0.013-0.314 c0.001-0.089,0.011-0.183,0.033-0.282c0.022-0.099,0.057-0.197,0.106-0.293c0.049-0.096,0.111-0.187,0.188-0.273 C267.59,292.931,267.681,292.858,267.789,292.796z M268.104,293.92c0.002-0.023,0.001-0.06-0.002-0.108 c-0.003-0.048-0.007-0.098-0.01-0.15c-0.004-0.052-0.007-0.102-0.01-0.15s-0.007-0.082-0.012-0.103 c-0.012-0.07-0.034-0.123-0.069-0.156c-0.036-0.033-0.094-0.026-0.178,0.022s-0.14,0.107-0.169,0.178 c-0.027,0.071-0.042,0.145-0.044,0.222c-0.002,0.025-0.001,0.061,0.001,0.11c0.002,0.049,0.005,0.1,0.009,0.151 c0.004,0.053,0.007,0.102,0.012,0.149c0.005,0.047,0.009,0.082,0.014,0.102c0.012,0.071,0.035,0.123,0.069,0.157 c0.036,0.034,0.096,0.027,0.18-0.022c0.084-0.049,0.138-0.109,0.167-0.179C268.089,294.072,268.102,293.998,268.104,293.92z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4011_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M268.581,301.065c-0.991,1.495-2.196,2.75-3.525,3.603c-0.116,0.075-0.231,0.157-0.349,0.225 c-0.118,0.068-0.234,0.119-0.352,0.179c-1.34,0.688-2.618,0.867-3.731,0.587c-0.207-0.052-0.408-0.119-0.602-0.202 c-1.069-0.455-1.94-1.369-2.511-2.665c-0.102-0.231-0.193-0.474-0.275-0.729c-0.219-0.685-0.371-1.447-0.429-2.295 c-0.058-0.848-0.017-1.721,0.096-2.598c0.042-0.327,0.095-0.653,0.159-0.98c0.357-1.831,1.042-3.644,1.971-5.253 c0.169-0.293,0.346-0.578,0.53-0.856c0.991-1.495,2.196-2.75,3.525-3.603l-0.246-3.606 c-1.944,1.212-3.701,3.055-5.128,5.248c-0.182,0.28-0.357,0.567-0.528,0.858c-1.37,2.326-2.38,4.974-2.875,7.641 c-0.061,0.326-0.111,0.653-0.156,0.979c-0.176,1.278-0.234,2.551-0.15,3.786c0.084,1.235,0.304,2.348,0.635,3.334 c0.084,0.252,0.174,0.497,0.272,0.732c0.808,1.914,2.089,3.24,3.66,3.868c0.196,0.078,0.396,0.15,0.601,0.206 c1.607,0.441,3.473,0.193,5.428-0.847c0.117-0.062,0.234-0.123,0.351-0.191c0.118-0.068,0.233-0.141,0.35-0.214 c1.944-1.212,3.701-3.055,5.128-5.248L268.581,301.065z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4012_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f95fa"
    },
    d: "M274.065,285.853c-0.085-0.251-0.174-0.497-0.272-0.732c-0.858-2.052-2.225-3.47-3.906-4.134 c-0.197-0.078-0.396-0.148-0.601-0.205c-1.713-0.475-3.706-0.208-5.797,0.91l0.053,0.778l0.246,3.606l0.055,0.812 c1.203-0.611,2.348-0.771,3.349-0.529c0.207,0.05,0.409,0.115,0.603,0.199c0.957,0.414,1.737,1.237,2.253,2.395 c0.102,0.23,0.193,0.474,0.274,0.731c0.194,0.617,0.329,1.301,0.381,2.062c0.052,0.76,0.017,1.543-0.081,2.329 c-0.041,0.326-0.093,0.653-0.157,0.979c-0.325,1.644-0.938,3.27-1.768,4.716l0.415,0.44l1.847,1.959l0.402,0.426 c1.466-2.481,2.544-5.31,3.067-8.16c0.06-0.326,0.111-0.653,0.156-0.979c0.189-1.364,0.251-2.724,0.161-4.044 C274.655,288.092,274.419,286.904,274.065,285.853z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4004_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M233.911,310.349c0.031-0.018,0.059-0.018,0.085-0.003c0.025,0.017,0.038,0.045,0.041,0.086 l0.027,0.395c0.003,0.041-0.006,0.085-0.025,0.133c-0.019,0.048-0.037,0.09-0.057,0.128l-0.576,1.223 c0.132-0.053,0.253-0.081,0.362-0.082c0.111-0.002,0.206,0.023,0.287,0.075c0.082,0.051,0.148,0.13,0.197,0.236 c0.049,0.106,0.08,0.239,0.091,0.398c0.013,0.193-0.006,0.382-0.055,0.567c-0.048,0.184-0.121,0.358-0.221,0.524 c-0.098,0.165-0.217,0.315-0.356,0.454c-0.138,0.138-0.293,0.256-0.461,0.353c-0.202,0.116-0.38,0.187-0.532,0.212 c-0.154,0.025-0.284,0.018-0.39-0.021c-0.105-0.039-0.188-0.104-0.25-0.197c-0.06-0.093-0.099-0.195-0.115-0.309 c-0.006-0.043,0.003-0.086,0.025-0.127c0.022-0.043,0.05-0.073,0.081-0.091l0.344-0.198 c0.029-0.017,0.052-0.017,0.073-0.005c0.021,0.013,0.043,0.036,0.065,0.069c0.021,0.034,0.048,0.063,0.078,0.085 c0.032,0.021,0.073,0.035,0.123,0.039c0.049,0.004,0.11-0.005,0.184-0.029c0.074-0.023,0.163-0.065,0.266-0.124 c0.178-0.102,0.316-0.231,0.418-0.384c0.102-0.153,0.148-0.313,0.137-0.48c-0.011-0.167-0.074-0.255-0.187-0.265 c-0.113-0.01-0.258,0.037-0.435,0.138l-0.36,0.208c-0.032,0.018-0.061,0.019-0.085,0.002 c-0.025-0.016-0.04-0.044-0.043-0.085l-0.027-0.396c-0.003-0.04,0.006-0.084,0.026-0.133 c0.019-0.047,0.038-0.089,0.057-0.128l0.551-1.169l-1.197,0.691c-0.032,0.019-0.061,0.019-0.085,0.003 c-0.025-0.016-0.038-0.044-0.041-0.085l-0.027-0.395c-0.003-0.041,0.006-0.083,0.027-0.126 c0.021-0.042,0.047-0.074,0.079-0.093L233.911,310.349z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M237.031,310.056c0.008,0.069,0.015,0.146,0.021,0.231c0.006,0.085,0.012,0.173,0.018,0.262 c0.006,0.089,0.012,0.176,0.018,0.262c0.006,0.085,0.01,0.164,0.011,0.236c0.007,0.22-0.005,0.435-0.035,0.642 c-0.029,0.207-0.085,0.406-0.167,0.594c-0.081,0.188-0.193,0.362-0.333,0.522c-0.142,0.161-0.316,0.301-0.528,0.423 c-0.215,0.124-0.396,0.189-0.545,0.197c-0.15,0.007-0.275-0.03-0.375-0.113c-0.101-0.083-0.178-0.204-0.233-0.363 c-0.055-0.16-0.094-0.345-0.117-0.555c-0.016-0.137-0.03-0.296-0.043-0.475c-0.012-0.18-0.02-0.342-0.023-0.487 c-0.007-0.22,0.006-0.435,0.035-0.647c0.029-0.211,0.084-0.412,0.167-0.602c0.081-0.19,0.191-0.366,0.331-0.529 c0.138-0.164,0.315-0.306,0.529-0.43c0.211-0.122,0.391-0.187,0.543-0.195c0.15-0.008,0.277,0.028,0.377,0.112 c0.101,0.083,0.178,0.203,0.233,0.363C236.969,309.661,237.009,309.845,237.031,310.056z M235.35,312.027 c0.033,0.259,0.097,0.437,0.192,0.535c0.094,0.097,0.244,0.087,0.446-0.03c0.202-0.117,0.34-0.274,0.416-0.468 c0.076-0.196,0.111-0.433,0.108-0.708c-0.003-0.144-0.011-0.301-0.022-0.472c-0.012-0.171-0.025-0.324-0.042-0.462 c-0.033-0.259-0.097-0.436-0.192-0.534c-0.096-0.097-0.244-0.086-0.446,0.03c-0.202,0.117-0.342,0.273-0.416,0.469 c-0.075,0.196-0.111,0.431-0.108,0.707c0.003,0.145,0.011,0.301,0.022,0.472C235.32,311.736,235.334,311.89,235.35,312.027z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M238.007,307.956c0.106-0.062,0.2-0.095,0.282-0.1c0.08-0.004,0.15,0.011,0.208,0.045 c0.058,0.034,0.103,0.084,0.136,0.152c0.033,0.068,0.055,0.143,0.067,0.225c0.013,0.093,0.022,0.194,0.029,0.303 c0.007,0.11,0.013,0.214,0.013,0.314c-0.001,0.089-0.011,0.183-0.033,0.282c-0.022,0.1-0.057,0.197-0.106,0.293 c-0.049,0.096-0.111,0.186-0.186,0.27c-0.077,0.084-0.167,0.157-0.274,0.219c-0.108,0.061-0.201,0.096-0.283,0.102 c-0.08,0.005-0.15-0.008-0.208-0.042c-0.058-0.034-0.103-0.085-0.136-0.152c-0.033-0.068-0.055-0.143-0.067-0.225 c-0.013-0.092-0.022-0.195-0.029-0.303c-0.007-0.11-0.013-0.214-0.013-0.314c0.001-0.089,0.011-0.183,0.033-0.282 c0.022-0.099,0.057-0.197,0.106-0.293c0.049-0.096,0.111-0.187,0.186-0.273 C237.808,308.091,237.899,308.017,238.007,307.956z M239.753,307.085c0.019-0.045,0.038-0.084,0.058-0.115 c0.021-0.031,0.051-0.058,0.092-0.082l0.262-0.15c0.031-0.018,0.057-0.022,0.078-0.012c0.019,0.009,0.031,0.03,0.033,0.065 c0,0.006-0.001,0.017-0.003,0.03c-0.002,0.013-0.005,0.027-0.011,0.042l-1.896,4.854c-0.017,0.045-0.036,0.082-0.058,0.113 c-0.02,0.031-0.05,0.059-0.09,0.082l-0.26,0.15c-0.032,0.019-0.059,0.023-0.08,0.013c-0.019-0.01-0.031-0.03-0.033-0.065 c-0.001-0.008,0.001-0.017,0.003-0.03c0.001-0.014,0.005-0.026,0.009-0.04L239.753,307.085z M238.322,309.08 c0.002-0.024,0.001-0.061-0.002-0.109c-0.003-0.048-0.007-0.098-0.01-0.15c-0.004-0.052-0.007-0.103-0.01-0.151 s-0.007-0.082-0.012-0.103c-0.011-0.07-0.033-0.123-0.069-0.156c-0.036-0.033-0.094-0.026-0.178,0.022 c-0.084,0.048-0.14,0.107-0.169,0.178c-0.029,0.071-0.042,0.145-0.044,0.222c-0.002,0.025-0.001,0.061,0.001,0.11 c0.002,0.049,0.005,0.1,0.009,0.151c0.004,0.053,0.007,0.102,0.012,0.149c0.005,0.047,0.009,0.082,0.014,0.102 c0.012,0.07,0.033,0.122,0.069,0.156c0.036,0.033,0.096,0.027,0.18-0.022c0.084-0.048,0.139-0.109,0.167-0.179 C238.307,309.231,238.32,309.157,238.322,309.08z M240.018,308.824c0.106-0.062,0.2-0.095,0.282-0.1 c0.08-0.004,0.15,0.011,0.208,0.045c0.058,0.034,0.103,0.084,0.136,0.152c0.033,0.068,0.055,0.143,0.067,0.225 c0.013,0.093,0.022,0.194,0.029,0.303c0.007,0.109,0.013,0.214,0.013,0.314c-0.001,0.089-0.011,0.184-0.033,0.282 c-0.022,0.1-0.057,0.197-0.106,0.293c-0.049,0.096-0.111,0.186-0.186,0.27c-0.077,0.084-0.167,0.157-0.274,0.219 c-0.108,0.061-0.201,0.096-0.283,0.102c-0.08,0.006-0.15-0.008-0.207-0.042c-0.058-0.035-0.103-0.085-0.136-0.153 c-0.033-0.068-0.055-0.143-0.067-0.225c-0.013-0.092-0.023-0.195-0.031-0.303c-0.007-0.11-0.011-0.214-0.011-0.314 c0.001-0.089,0.011-0.183,0.033-0.282c0.022-0.099,0.057-0.197,0.106-0.293c0.049-0.096,0.111-0.186,0.186-0.273 C239.819,308.959,239.91,308.886,240.018,308.824z M240.333,309.948c0.002-0.023,0.001-0.06-0.002-0.108 c-0.003-0.048-0.007-0.098-0.01-0.15c-0.004-0.052-0.007-0.102-0.01-0.15c-0.003-0.048-0.007-0.082-0.012-0.103 c-0.011-0.071-0.035-0.123-0.069-0.156c-0.036-0.033-0.094-0.026-0.178,0.022c-0.084,0.049-0.14,0.107-0.169,0.178 c-0.029,0.071-0.042,0.145-0.044,0.222c-0.002,0.025-0.001,0.061,0.001,0.11c0.002,0.049,0.005,0.1,0.009,0.151 c0.004,0.053,0.007,0.102,0.012,0.149c0.005,0.047,0.009,0.082,0.014,0.102c0.012,0.071,0.033,0.123,0.069,0.157 c0.036,0.033,0.096,0.027,0.18-0.022c0.084-0.048,0.139-0.109,0.167-0.179C240.316,310.1,240.331,310.026,240.333,309.948z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4005_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M243.337,310.975c-0.357,1.831-1.042,3.644-1.971,5.253c-0.169,0.293-0.346,0.578-0.53,0.856 c-0.991,1.494-2.196,2.75-3.525,3.603c-0.117,0.075-0.23,0.157-0.349,0.225c-0.118,0.068-0.235,0.119-0.352,0.18 c-1.34,0.688-2.619,0.866-3.731,0.587c-0.207-0.052-0.408-0.119-0.602-0.202c-1.07-0.455-1.94-1.37-2.511-2.665 c-0.102-0.231-0.194-0.474-0.275-0.729c-0.219-0.685-0.371-1.447-0.429-2.295c-0.058-0.848-0.017-1.721,0.096-2.598 c0.042-0.327,0.095-0.653,0.159-0.98c0.357-1.831,1.042-3.644,1.971-5.253c0.169-0.293,0.346-0.578,0.53-0.856 c0.991-1.494,2.196-2.75,3.525-3.603l-0.246-3.606c-1.944,1.212-3.701,3.055-5.128,5.248 c-0.182,0.28-0.357,0.567-0.528,0.858c-1.37,2.326-2.379,4.974-2.875,7.641c-0.061,0.326-0.111,0.653-0.156,0.979 c-0.176,1.278-0.233,2.551-0.149,3.786c0.084,1.235,0.304,2.348,0.635,3.334c0.084,0.252,0.174,0.497,0.273,0.732 c0.808,1.914,2.088,3.24,3.66,3.868c0.196,0.078,0.396,0.15,0.601,0.206c1.607,0.441,3.473,0.193,5.428-0.847 c0.117-0.062,0.234-0.123,0.351-0.191c0.117-0.068,0.233-0.141,0.349-0.214c1.944-1.212,3.701-3.055,5.128-5.248 c0.182-0.28,0.357-0.567,0.528-0.858c1.37-2.326,2.38-4.974,2.875-7.641L243.337,310.975z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4007_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f95fa"
    },
    d: "M246.321,301.872c-0.085-0.251-0.174-0.497-0.273-0.732c-0.858-2.052-2.225-3.47-3.906-4.134 c-0.197-0.078-0.396-0.148-0.601-0.205c-1.713-0.475-3.706-0.208-5.797,0.91l0.053,0.778l0.246,3.606l0.055,0.812 c1.203-0.611,2.348-0.771,3.349-0.529c0.207,0.05,0.409,0.115,0.603,0.199c0.957,0.414,1.737,1.237,2.253,2.395 c0.102,0.23,0.193,0.474,0.274,0.731c0.194,0.617,0.329,1.301,0.381,2.062c0.052,0.76,0.017,1.543-0.081,2.329l0.619-0.097 l2.748-0.429l0.595-0.093c0.189-1.364,0.251-2.724,0.161-4.044C246.91,304.111,246.674,302.922,246.321,301.872z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4006_",
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M246.321,301.872c-0.085-0.251-0.174-0.497-0.273-0.732c-0.858-2.052-2.225-3.47-3.906-4.134 c-0.197-0.078-0.396-0.148-0.601-0.205c-1.713-0.475-3.706-0.208-5.797,0.91l0.053,0.778l0.246,3.606l0.055,0.812 c1.203-0.611,2.348-0.771,3.349-0.529c0.207,0.05,0.409,0.115,0.603,0.199c0.957,0.414,1.737,1.237,2.253,2.395 c0.102,0.23,0.193,0.474,0.274,0.731c0.194,0.617,0.329,1.301,0.381,2.062c0.052,0.76,0.017,1.543-0.081,2.329l0.619-0.097 l2.748-0.429l0.595-0.093c0.189-1.364,0.251-2.724,0.161-4.044C246.91,304.111,246.674,302.922,246.321,301.872z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3987_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M206.225,328.101c0.081-0.14,0.13-0.262,0.148-0.369c0.018-0.107,0.024-0.199,0.019-0.277 c-0.01-0.152-0.055-0.261-0.134-0.324c-0.079-0.064-0.203-0.047-0.371,0.05c-0.16,0.092-0.272,0.209-0.339,0.351 c-0.067,0.142-0.111,0.302-0.132,0.475c-0.006,0.054-0.021,0.1-0.045,0.138c-0.024,0.039-0.049,0.066-0.076,0.081 l-0.342,0.199c-0.032,0.018-0.061,0.02-0.088,0.007c-0.026-0.014-0.04-0.043-0.04-0.089 c-0.002-0.172,0.02-0.349,0.068-0.531c0.048-0.182,0.117-0.356,0.206-0.523c0.089-0.168,0.196-0.321,0.322-0.461 c0.126-0.139,0.264-0.254,0.415-0.34c0.182-0.105,0.342-0.158,0.48-0.159c0.139-0.001,0.255,0.034,0.35,0.105 c0.094,0.07,0.168,0.167,0.22,0.289c0.052,0.122,0.083,0.255,0.093,0.4c0.006,0.093,0.008,0.183,0.005,0.272 c-0.003,0.088-0.018,0.184-0.044,0.284c-0.026,0.103-0.067,0.216-0.121,0.342c-0.055,0.126-0.129,0.271-0.223,0.433 l-0.739,1.403l1.206-0.696c0.031-0.018,0.06-0.02,0.085-0.003c0.025,0.017,0.039,0.045,0.042,0.086l0.027,0.394 c0.003,0.041-0.006,0.083-0.027,0.127c-0.021,0.042-0.048,0.074-0.079,0.092l-2.026,1.17 c-0.032,0.018-0.06,0.019-0.085,0.003c-0.025-0.017-0.039-0.046-0.042-0.086l-0.023-0.34 c-0.004-0.062,0.007-0.125,0.032-0.189c0.027-0.063,0.049-0.11,0.068-0.14L206.225,328.101z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M209.842,325.741c0.008,0.068,0.014,0.146,0.02,0.231c0.006,0.085,0.012,0.172,0.018,0.261 c0.006,0.09,0.012,0.177,0.018,0.262c0.006,0.085,0.01,0.163,0.012,0.236c0.006,0.22-0.006,0.434-0.035,0.642 c-0.029,0.207-0.085,0.405-0.167,0.594c-0.081,0.188-0.193,0.362-0.334,0.523c-0.141,0.16-0.317,0.3-0.527,0.423 c-0.215,0.124-0.396,0.189-0.546,0.197c-0.15,0.007-0.275-0.03-0.375-0.113c-0.101-0.083-0.178-0.205-0.233-0.364 c-0.054-0.159-0.093-0.345-0.116-0.554c-0.016-0.137-0.03-0.296-0.043-0.476c-0.012-0.18-0.02-0.342-0.023-0.486 c-0.007-0.22,0.005-0.435,0.034-0.647c0.029-0.212,0.085-0.412,0.167-0.602c0.081-0.19,0.192-0.366,0.331-0.529 c0.139-0.164,0.315-0.307,0.53-0.431c0.211-0.121,0.391-0.186,0.543-0.195c0.151-0.008,0.278,0.029,0.377,0.112 c0.101,0.083,0.178,0.204,0.233,0.363C209.78,325.346,209.818,325.531,209.842,325.741z M208.159,327.712 c0.034,0.259,0.097,0.438,0.193,0.535c0.094,0.096,0.244,0.087,0.447-0.03c0.202-0.117,0.341-0.274,0.416-0.469 c0.076-0.196,0.111-0.432,0.108-0.708c-0.004-0.143-0.011-0.301-0.023-0.472c-0.012-0.171-0.026-0.324-0.041-0.462 c-0.033-0.258-0.097-0.436-0.192-0.533c-0.095-0.098-0.244-0.087-0.446,0.029c-0.202,0.118-0.342,0.273-0.417,0.469 c-0.076,0.196-0.111,0.431-0.108,0.706c0.004,0.145,0.011,0.302,0.023,0.473 C208.13,327.421,208.144,327.576,208.159,327.712z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M210.816,323.641c0.107-0.061,0.201-0.094,0.282-0.099c0.081-0.005,0.15,0.011,0.208,0.045 c0.058,0.033,0.104,0.084,0.137,0.151c0.033,0.068,0.055,0.143,0.067,0.226c0.012,0.093,0.021,0.194,0.029,0.302 c0.008,0.11,0.012,0.214,0.013,0.314c-0.001,0.089-0.011,0.184-0.033,0.282c-0.022,0.1-0.057,0.198-0.107,0.293 c-0.049,0.096-0.111,0.186-0.186,0.27c-0.076,0.084-0.166,0.157-0.273,0.219c-0.107,0.061-0.201,0.096-0.282,0.102 c-0.08,0.006-0.15-0.008-0.208-0.042c-0.058-0.033-0.104-0.085-0.137-0.152c-0.032-0.068-0.055-0.142-0.066-0.224 c-0.013-0.093-0.023-0.195-0.03-0.304c-0.007-0.11-0.012-0.214-0.012-0.314c0-0.089,0.011-0.182,0.032-0.282 c0.022-0.098,0.057-0.197,0.107-0.292c0.049-0.096,0.111-0.187,0.186-0.273C210.617,323.776,210.71,323.702,210.816,323.641 z M212.565,322.771c0.018-0.046,0.037-0.084,0.057-0.115c0.021-0.032,0.051-0.059,0.092-0.082l0.261-0.151 c0.031-0.018,0.058-0.021,0.078-0.013c0.02,0.01,0.031,0.031,0.034,0.065c0.001,0.007-0.001,0.017-0.002,0.03 c-0.003,0.013-0.007,0.026-0.011,0.042l-1.896,4.853c-0.018,0.045-0.037,0.083-0.058,0.114 c-0.021,0.031-0.051,0.058-0.091,0.082l-0.26,0.15c-0.032,0.018-0.058,0.023-0.079,0.013 c-0.02-0.01-0.031-0.031-0.033-0.065c-0.001-0.008,0-0.018,0.002-0.03c0.002-0.013,0.006-0.026,0.01-0.04L212.565,322.771z  M211.132,324.766c0.001-0.025,0-0.061-0.003-0.109c-0.003-0.048-0.007-0.098-0.01-0.151 c-0.003-0.051-0.007-0.103-0.01-0.151c-0.003-0.048-0.007-0.082-0.011-0.102c-0.012-0.07-0.035-0.124-0.07-0.157 c-0.036-0.033-0.095-0.026-0.179,0.022c-0.084,0.048-0.14,0.107-0.169,0.178c-0.028,0.071-0.042,0.146-0.043,0.222 c-0.002,0.025-0.002,0.061,0,0.11c0.002,0.048,0.005,0.099,0.009,0.151c0.003,0.052,0.008,0.102,0.012,0.148 c0.005,0.048,0.01,0.082,0.014,0.102c0.011,0.071,0.034,0.123,0.068,0.157c0.036,0.033,0.096,0.026,0.18-0.022 c0.084-0.048,0.139-0.108,0.168-0.178C211.116,324.917,211.13,324.843,211.132,324.766z M212.827,324.509 c0.107-0.061,0.201-0.094,0.282-0.099s0.15,0.011,0.208,0.045c0.058,0.033,0.104,0.084,0.137,0.151 c0.032,0.068,0.055,0.143,0.067,0.225c0.012,0.093,0.022,0.194,0.029,0.303c0.008,0.11,0.012,0.214,0.013,0.314 c-0.001,0.089-0.012,0.184-0.033,0.282c-0.022,0.1-0.057,0.197-0.107,0.293c-0.049,0.096-0.111,0.186-0.186,0.27 c-0.076,0.084-0.167,0.157-0.274,0.219c-0.107,0.062-0.201,0.096-0.282,0.102c-0.08,0.006-0.15-0.008-0.207-0.042 c-0.059-0.035-0.104-0.085-0.137-0.153c-0.032-0.068-0.055-0.142-0.066-0.224c-0.013-0.093-0.022-0.195-0.03-0.304 c-0.007-0.109-0.012-0.214-0.012-0.314c0-0.089,0.011-0.182,0.032-0.282c0.022-0.098,0.057-0.197,0.107-0.292 c0.049-0.096,0.111-0.187,0.186-0.273C212.629,324.645,212.72,324.571,212.827,324.509z M213.143,325.633 c0.001-0.023,0-0.059-0.003-0.107c-0.003-0.048-0.007-0.098-0.01-0.151c-0.003-0.051-0.007-0.103-0.01-0.151 s-0.007-0.082-0.011-0.102c-0.012-0.07-0.034-0.124-0.069-0.157c-0.036-0.033-0.095-0.026-0.179,0.022 c-0.084,0.048-0.14,0.107-0.169,0.178c-0.028,0.071-0.042,0.145-0.043,0.222c-0.002,0.025-0.002,0.061,0,0.11 c0.003,0.048,0.005,0.099,0.009,0.151c0.004,0.052,0.008,0.102,0.012,0.148c0.005,0.048,0.01,0.082,0.014,0.102 c0.011,0.071,0.034,0.123,0.069,0.157c0.036,0.033,0.096,0.026,0.18-0.022c0.084-0.048,0.139-0.108,0.168-0.178 C213.128,325.785,213.142,325.711,213.143,325.633z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4002_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M218.62,318.115l-2.596,2.657c0.219,0.685,0.371,1.447,0.429,2.295 c0.058,0.847,0.017,1.721-0.095,2.598c-0.042,0.327-0.095,0.653-0.159,0.98c-0.357,1.831-1.042,3.644-1.971,5.253 c-0.169,0.293-0.346,0.578-0.53,0.856c-0.991,1.494-2.196,2.75-3.525,3.603c-0.117,0.075-0.231,0.157-0.349,0.225 c-0.118,0.068-0.235,0.119-0.352,0.18c-1.34,0.688-2.619,0.866-3.731,0.586c-0.207-0.052-0.408-0.119-0.602-0.202 c-1.07-0.455-1.94-1.37-2.511-2.665c-0.102-0.231-0.194-0.474-0.275-0.729c-0.219-0.685-0.371-1.447-0.429-2.295 s-0.017-1.721,0.096-2.598c0.042-0.327,0.095-0.653,0.158-0.98c0.357-1.831,1.042-3.644,1.971-5.253 c0.169-0.293,0.346-0.578,0.53-0.856c0.991-1.494,2.196-2.75,3.525-3.603l-0.246-3.606 c-1.944,1.212-3.701,3.055-5.128,5.248c-0.182,0.28-0.357,0.567-0.528,0.858c-1.37,2.326-2.38,4.974-2.875,7.641 c-0.061,0.326-0.111,0.653-0.156,0.979c-0.176,1.278-0.234,2.551-0.149,3.786c0.084,1.235,0.304,2.348,0.635,3.334 c0.084,0.252,0.174,0.497,0.273,0.732c0.808,1.914,2.089,3.24,3.66,3.868c0.196,0.079,0.396,0.15,0.601,0.206 c1.607,0.441,3.472,0.193,5.428-0.847c0.117-0.062,0.234-0.123,0.351-0.191c0.117-0.068,0.233-0.141,0.35-0.214 c1.944-1.212,3.701-3.055,5.128-5.248c0.182-0.28,0.357-0.567,0.528-0.858c1.37-2.326,2.379-4.974,2.875-7.641 c0.061-0.327,0.111-0.653,0.156-0.979c0.176-1.278,0.234-2.552,0.149-3.786C219.171,320.214,218.951,319.1,218.62,318.115z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4003_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f95fa"
    },
    d: "M215.003,312.674c-0.197-0.078-0.396-0.148-0.601-0.205 c-1.713-0.475-3.706-0.208-5.797,0.909l0.053,0.778l0.246,3.606l0.055,0.812c1.203-0.611,2.348-0.771,3.349-0.529 c0.207,0.05,0.409,0.115,0.603,0.199c0.957,0.414,1.737,1.237,2.253,2.395l0.584-0.597l2.599-2.659l0.562-0.575 C218.051,314.756,216.684,313.338,215.003,312.674z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3983_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M177.902,343.979c-0.023-0.022-0.033-0.054-0.032-0.097c0.001-0.044,0.014-0.086,0.038-0.127 l0.877-1.495c0.022-0.035,0.045-0.071,0.067-0.105s0.049-0.061,0.079-0.077l0.338-0.195 c0.031-0.019,0.061-0.019,0.085-0.003c0.025,0.017,0.039,0.045,0.042,0.086l0.245,3.594 c0.003,0.041-0.006,0.082-0.027,0.126c-0.021,0.042-0.048,0.073-0.079,0.092l-0.352,0.203 c-0.032,0.019-0.06,0.019-0.085,0.003c-0.025-0.017-0.039-0.045-0.042-0.086l-0.187-2.749l-0.573,0.973 c-0.024,0.042-0.052,0.068-0.083,0.08c-0.031,0.012-0.059,0.008-0.085-0.013L177.902,343.979z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M182.366,341.605c0.008,0.068,0.014,0.146,0.02,0.231c0.006,0.085,0.012,0.172,0.018,0.261 c0.006,0.09,0.012,0.177,0.018,0.262c0.006,0.085,0.01,0.163,0.012,0.236c0.006,0.22-0.006,0.434-0.035,0.642 c-0.029,0.207-0.085,0.405-0.167,0.594c-0.082,0.188-0.193,0.362-0.334,0.523c-0.141,0.16-0.317,0.3-0.527,0.423 c-0.215,0.123-0.396,0.189-0.546,0.197c-0.149,0.007-0.275-0.03-0.375-0.113c-0.1-0.083-0.178-0.205-0.233-0.364 c-0.055-0.159-0.093-0.345-0.116-0.554c-0.016-0.137-0.03-0.296-0.043-0.476c-0.012-0.18-0.02-0.342-0.023-0.486 c-0.007-0.221,0.005-0.435,0.034-0.647c0.029-0.212,0.085-0.412,0.167-0.602c0.081-0.19,0.192-0.366,0.331-0.529 c0.139-0.164,0.315-0.307,0.53-0.431c0.211-0.121,0.391-0.186,0.543-0.195c0.151-0.008,0.277,0.029,0.377,0.112 c0.101,0.083,0.178,0.204,0.233,0.363C182.303,341.209,182.342,341.394,182.366,341.605z M180.683,343.576 c0.034,0.259,0.097,0.438,0.193,0.535c0.095,0.096,0.244,0.087,0.447-0.03c0.202-0.117,0.341-0.274,0.416-0.469 c0.076-0.196,0.112-0.432,0.108-0.708c-0.004-0.143-0.011-0.301-0.023-0.472c-0.012-0.171-0.025-0.324-0.041-0.462 c-0.033-0.258-0.097-0.435-0.192-0.533c-0.095-0.098-0.244-0.087-0.446,0.029c-0.202,0.118-0.342,0.273-0.417,0.469 c-0.076,0.196-0.111,0.431-0.108,0.706c0.004,0.145,0.011,0.302,0.023,0.473 C180.654,343.284,180.668,343.439,180.683,343.576z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M183.34,339.504c0.107-0.061,0.201-0.094,0.282-0.099c0.081-0.005,0.15,0.011,0.208,0.045 c0.058,0.033,0.104,0.084,0.137,0.151c0.033,0.068,0.055,0.143,0.067,0.226c0.012,0.093,0.022,0.194,0.029,0.302 c0.008,0.11,0.012,0.214,0.013,0.314c-0.001,0.089-0.011,0.184-0.033,0.282c-0.022,0.1-0.057,0.198-0.107,0.293 c-0.049,0.096-0.111,0.186-0.186,0.27c-0.076,0.084-0.167,0.157-0.274,0.219c-0.107,0.061-0.201,0.096-0.282,0.102 c-0.08,0.006-0.15-0.008-0.208-0.042c-0.058-0.033-0.104-0.085-0.137-0.153c-0.032-0.068-0.055-0.142-0.066-0.224 c-0.013-0.093-0.023-0.195-0.03-0.304c-0.007-0.109-0.012-0.214-0.012-0.314c0-0.089,0.011-0.182,0.032-0.282 c0.022-0.098,0.057-0.197,0.107-0.292c0.049-0.096,0.111-0.187,0.186-0.273C183.141,339.64,183.233,339.565,183.34,339.504z  M185.088,338.634c0.019-0.046,0.038-0.084,0.058-0.115c0.021-0.031,0.051-0.059,0.092-0.082l0.261-0.151 c0.031-0.018,0.058-0.021,0.078-0.013c0.02,0.01,0.032,0.031,0.034,0.065c0,0.007-0.001,0.017-0.003,0.03 c-0.002,0.013-0.006,0.026-0.011,0.041l-1.896,4.853c-0.018,0.046-0.037,0.083-0.058,0.114 c-0.021,0.031-0.051,0.058-0.091,0.082l-0.26,0.15c-0.032,0.018-0.058,0.023-0.079,0.013 c-0.02-0.01-0.031-0.031-0.033-0.065c-0.001-0.008,0-0.018,0.002-0.03c0.002-0.013,0.005-0.027,0.01-0.041L185.088,338.634z  M183.656,340.629c0.001-0.025,0-0.061-0.003-0.109c-0.003-0.048-0.007-0.098-0.01-0.15 c-0.004-0.051-0.007-0.103-0.01-0.151c-0.003-0.048-0.007-0.082-0.011-0.102c-0.012-0.07-0.034-0.124-0.069-0.157 c-0.036-0.033-0.095-0.026-0.179,0.023c-0.084,0.048-0.14,0.107-0.169,0.178c-0.028,0.071-0.042,0.146-0.043,0.222 c-0.002,0.025-0.002,0.061,0,0.11c0.003,0.048,0.005,0.099,0.009,0.151c0.003,0.052,0.008,0.102,0.012,0.148 c0.005,0.048,0.01,0.082,0.015,0.102c0.011,0.071,0.033,0.123,0.068,0.157c0.036,0.033,0.096,0.026,0.18-0.022 c0.084-0.048,0.139-0.108,0.168-0.178C183.64,340.78,183.654,340.706,183.656,340.629z M185.351,340.373 c0.106-0.061,0.201-0.094,0.282-0.099c0.081-0.005,0.15,0.011,0.208,0.045c0.058,0.033,0.104,0.084,0.137,0.151 c0.032,0.068,0.055,0.143,0.067,0.226c0.012,0.093,0.022,0.194,0.029,0.302c0.007,0.11,0.012,0.214,0.013,0.314 c-0.001,0.089-0.012,0.184-0.033,0.282c-0.022,0.1-0.057,0.197-0.107,0.293c-0.049,0.096-0.111,0.186-0.186,0.27 c-0.076,0.084-0.167,0.157-0.273,0.219c-0.108,0.062-0.201,0.096-0.282,0.102c-0.08,0.006-0.15-0.008-0.207-0.042 c-0.058-0.034-0.104-0.085-0.137-0.152c-0.033-0.068-0.055-0.142-0.066-0.224c-0.013-0.093-0.022-0.195-0.03-0.304 c-0.007-0.109-0.012-0.214-0.012-0.314c0-0.089,0.01-0.182,0.032-0.282c0.022-0.098,0.057-0.197,0.107-0.292 c0.049-0.096,0.111-0.186,0.186-0.273C185.153,340.508,185.243,340.435,185.351,340.373z M185.667,341.496 c0.001-0.023,0-0.059-0.003-0.107c-0.003-0.048-0.007-0.098-0.01-0.151c-0.004-0.051-0.007-0.102-0.01-0.151 c-0.003-0.048-0.007-0.082-0.011-0.102c-0.011-0.071-0.034-0.124-0.069-0.157c-0.036-0.033-0.095-0.026-0.179,0.022 c-0.084,0.048-0.14,0.107-0.169,0.178c-0.028,0.07-0.042,0.145-0.043,0.222c-0.002,0.025-0.002,0.061,0,0.11 c0.003,0.048,0.005,0.099,0.009,0.151c0.004,0.052,0.008,0.102,0.012,0.148c0.005,0.048,0.01,0.082,0.015,0.102 c0.011,0.071,0.033,0.123,0.069,0.157c0.036,0.033,0.096,0.026,0.18-0.022c0.084-0.048,0.139-0.108,0.168-0.178 C185.651,341.649,185.666,341.575,185.667,341.496z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3984_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3986_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f95fa"
    },
    d: "M181.467,329.047l0.053,0.778l0.246,3.606l0.055,0.812c1.203-0.611,2.348-0.771,3.349-0.529 l0.327-0.87l1.451-3.866l0.315-0.84C185.551,327.663,183.558,327.929,181.467,329.047z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3985_",
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M181.467,329.047l0.053,0.778l0.246,3.606l0.055,0.812c1.203-0.611,2.348-0.771,3.349-0.529 l0.327-0.87l1.451-3.866l0.315-0.84C185.551,327.663,183.558,327.929,181.467,329.047z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M191.482,333.783c-0.084-0.252-0.174-0.497-0.273-0.732c-0.808-1.914-2.089-3.24-3.66-3.868 l-1.45,3.862c1.07,0.454,1.94,1.37,2.511,2.665c0.102,0.231,0.193,0.474,0.275,0.729c0.219,0.685,0.371,1.447,0.429,2.295 c0.058,0.848,0.017,1.721-0.095,2.598c-0.042,0.327-0.095,0.653-0.159,0.98c-0.357,1.831-1.042,3.644-1.971,5.253 c-0.169,0.293-0.346,0.578-0.53,0.856c-0.991,1.494-2.196,2.75-3.525,3.603c-0.116,0.075-0.23,0.157-0.349,0.225 c-0.118,0.068-0.234,0.119-0.352,0.18c-1.34,0.688-2.619,0.866-3.731,0.587c-0.207-0.052-0.407-0.119-0.602-0.202 c-1.069-0.454-1.94-1.37-2.511-2.665c-0.102-0.231-0.193-0.474-0.275-0.729c-0.219-0.685-0.372-1.447-0.429-2.295 c-0.058-0.848-0.017-1.721,0.096-2.598c0.042-0.327,0.095-0.653,0.159-0.98c0.357-1.831,1.042-3.644,1.971-5.253 c0.169-0.293,0.346-0.578,0.53-0.856c0.991-1.494,2.196-2.75,3.525-3.603l-0.246-3.606 c-1.944,1.212-3.701,3.055-5.128,5.248c-0.182,0.28-0.357,0.567-0.528,0.858c-1.37,2.326-2.379,4.974-2.875,7.641 c-0.061,0.326-0.111,0.653-0.156,0.979c-0.176,1.278-0.233,2.552-0.149,3.786c0.084,1.235,0.304,2.348,0.635,3.334 c0.084,0.252,0.174,0.497,0.273,0.732c0.808,1.914,2.088,3.24,3.66,3.868c0.196,0.078,0.396,0.15,0.601,0.206 c1.607,0.441,3.472,0.193,5.428-0.847c0.117-0.062,0.233-0.123,0.351-0.191c0.118-0.068,0.233-0.141,0.35-0.214 c1.944-1.212,3.701-3.055,5.128-5.248c0.182-0.28,0.357-0.567,0.528-0.858c1.37-2.326,2.38-4.974,2.875-7.641 c0.061-0.326,0.111-0.653,0.156-0.979c0.176-1.278,0.234-2.552,0.149-3.786 C192.032,335.882,191.812,334.769,191.482,333.783z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M311.006,298.616L168.278,381.02c-0.352,0.204-0.663,0.002-0.694-0.45l-0.008-0.122 c-0.031-0.452,0.23-0.984,0.583-1.187l142.728-82.404c0.353-0.204,0.663-0.002,0.694,0.45l0.008,0.122 C311.619,297.88,311.358,298.412,311.006,298.616z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M311.317,303.18l-142.728,82.404c-0.353,0.203-0.663,0.002-0.694-0.45l-0.008-0.122 c-0.031-0.452,0.23-0.984,0.582-1.187l142.728-82.404c0.353-0.204,0.663-0.002,0.694,0.45l0.008,0.122 C311.93,302.444,311.67,302.976,311.317,303.18z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M312.923,181.633l-4.06-2.34l-159.31,91.95c-1.17,0.68-2.12,2.08-2.44,3.46 c-0.04,0.17-0.07,0.33-0.09,0.5c-0.02,0.15-0.03,0.31-0.03,0.46c0,0.07,0.01,0.15,0.01,0.23l0.41,5.98l4.07,2.35l162.06-93.56 L312.923,181.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M312.923,181.633l-159.3,91.96c-0.89,0.51-1.66,1.45-2.11,2.47l-4.06-2.35 c-0.15,0.32-0.26,0.66-0.34,0.99c0.32-1.38,1.27-2.78,2.44-3.46l159.31-91.95L312.923,181.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M151.073,278.233l0.41,5.99l-4.07-2.35l-0.41-5.98c0-0.08-0.01-0.16-0.01-0.23 c0-0.15,0.01-0.31,0.03-0.46c0.02-0.17,0.05-0.33,0.09-0.5c0.08-0.33,0.184-0.676,0.334-0.996l4.066,2.356 C151.193,276.783,151.023,277.543,151.073,278.233z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Magnifying_glass"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glass_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glass_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Magnifying_glass_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3656_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3662_",
    style: {
      fill: "#5f95fa"
    },
    d: "M283.778,102.799L283.778,102.799L283.778,102.799 c-0.47-0.482-0.621-1.273-0.343-2.261c0.556-1.975,2.62-3.986,4.608-4.492c0.994-0.253,1.782-0.082,2.251,0.4l0,0l0,0 l28.145,26.653l-0.003,0.003c0.733,0.661,0.991,1.803,0.583,3.251c-0.777,2.761-3.661,5.572-6.441,6.279 c-1.458,0.371-2.593,0.084-3.235-0.666l-0.008,0.008L283.778,102.799z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3660_",
    style: {
      fill: "#5f95fa"
    },
    d: "M288.044,96.045c1.989-0.506,3.15,0.685,2.594,2.661 c-0.556,1.975-2.619,3.986-4.608,4.492c-1.989,0.506-3.15-0.685-2.594-2.661C283.992,98.563,286.055,96.551,288.044,96.045z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3659_",
    d: "M288.044,96.045c1.989-0.506,3.15,0.685,2.594,2.661c-0.556,1.975-2.619,3.986-4.608,4.492 c-1.989,0.506-3.15-0.685-2.594-2.661C283.992,98.563,286.055,96.551,288.044,96.045z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3658_",
    style: {
      fill: "#37474F"
    },
    d: "M275.886,91c0.336-1.194,1.584-2.41,2.786-2.716 c0.601-0.153,1.077-0.049,1.361,0.242l0.001-0.001l8.973,9.175l-0.001,0.001c0.284,0.291,0.375,0.77,0.207,1.367 c-0.336,1.194-1.584,2.41-2.786,2.716c-0.601,0.153-1.077,0.049-1.361-0.242l-8.973-9.175l0,0 C275.809,92.076,275.718,91.597,275.886,91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M278.672,88.284c-0.155,0.04-0.312,0.096-0.467,0.164c-0.025,0.011-0.049,0.026-0.074,0.038 c-0.133,0.062-0.264,0.13-0.393,0.21c-0.01,0.006-0.019,0.014-0.029,0.02c-0.845,0.532-1.578,1.412-1.824,2.284 c-0.168,0.597-0.077,1.076,0.207,1.367l2.15,2.198c0.758-0.503,1.478-1.075,2.158-1.747l7.927,7.743 c0.414-0.452,0.74-0.972,0.887-1.494c0.168-0.597,0.077-1.076-0.207-1.367l0.001-0.001l-8.973-9.175l-0.001,0.001 C279.75,88.235,279.274,88.131,278.672,88.284z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3657_",
    style: {
      fill: "#5f95fa"
    },
    d: "M289.739,100.493l28.413,27.775c0.377-0.623,0.687-1.266,0.868-1.915 c0.407-1.447,0.153-2.59-0.586-3.251l0.005-0.005l-28.14-26.65c0.473,0.485,0.616,1.273,0.34,2.261 C290.463,99.314,290.148,99.923,289.739,100.493z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3644_",
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M289.739,100.493l28.413,27.775 c0.377-0.623,0.687-1.266,0.868-1.915c0.407-1.447,0.153-2.59-0.586-3.251l0.005-0.005l-28.14-26.65 c0.473,0.485,0.616,1.273,0.34,2.261C290.463,99.314,290.148,99.923,289.739,100.493z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1409_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3653_",
    style: {
      fill: "#5f95fa"
    },
    d: "M249.262,107.258c4.545,2.623,10.822,2.245,17.757-1.759 c13.869-8.007,25.112-27.48,25.112-43.495c0-8.007-2.811-13.634-7.355-16.257l0,0l-5.099-2.955 c-4.544-2.623-10.822-2.244-17.757,1.759c-13.869,8.007-25.112,27.481-25.112,43.495c0,8.007,2.811,13.633,7.355,16.257 L249.262,107.258L249.262,107.258z M288.696,62.004c0,7.152-2.448,15.332-6.895,23.033c-4.446,7.701-10.306,13.912-16.5,17.488 c-5.6,3.234-10.687,3.858-14.322,1.759c-3.635-2.099-5.637-6.816-5.638-13.283c0-7.152,2.448-15.332,6.895-23.033 c4.446-7.701,10.306-13.911,16.5-17.488c5.6-3.233,10.686-3.858,14.322-1.759C286.694,50.82,288.696,55.537,288.696,62.004z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3663_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M249.262,107.258c4.545,2.623,10.822,2.245,17.757-1.759 c13.869-8.007,25.112-27.48,25.112-43.495c0-8.007-2.811-13.634-7.355-16.257l0,0l-5.099-2.955 c-4.544-2.623-10.822-2.244-17.757,1.759c-13.869,8.007-25.112,27.481-25.112,43.495c0,8.007,2.811,13.633,7.355,16.257 L249.262,107.258L249.262,107.258z M288.696,62.004c0,7.152-2.448,15.332-6.895,23.033c-4.446,7.701-10.306,13.912-16.5,17.488 c-5.6,3.234-10.687,3.858-14.322,1.759c-3.635-2.099-5.637-6.816-5.638-13.283c0-7.152,2.448-15.332,6.895-23.033 c4.446-7.701,10.306-13.911,16.5-17.488c5.6-3.233,10.686-3.858,14.322-1.759C286.694,50.82,288.696,55.537,288.696,62.004z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3647_",
    style: {
      fill: "#5f95fa"
    },
    d: "M267.02,47.504c-13.869,8.007-25.112,27.48-25.112,43.495 c0,16.015,11.243,22.506,25.112,14.499c13.869-8.007,25.112-27.481,25.112-43.495C292.132,45.988,280.888,39.497,267.02,47.504z  M283.059,48.719c3.636,2.099,5.638,6.816,5.638,13.283c0,7.152-2.448,15.332-6.895,23.033 c-4.446,7.701-10.306,13.912-16.5,17.487c-5.6,3.234-10.687,3.858-14.322,1.759c-3.635-2.099-5.637-6.816-5.638-13.283 c0-7.152,2.449-15.332,6.895-23.033c4.446-7.701,10.306-13.912,16.5-17.488C274.337,47.245,279.424,46.62,283.059,48.719z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3728_",
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M267.02,47.504c-13.869,8.007-25.112,27.48-25.112,43.495 c0,16.015,11.243,22.506,25.112,14.499c13.869-8.007,25.112-27.481,25.112-43.495C292.132,45.988,280.888,39.497,267.02,47.504z  M283.059,48.719c3.636,2.099,5.638,6.816,5.638,13.283c0,7.152-2.448,15.332-6.895,23.033 c-4.446,7.701-10.306,13.912-16.5,17.487c-5.6,3.234-10.687,3.858-14.322,1.759c-3.635-2.099-5.637-6.816-5.638-13.283 c0-7.152,2.449-15.332,6.895-23.033c4.446-7.701,10.306-13.912,16.5-17.488C274.337,47.245,279.424,46.62,283.059,48.719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#5f95fa"
    },
    d: "M241.908,90.998c0-10.512,4.842-22.508,12.092-31.779 c-0.021,0.021-0.043,0.048-0.059,0.07l-5.084-2.945c-7.223,9.255-12.049,21.218-12.049,31.703c0,8.008,2.811,13.635,7.357,16.257 l5.095,2.956v-0.005c0.091,0.054,0.183,0.102,0.274,0.15C244.832,104.853,241.908,99.161,241.908,90.998z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3643_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3645_",
    style: {
      fill: "#5f95fa"
    },
    d: "M283.061,48.717c-1.428-0.824-3.069-1.224-4.882-1.216 c1.408,2.438,2.149,5.73,2.143,9.668c0.005,7.149-2.444,15.333-6.891,23.036c-4.444,7.698-10.307,13.91-16.501,17.48 c-3.408,1.974-6.629,2.978-9.448,2.984c0.903,1.568,2.07,2.789,3.497,3.613c3.635,2.099,8.722,1.475,14.327-1.762 c6.188-3.574,12.051-9.786,16.495-17.484c4.448-7.703,6.896-15.887,6.897-23.033C288.699,55.534,286.696,50.816,283.061,48.717z "
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3642_",
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M284.907,59.814c0,7.152-2.448,15.332-6.895,23.033 c-4.446,7.701-10.306,13.912-16.5,17.488c-4.621,2.668-8.889,3.555-12.284,2.605c-2.519-2.465-3.885-6.606-3.886-11.941 c0-7.152,2.449-15.332,6.895-23.033c4.446-7.701,10.306-13.912,16.5-17.488c4.621-2.668,8.889-3.555,12.284-2.606 C283.541,50.338,284.907,54.478,284.907,59.814z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M285.608,46.272c0.102,0.07,0.199,0.14,0.296,0.215c-0.011-0.005-0.016-0.011-0.021-0.011 c-0.161-0.118-0.317-0.231-0.484-0.339c-0.064-0.048-0.129-0.091-0.193-0.134c0.086,0.054,0.167,0.107,0.247,0.161 C285.505,46.197,285.554,46.235,285.608,46.272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M286,46.557c0.075,0.054,0.145,0.108,0.215,0.172c-0.097-0.081-0.199-0.156-0.301-0.231 c-0.005-0.005-0.011-0.005-0.011-0.011C285.935,46.509,285.967,46.53,286,46.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M287.306,47.696v0.005c-0.145-0.145-0.29-0.285-0.441-0.425c0.097,0.086,0.188,0.172,0.274,0.258 C287.193,47.589,287.252,47.643,287.306,47.696z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Documents"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f95fa"
    },
    d: "M431.724,282.638c-0.276,0-0.5,0.224-0.5,0.5v38.935l-32.247,18.618 c-0.239,0.138-0.321,0.443-0.183,0.683c0.092,0.16,0.261,0.25,0.433,0.25c0.085,0,0.171-0.021,0.25-0.067l32.497-18.762 c0.154-0.089,0.25-0.254,0.25-0.433v-39.224C432.224,282.862,432,282.638,431.724,282.638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M431.724,282.638c-0.276,0-0.5,0.224-0.5,0.5v38.935l-32.247,18.618 c-0.239,0.138-0.321,0.443-0.183,0.683c0.092,0.16,0.261,0.25,0.433,0.25c0.085,0,0.171-0.021,0.25-0.067l32.497-18.762 c0.154-0.089,0.25-0.254,0.25-0.433v-39.224C432.224,282.862,432,282.638,431.724,282.638z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f95fa"
    },
    d: "M429.692,284.31c0-1.295,0.909-2.87,2.031-3.518c1.122-0.648,2.031-0.123,2.031,1.173 c0,1.295-0.909,2.87-2.031,3.518C430.602,286.131,429.692,285.606,429.692,284.31z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Document_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sheet_7_"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "338.337,91.477 336.272,90.286 428.983,36.76 431.048,37.951  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFA"
    },
    points: "431.048,37.95 431.048,180.342 338.298,233.888 338.337,91.477  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M430.554,38.806v141.251l-91.762,52.976l0.039-141.27L430.554,38.806 M431.048,37.95 l-92.711,53.527l-0.04,142.411l92.75-53.547V37.95L431.048,37.95z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "338.337,91.477 338.298,233.888 336.292,232.73 336.272,90.286 338.298,91.452  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Chart_5_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3980_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4016_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M357.013,130.105c0.045-0.027,0.085-0.03,0.119-0.003c0.033,0.024,0.049,0.068,0.049,0.128 v0.549c0,0.057-0.009,0.118-0.025,0.186c-0.017,0.069-0.042,0.158-0.074,0.272l-1.449,5.291 c-0.016,0.058-0.039,0.116-0.065,0.174c-0.027,0.058-0.066,0.1-0.116,0.13l-0.517,0.298 c-0.046,0.027-0.087,0.028-0.119,0.003c-0.033-0.027-0.051-0.068-0.051-0.13c0-0.022,0.008-0.058,0.019-0.11l1.453-5.303 l-1.96,1.132c-0.045,0.027-0.085,0.028-0.119,0.003c-0.033-0.025-0.049-0.069-0.049-0.131v-0.59 c0-0.06,0.016-0.124,0.049-0.188c0.034-0.064,0.074-0.107,0.119-0.134L357.013,130.105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M361.065,129.938c0.004,0.103,0.006,0.217,0.006,0.346c0,0.127,0,0.258,0,0.39 c0,0.134,0,0.264,0,0.392c0,0.128-0.002,0.246-0.006,0.353c-0.013,0.33-0.049,0.649-0.11,0.959 c-0.06,0.31-0.155,0.604-0.288,0.882c-0.129,0.279-0.301,0.536-0.512,0.77c-0.21,0.237-0.466,0.441-0.77,0.617 c-0.308,0.177-0.568,0.27-0.774,0.275c-0.207,0.006-0.378-0.053-0.509-0.179c-0.131-0.128-0.228-0.313-0.286-0.551 c-0.061-0.241-0.097-0.518-0.11-0.832c-0.009-0.207-0.013-0.444-0.013-0.714c0-0.268,0.004-0.512,0.013-0.727 c0.013-0.329,0.049-0.652,0.11-0.968c0.058-0.313,0.155-0.612,0.286-0.893c0.131-0.28,0.302-0.542,0.509-0.78 c0.207-0.238,0.466-0.447,0.774-0.625c0.304-0.176,0.56-0.268,0.77-0.276c0.212-0.007,0.383,0.052,0.512,0.18 c0.133,0.125,0.228,0.31,0.288,0.55C361.016,129.345,361.052,129.622,361.065,129.938z M358.548,132.83 c0.021,0.387,0.092,0.655,0.216,0.804c0.122,0.149,0.329,0.139,0.621-0.03c0.29-0.168,0.499-0.396,0.621-0.688 c0.122-0.289,0.195-0.64,0.216-1.051c0.009-0.218,0.012-0.453,0.012-0.709c0-0.253-0.003-0.485-0.012-0.691 c-0.021-0.387-0.094-0.655-0.216-0.804c-0.122-0.149-0.331-0.139-0.621,0.03c-0.292,0.168-0.499,0.398-0.621,0.688 c-0.124,0.292-0.195,0.64-0.216,1.053c-0.009,0.216-0.012,0.451-0.012,0.706C358.536,132.393,358.539,132.624,358.548,132.83 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M362.614,126.828c0.153-0.089,0.286-0.136,0.401-0.14c0.112-0.003,0.205,0.021,0.283,0.073 c0.078,0.054,0.136,0.13,0.174,0.234c0.04,0.101,0.064,0.214,0.073,0.337c0.009,0.139,0.012,0.292,0.012,0.456 c0,0.164-0.003,0.319-0.012,0.468c-0.009,0.134-0.033,0.272-0.073,0.42c-0.039,0.149-0.097,0.293-0.174,0.435 c-0.077,0.142-0.171,0.274-0.283,0.398c-0.115,0.124-0.247,0.228-0.401,0.317c-0.155,0.089-0.288,0.137-0.399,0.145 c-0.113,0.005-0.209-0.016-0.285-0.07c-0.077-0.052-0.135-0.131-0.176-0.233c-0.04-0.101-0.062-0.214-0.071-0.337 c-0.007-0.14-0.012-0.292-0.012-0.456c0-0.164,0.004-0.32,0.012-0.469c0.009-0.133,0.031-0.273,0.071-0.42 c0.04-0.147,0.099-0.292,0.176-0.435c0.076-0.142,0.171-0.275,0.285-0.401C362.326,127.025,362.459,126.918,362.614,126.828z  M365.117,125.583c0.03-0.068,0.06-0.125,0.091-0.17c0.031-0.046,0.076-0.085,0.135-0.119l0.374-0.216 c0.046-0.027,0.082-0.033,0.109-0.019c0.028,0.017,0.04,0.049,0.04,0.098c0,0.012-0.002,0.027-0.006,0.045 c-0.004,0.019-0.01,0.042-0.018,0.063l-3.086,7.193c-0.03,0.066-0.06,0.122-0.089,0.167 c-0.031,0.047-0.076,0.086-0.134,0.119l-0.375,0.217c-0.046,0.027-0.082,0.033-0.109,0.016 c-0.027-0.013-0.042-0.046-0.042-0.097c0-0.01,0.003-0.027,0.006-0.045c0.005-0.019,0.01-0.039,0.019-0.059L365.117,125.583z  M362.944,128.518c0.005-0.036,0.006-0.091,0.006-0.162c0-0.071,0-0.146,0-0.223c0-0.077,0-0.155,0-0.226 c0-0.072-0.001-0.124-0.006-0.153c-0.008-0.107-0.036-0.186-0.082-0.237c-0.045-0.052-0.128-0.042-0.249,0.027 c-0.121,0.07-0.204,0.157-0.25,0.262c-0.045,0.104-0.072,0.213-0.08,0.331c-0.004,0.034-0.009,0.089-0.01,0.162 c-0.001,0.073-0.003,0.15-0.003,0.228c0,0.077,0.001,0.15,0.003,0.222c0.001,0.07,0.006,0.122,0.01,0.153 c0.009,0.106,0.036,0.185,0.08,0.235c0.046,0.051,0.13,0.042,0.25-0.028c0.121-0.07,0.204-0.156,0.249-0.261 C362.909,128.743,362.937,128.635,362.944,128.518z M365.317,128.189c0.155-0.089,0.287-0.137,0.401-0.14 c0.112-0.003,0.207,0.021,0.283,0.074c0.078,0.052,0.136,0.131,0.176,0.231c0.04,0.103,0.064,0.216,0.073,0.338 c0.007,0.14,0.01,0.292,0.01,0.456c0,0.164-0.003,0.319-0.01,0.468c-0.009,0.134-0.033,0.274-0.073,0.422 c-0.04,0.148-0.098,0.292-0.176,0.433c-0.076,0.143-0.171,0.274-0.283,0.398c-0.113,0.124-0.246,0.229-0.401,0.319 c-0.153,0.088-0.287,0.136-0.399,0.143c-0.113,0.007-0.207-0.016-0.284-0.07c-0.078-0.052-0.136-0.128-0.174-0.231 c-0.038-0.103-0.064-0.216-0.071-0.338c-0.009-0.14-0.013-0.292-0.013-0.456c0-0.164,0.004-0.319,0.013-0.468 c0.008-0.134,0.033-0.274,0.071-0.421c0.039-0.147,0.097-0.292,0.174-0.433c0.077-0.141,0.171-0.277,0.284-0.402 C365.029,128.386,365.164,128.279,365.317,128.189z M365.649,129.878c0.003-0.034,0.006-0.088,0.006-0.161 c0-0.072,0-0.147,0-0.225c0-0.077,0-0.152,0-0.225c0-0.071-0.003-0.124-0.006-0.155c-0.009-0.104-0.036-0.185-0.082-0.235 c-0.046-0.051-0.128-0.042-0.25,0.028c-0.119,0.07-0.204,0.156-0.249,0.261c-0.046,0.104-0.073,0.214-0.081,0.329 c-0.006,0.036-0.009,0.091-0.01,0.164c-0.001,0.073-0.003,0.149-0.003,0.227s0.001,0.153,0.003,0.223 c0.001,0.071,0.004,0.122,0.01,0.152c0.007,0.107,0.034,0.186,0.081,0.237c0.045,0.052,0.129,0.042,0.249-0.027 c0.122-0.07,0.204-0.156,0.25-0.262C365.613,130.105,365.64,129.996,365.649,129.878z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4009_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M352.336,120.658c-2.263,3.503-3.99,7.616-4.873,11.751c-0.424,1.985-0.656,3.975-0.656,5.904 c0,1.929,0.232,3.651,0.656,5.147l3.333-3.368c-0.313-1.105-0.487-2.375-0.487-3.8c0-1.426,0.174-2.896,0.487-4.363 c0.653-3.055,1.931-6.089,3.603-8.677c1.635-2.531,3.641-4.636,5.818-5.893v-4.668 C357.271,114.392,354.549,117.233,352.336,120.658z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4010_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f95fa"
    },
    d: "M372.971,117.682c-0.883-3.116-2.61-5.234-4.873-6.124c-2.212-0.87-4.935-0.568-7.881,1.133 v4.668c2.177-1.257,4.183-1.468,5.819-0.825c1.672,0.657,2.95,2.214,3.603,4.516c0.313,1.105,0.487,2.375,0.487,3.8 c0,1.425-0.174,2.896-0.487,4.363c-0.652,3.055-1.931,6.088-3.603,8.676c-1.635,2.531-3.642,4.636-5.819,5.893 c-2.177,1.257-4.184,1.468-5.818,0.826c-1.672-0.658-2.951-2.214-3.603-4.516l-3.332,3.368 c0.883,3.116,2.61,5.234,4.873,6.124c2.213,0.87,4.935,0.568,7.881-1.133c2.946-1.701,5.668-4.542,7.881-7.967 c2.263-3.503,3.991-7.616,4.873-11.751c0.424-1.985,0.656-3.975,0.656-5.904 C373.627,120.899,373.395,119.177,372.971,117.682z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Chart_1_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M356.855,178.764c-0.152,0.243-0.329,0.464-0.536,0.667c-0.207,0.202-0.429,0.374-0.672,0.514 c-0.291,0.167-0.545,0.268-0.758,0.301c-0.214,0.031-0.395,0.016-0.538-0.045c-0.144-0.061-0.252-0.163-0.327-0.303 c-0.075-0.14-0.118-0.294-0.131-0.465c-0.004-0.065,0.012-0.128,0.046-0.189c0.036-0.063,0.076-0.107,0.122-0.134l0.493-0.284 c0.042-0.024,0.076-0.025,0.104-0.006c0.027,0.021,0.055,0.057,0.083,0.107c0.026,0.05,0.06,0.094,0.1,0.128 c0.042,0.036,0.097,0.055,0.165,0.064c0.068,0.006,0.155-0.005,0.259-0.039c0.104-0.031,0.231-0.091,0.381-0.177 c0.253-0.148,0.459-0.334,0.615-0.56c0.156-0.225,0.235-0.465,0.235-0.713c0-0.25-0.079-0.383-0.235-0.402 c-0.156-0.018-0.362,0.046-0.615,0.194l-0.517,0.298c-0.048,0.027-0.088,0.028-0.119,0.002c-0.034-0.026-0.05-0.067-0.05-0.128 v-0.591c0-0.061,0.015-0.126,0.046-0.198c0.031-0.07,0.063-0.134,0.091-0.189l0.874-1.729l-1.723,0.995 c-0.046,0.027-0.085,0.028-0.119,0.003c-0.033-0.025-0.049-0.07-0.049-0.131v-0.591c0-0.06,0.016-0.122,0.049-0.186 c0.034-0.064,0.073-0.107,0.119-0.134l2.736-1.58c0.045-0.025,0.085-0.028,0.119-0.003c0.031,0.027,0.047,0.07,0.047,0.13 v0.591c0,0.061-0.015,0.128-0.046,0.198c-0.031,0.07-0.061,0.134-0.089,0.189l-0.913,1.809 c0.188-0.074,0.357-0.111,0.509-0.112c0.152,0.003,0.281,0.042,0.39,0.121c0.109,0.079,0.192,0.199,0.25,0.359 c0.058,0.163,0.088,0.361,0.088,0.6c0,0.288-0.045,0.57-0.129,0.844C357.126,178.262,357.007,178.52,356.855,178.764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M358.882,177.907c-0.208,0.006-0.378-0.054-0.509-0.18c-0.131-0.126-0.228-0.311-0.288-0.551 c-0.059-0.24-0.097-0.517-0.109-0.831c-0.009-0.207-0.014-0.444-0.014-0.713c0-0.268,0.005-0.512,0.014-0.727 c0.012-0.329,0.049-0.652,0.109-0.968c0.06-0.315,0.156-0.612,0.288-0.894c0.131-0.281,0.301-0.542,0.509-0.78 c0.207-0.24,0.465-0.448,0.773-0.626c0.21-0.121,0.389-0.188,0.554-0.229v1.21c-0.126-0.091-0.302-0.087-0.554,0.058 c-0.29,0.168-0.497,0.398-0.62,0.687c-0.124,0.292-0.195,0.642-0.216,1.054c-0.009,0.214-0.012,0.451-0.012,0.706 c0,0.256,0.003,0.485,0.012,0.693c0.021,0.387,0.092,0.655,0.216,0.803c0.122,0.15,0.329,0.14,0.62-0.028 c0.245-0.141,0.428-0.329,0.554-0.557v1.187c-0.165,0.149-0.344,0.29-0.554,0.411 C359.347,177.808,359.089,177.901,358.882,177.907z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M360.278,175.902c0.122-0.29,0.195-0.642,0.215-1.053c0.01-0.216,0.013-0.451,0.013-0.707 c0-0.255-0.003-0.485-0.013-0.691c-0.019-0.389-0.092-0.655-0.215-0.804c-0.017-0.021-0.048-0.014-0.068-0.029v-1.21 c0.074-0.019,0.152-0.044,0.218-0.046c0.21-0.007,0.383,0.052,0.512,0.179c0.131,0.127,0.228,0.31,0.288,0.551 c0.061,0.238,0.097,0.517,0.11,0.831c0.003,0.104,0.006,0.219,0.006,0.347c0,0.127,0,0.258,0,0.39c0,0.134,0,0.264,0,0.392 c0,0.128-0.003,0.246-0.006,0.353c-0.013,0.329-0.049,0.648-0.11,0.959c-0.06,0.309-0.156,0.603-0.288,0.882 c-0.13,0.278-0.302,0.535-0.512,0.77c-0.065,0.073-0.143,0.138-0.218,0.206v-1.187 C360.233,175.99,360.258,175.948,360.278,175.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M363.569,169.747c-0.078-0.052-0.171-0.078-0.285-0.073c-0.113,0.004-0.246,0.051-0.399,0.14 c-0.155,0.09-0.287,0.195-0.401,0.322c-0.112,0.125-0.207,0.259-0.283,0.4c-0.078,0.143-0.135,0.286-0.176,0.435 c-0.04,0.148-0.063,0.288-0.072,0.42c-0.009,0.149-0.012,0.305-0.012,0.469c0,0.164,0.003,0.316,0.012,0.456 c0.009,0.122,0.031,0.234,0.072,0.337c0.04,0.101,0.098,0.18,0.176,0.232c0.076,0.052,0.171,0.074,0.283,0.07 c0.113-0.008,0.246-0.055,0.401-0.144c0.153-0.089,0.286-0.194,0.399-0.317c0.113-0.125,0.207-0.256,0.285-0.398 c0.077-0.141,0.136-0.288,0.174-0.435c0.04-0.147,0.064-0.287,0.072-0.42c0.009-0.149,0.013-0.305,0.013-0.469 c0-0.164-0.004-0.316-0.013-0.456c-0.008-0.122-0.031-0.234-0.072-0.336C363.705,169.876,363.646,169.801,363.569,169.747z  M363.222,171.342c0,0.072-0.001,0.126-0.006,0.162c-0.009,0.116-0.036,0.225-0.082,0.329c-0.045,0.104-0.13,0.191-0.249,0.261 c-0.121,0.07-0.204,0.079-0.25,0.028c-0.045-0.052-0.073-0.129-0.082-0.237c-0.003-0.03-0.008-0.082-0.009-0.152 c-0.001-0.071-0.003-0.146-0.003-0.223c0-0.077,0.002-0.154,0.003-0.227c0.001-0.073,0.006-0.128,0.009-0.164 c0.009-0.116,0.037-0.226,0.082-0.329c0.046-0.106,0.129-0.192,0.25-0.262c0.119-0.07,0.204-0.079,0.249-0.027 c0.046,0.051,0.073,0.13,0.082,0.237c0.004,0.03,0.006,0.082,0.006,0.154c0,0.071,0,0.148,0,0.225 C363.222,171.195,363.222,171.269,363.222,171.342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M364.659,172.752c-0.009,0.15-0.013,0.305-0.013,0.469c0,0.164,0.005,0.316,0.013,0.454 c0.008,0.123,0.031,0.237,0.07,0.339c0.04,0.101,0.098,0.179,0.176,0.231c0.077,0.054,0.171,0.076,0.284,0.07 c0.112-0.008,0.246-0.055,0.399-0.143c0.155-0.089,0.288-0.196,0.4-0.318c0.112-0.124,0.207-0.256,0.283-0.398 c0.077-0.142,0.136-0.286,0.176-0.434c0.04-0.149,0.063-0.289,0.072-0.421c0.009-0.149,0.012-0.305,0.012-0.469 c0-0.164-0.003-0.314-0.012-0.454c-0.009-0.124-0.031-0.237-0.072-0.338c-0.04-0.101-0.098-0.179-0.176-0.231 c-0.076-0.054-0.171-0.079-0.283-0.074c-0.113,0.003-0.246,0.05-0.4,0.14c-0.153,0.088-0.287,0.195-0.399,0.322 c-0.113,0.125-0.207,0.26-0.284,0.402c-0.078,0.142-0.136,0.286-0.176,0.434C364.69,172.48,364.667,172.62,364.659,172.752z  M365.246,172.871c0-0.077,0.002-0.153,0.002-0.226c0.003-0.073,0.006-0.128,0.01-0.164c0.009-0.115,0.036-0.227,0.082-0.331 c0.045-0.103,0.129-0.191,0.249-0.26c0.122-0.07,0.204-0.079,0.25-0.028c0.045,0.051,0.073,0.131,0.082,0.235 c0.003,0.031,0.006,0.084,0.006,0.155c0,0.073,0,0.147,0,0.225c0,0.077,0,0.153,0,0.225c0,0.073-0.003,0.127-0.006,0.161 c-0.009,0.118-0.037,0.226-0.082,0.331c-0.046,0.106-0.128,0.192-0.25,0.262c-0.119,0.069-0.204,0.079-0.249,0.025 c-0.046-0.051-0.073-0.128-0.082-0.235c-0.004-0.03-0.007-0.081-0.01-0.152C365.247,173.023,365.246,172.949,365.246,172.871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M362.303,175.761l3.086-7.193c0.03-0.067,0.06-0.124,0.091-0.17 c0.031-0.044,0.076-0.083,0.134-0.118l0.375-0.216c0.046-0.027,0.082-0.033,0.109-0.02c0.027,0.016,0.04,0.049,0.04,0.098 c0,0.012-0.001,0.025-0.006,0.044c-0.005,0.02-0.01,0.04-0.018,0.061l-3.086,7.193c-0.03,0.067-0.06,0.122-0.091,0.168 c-0.03,0.046-0.076,0.087-0.134,0.119l-0.375,0.217c-0.045,0.025-0.081,0.031-0.107,0.017 c-0.029-0.015-0.042-0.046-0.042-0.097c0-0.01,0.003-0.027,0.006-0.046C362.29,175.802,362.296,175.781,362.303,175.761z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5f95fa"
    },
    points: "360.217,160.501 360.209,160.506 360.209,155.838 360.217,155.833  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f95fa"
    },
    d: "M370.126,167.992c0-1.426-0.174-2.695-0.487-3.801c-0.653-2.302-1.931-3.859-3.603-4.516 c-1.635-0.643-3.642-0.432-5.819,0.825v-4.668c2.946-1.701,5.668-2.003,7.881-1.133c2.263,0.89,3.991,3.008,4.873,6.124 c0.424,1.496,0.656,3.218,0.656,5.147c0,1.929-0.232,3.919-0.656,5.904l-3.333,0.48 C369.952,170.888,370.126,169.417,370.126,167.992z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5f95fa"
    },
    points: "360.217,186.924 360.217,191.592 360.209,191.597 360.209,186.929  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M352.336,163.8c-2.263,3.503-3.99,7.616-4.873,11.751c-0.424,1.985-0.656,3.975-0.656,5.904 c0,1.929,0.232,3.651,0.656,5.146c0.883,3.116,2.61,5.234,4.873,6.124c2.211,0.869,4.93,0.568,7.873-1.129v-4.668 c-2.174,1.253-4.178,1.463-5.81,0.821c-1.672-0.657-2.951-2.214-3.603-4.516c-0.313-1.105-0.487-2.375-0.487-3.8 c0-1.425,0.174-2.896,0.487-4.363c0.652-3.055,1.931-6.089,3.603-8.677c1.633-2.528,3.637-4.631,5.81-5.888v-4.668 C357.266,157.539,354.547,160.378,352.336,163.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M369.639,172.355c-0.652,3.055-1.931,6.088-3.603,8.676c-1.635,2.531-3.642,4.636-5.819,5.893 v4.668c2.946-1.701,5.668-4.542,7.881-7.967c2.263-3.503,3.991-7.616,4.873-11.751L369.639,172.355z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Check_List_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M386.25,106.673c-0.067,0-0.134-0.018-0.194-0.052c-0.12-0.069-0.194-0.197-0.194-0.335 v-7.264c0-0.138,0.074-0.266,0.194-0.335l6.291-3.631c0.12-0.069,0.267-0.069,0.387,0c0.12,0.069,0.194,0.197,0.194,0.335 l0.001,7.264c0,0.138-0.074,0.266-0.194,0.335l-6.292,3.632C386.383,106.655,386.316,106.673,386.25,106.673z  M386.637,99.245v6.37l5.517-3.185l-0.001-6.369L386.637,99.245z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Check_2_",
    style: {
      fill: "#5f95fa"
    },
    d: "M393.278,93.568c-0.389-0.163-0.837,0.02-0.999,0.407l-2.884,6.862 l-0.687-0.668c-0.3-0.293-0.784-0.286-1.079,0.016c-0.293,0.301-0.286,0.785,0.016,1.079l1.489,1.447 c0.143,0.139,0.332,0.216,0.532,0.216c0.05,0,0.101-0.005,0.152-0.015c0.248-0.051,0.454-0.22,0.551-0.452l3.317-7.892 C393.849,94.179,393.666,93.731,393.278,93.568z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M397.887,94.84l23.151-13.367c0.556-0.321,1.006-0.09,1.006,0.515 c0,0.605-0.45,1.355-1.006,1.676L397.887,97.03c-0.556,0.321-1.006,0.09-1.006-0.514 C396.881,95.911,397.332,95.16,397.887,94.84z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M386.249,117.568c-0.067,0-0.134-0.018-0.194-0.052c-0.12-0.069-0.194-0.197-0.194-0.335 v-7.264c0-0.138,0.074-0.266,0.194-0.335l6.292-3.632c0.12-0.069,0.267-0.069,0.387,0c0.12,0.069,0.194,0.197,0.194,0.335 v7.264c0,0.138-0.074,0.266-0.194,0.335l-6.292,3.631C386.383,117.551,386.316,117.568,386.249,117.568z M386.636,110.141 v6.369l5.517-3.184v-6.37L386.636,110.141z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Check_1_",
    style: {
      fill: "#5f95fa"
    },
    d: "M393.278,104.464c-0.389-0.163-0.837,0.02-0.999,0.407l-2.884,6.862 l-0.687-0.668c-0.3-0.292-0.784-0.286-1.079,0.016c-0.293,0.301-0.286,0.785,0.016,1.079l1.489,1.447 c0.143,0.139,0.332,0.216,0.532,0.216c0.05,0,0.101-0.005,0.152-0.015c0.248-0.051,0.454-0.22,0.551-0.452l3.317-7.892 C393.849,105.075,393.666,104.627,393.278,104.464z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M397.887,105.702l23.151-13.367c0.556-0.321,1.006-0.09,1.006,0.515s-0.45,1.355-1.006,1.676 l-23.151,13.366c-0.556,0.321-1.006,0.09-1.006-0.514C396.881,106.773,397.332,106.023,397.887,105.702z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M386.249,128.465c-0.067,0-0.134-0.018-0.194-0.052c-0.12-0.069-0.194-0.197-0.194-0.335 v-7.264c0-0.138,0.074-0.266,0.194-0.335l6.292-3.631c0.12-0.069,0.267-0.069,0.387,0c0.12,0.069,0.194,0.197,0.194,0.335 v7.264c0,0.138-0.074,0.266-0.194,0.335l-6.292,3.632C386.383,128.447,386.316,128.465,386.249,128.465z M386.636,121.037 v6.37l5.517-3.185v-6.369L386.636,121.037z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Check_3_",
    style: {
      fill: "#5f95fa"
    },
    d: "M393.278,115.36c-0.389-0.163-0.837,0.02-0.999,0.408l-2.884,6.862 l-0.687-0.668c-0.3-0.293-0.784-0.286-1.079,0.016c-0.293,0.301-0.286,0.785,0.016,1.079l1.489,1.447 c0.143,0.139,0.332,0.216,0.532,0.216c0.05,0,0.101-0.005,0.152-0.015c0.248-0.051,0.454-0.22,0.551-0.452l3.317-7.893 C393.849,115.971,393.666,115.523,393.278,115.36z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M397.887,116.564l23.151-13.367c0.556-0.321,1.006-0.09,1.006,0.515 c0,0.605-0.45,1.355-1.006,1.676l-23.151,13.366c-0.556,0.321-1.006,0.091-1.006-0.514 C396.881,117.635,397.332,116.885,397.887,116.564z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3979_",
    style: {
      fill: "#E0E0E0"
    },
    points: "389.32,174.389 385.58,176.549 385.58,134.73 389.32,132.571  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3978_",
    style: {
      fill: "#E0E0E0"
    },
    points: "395.921,170.578 392.181,172.738 392.181,130.919 395.921,128.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3977_",
    style: {
      fill: "#E0E0E0"
    },
    points: "402.522,166.767 398.782,168.926 398.782,127.108 402.522,124.949  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3976_",
    style: {
      fill: "#E0E0E0"
    },
    points: "409.123,162.956 405.383,165.115 405.383,123.297 409.123,121.138  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3974_",
    style: {
      fill: "#E0E0E0"
    },
    points: "415.724,159.145 411.984,161.304 411.984,119.486 415.724,117.326  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3973_",
    style: {
      fill: "#E0E0E0"
    },
    points: "422.325,155.334 418.585,157.493 418.585,115.675 422.325,113.516  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3972_",
    style: {
      fill: "#5f95fa"
    },
    points: "418.585,115.675 422.325,113.516 422.325,132.602 418.585,134.761  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3969_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3971_",
    style: {
      fill: "#5f95fa"
    },
    points: "385.58,143.861 389.32,141.701 389.32,165.05 385.58,167.209  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3970_",
    style: {
      opacity: 0.15
    },
    points: "385.58,167.209 389.32,165.05 389.32,174.389 385.58,176.549  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3966_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3968_",
    style: {
      fill: "#5f95fa"
    },
    points: "392.181,145.357 395.921,143.197 395.921,151.604 392.181,153.763  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3967_",
    style: {
      opacity: 0.15
    },
    points: "392.181,153.763 395.921,151.604 395.921,170.578 392.181,172.737  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3963_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3965_",
    style: {
      fill: "#5f95fa"
    },
    points: "398.782,130.609 402.522,128.449 402.522,135.785 398.782,137.944  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3964_",
    style: {
      opacity: 0.15
    },
    points: "398.782,137.944 402.522,135.785 402.522,166.767 398.782,168.926  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3960_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3962_",
    style: {
      fill: "#5f95fa"
    },
    points: "405.383,132.427 409.123,130.268 409.123,148.748 405.383,150.907  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3961_",
    style: {
      opacity: 0.15
    },
    points: "405.383,150.907 409.123,148.748 409.123,162.956 405.383,165.115  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3957_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3959_",
    style: {
      fill: "#5f95fa"
    },
    points: "411.984,136.124 415.724,133.964 415.724,141.779 411.984,143.938  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3958_",
    style: {
      opacity: 0.15
    },
    points: "411.984,143.938 415.724,141.779 415.724,159.145 411.984,161.304  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3955_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3956_",
    style: {
      opacity: 0.15
    },
    points: "418.585,134.761 422.325,132.602 422.325,155.334 418.585,157.493  "
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3943_",
    style: {
      fill: "#5f95fa"
    },
    points: "385.58,167.209 389.32,165.05 389.32,174.389 385.58,176.549  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3942_",
    style: {
      opacity: 0.2
    },
    points: "385.58,167.209 389.32,165.05 389.32,174.389 385.58,176.549  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3861_",
    style: {
      fill: "#5f95fa"
    },
    points: "392.181,153.763 395.921,151.604 395.921,170.578 392.181,172.737  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3857_",
    style: {
      opacity: 0.2
    },
    points: "392.181,153.763 395.921,151.604 395.921,170.578 392.181,172.737  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3784_",
    style: {
      fill: "#5f95fa"
    },
    points: "398.782,137.944 402.522,135.785 402.522,166.767 398.782,168.926  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3780_",
    style: {
      opacity: 0.2
    },
    points: "398.782,137.944 402.522,135.785 402.522,166.767 398.782,168.926  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3755_",
    style: {
      fill: "#5f95fa"
    },
    points: "405.383,150.907 409.123,148.748 409.123,162.956 405.383,165.115  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3754_",
    style: {
      opacity: 0.2
    },
    points: "405.383,150.907 409.123,148.748 409.123,162.956 405.383,165.115  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3753_",
    style: {
      fill: "#5f95fa"
    },
    points: "411.984,143.938 415.724,141.779 415.724,159.145 411.984,161.304  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3752_",
    style: {
      opacity: 0.2
    },
    points: "411.984,143.938 415.724,141.779 415.724,159.145 411.984,161.304  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3751_",
    style: {
      fill: "#5f95fa"
    },
    points: "418.585,134.761 422.325,132.602 422.325,155.334 418.585,157.493  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3749_",
    style: {
      opacity: 0.2
    },
    points: "418.585,134.761 422.325,132.602 422.325,155.334 418.585,157.493  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M345.089,102.07c-0.172,0-0.34-0.089-0.433-0.25c-0.139-0.239-0.057-0.545,0.183-0.683 l79.169-45.827c0.234-0.139,0.543-0.058,0.683,0.182c0.139,0.239,0.057,0.545-0.183,0.683l-79.169,45.827 C345.26,102.048,345.174,102.07,345.089,102.07z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M345.089,106.693c-0.172,0-0.34-0.089-0.433-0.249c-0.139-0.239-0.057-0.545,0.183-0.683 l79.169-45.827c0.234-0.138,0.543-0.059,0.683,0.182c0.139,0.239,0.057,0.545-0.183,0.683l-79.169,45.827 C345.26,106.672,345.174,106.693,345.089,106.693z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M345.089,111.316c-0.172,0-0.34-0.089-0.433-0.249c-0.139-0.239-0.057-0.545,0.183-0.683 l79.169-45.827c0.234-0.138,0.543-0.059,0.683,0.182c0.139,0.239,0.057,0.545-0.183,0.683l-79.169,45.827 C345.26,111.295,345.174,111.316,345.089,111.316z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M345.089,208.493c-0.172,0-0.34-0.089-0.433-0.25c-0.139-0.239-0.057-0.545,0.183-0.683 l79.169-45.827c0.234-0.138,0.543-0.059,0.683,0.182c0.139,0.239,0.057,0.545-0.183,0.683l-79.169,45.827 C345.26,208.471,345.174,208.493,345.089,208.493z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M345.089,213.116c-0.172,0-0.34-0.089-0.433-0.25c-0.139-0.239-0.057-0.545,0.183-0.683 l79.169-45.827c0.234-0.138,0.543-0.059,0.683,0.182c0.139,0.239,0.057,0.545-0.183,0.683l-79.169,45.827 C345.26,213.094,345.174,213.116,345.089,213.116z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M345.089,217.739c-0.172,0-0.34-0.089-0.433-0.249c-0.139-0.239-0.057-0.545,0.183-0.683 l79.169-45.827c0.234-0.138,0.543-0.059,0.683,0.182c0.139,0.239,0.057,0.545-0.183,0.683l-79.169,45.827 C345.26,217.718,345.174,217.739,345.089,217.739z"
  }))))), /*#__PURE__*/React.createElement("polygon", {
    id: "Shadow",
    style: {
      opacity: 0.1
    },
    points: "431.048,180.342 431.048,118.524 369.138,154.268 369.121,216.093  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Document"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sheet_6_"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "379.639,161.435 377.574,160.245 470.284,106.718 472.35,107.909  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFA"
    },
    points: "472.35,107.909 472.35,250.3 379.599,303.847 379.639,161.435  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M471.856,108.764v141.251l-91.762,52.976l0.039-141.27L471.856,108.764 M472.35,107.909 l-92.711,53.527l-0.04,142.411l92.75-53.547V107.909L472.35,107.909z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "379.639,161.435 379.599,303.847 377.594,302.689 377.574,160.245 379.599,161.411  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3661_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M392.781,259.549l-4.148,2.395c-0.262,0.151-0.474,0.556-0.474,0.905v0.094 c0,0.349,0.212,0.509,0.474,0.358l4.148-2.395c0.262-0.151,0.474-0.556,0.474-0.905v-0.094 C393.254,259.559,393.042,259.398,392.781,259.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M401.788,254.348l-4.148,2.395c-0.261,0.151-0.473,0.556-0.473,0.905v0.094 c0,0.349,0.212,0.509,0.473,0.358l4.148-2.395c0.262-0.151,0.474-0.556,0.474-0.905v-0.094 C402.262,254.358,402.049,254.197,401.788,254.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M410.795,249.147l-4.148,2.395c-0.262,0.151-0.473,0.556-0.473,0.905v0.094 c0,0.349,0.212,0.509,0.473,0.358l4.148-2.395c0.262-0.151,0.474-0.556,0.474-0.905v-0.094 C411.269,249.157,411.057,248.996,410.795,249.147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M419.802,243.946l-4.148,2.395c-0.262,0.151-0.474,0.556-0.474,0.905v0.094 c0,0.349,0.212,0.509,0.474,0.358l4.148-2.395c0.262-0.151,0.474-0.556,0.474-0.905v-0.094 C420.276,243.956,420.064,243.795,419.802,243.946z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M428.81,238.745l-4.148,2.395c-0.262,0.151-0.474,0.556-0.474,0.905v0.094 c0,0.349,0.212,0.509,0.474,0.358l4.148-2.395c0.262-0.151,0.474-0.556,0.474-0.905v-0.094 C429.283,238.755,429.071,238.594,428.81,238.745z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M437.817,233.544l-4.148,2.395c-0.262,0.151-0.474,0.556-0.474,0.905v0.094 c0,0.349,0.212,0.509,0.474,0.358l4.148-2.395c0.262-0.151,0.474-0.556,0.474-0.905v-0.094 C438.29,233.553,438.078,233.393,437.817,233.544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M446.824,228.343l-4.148,2.395c-0.262,0.151-0.474,0.556-0.474,0.905v0.094 c0,0.349,0.212,0.509,0.474,0.358l4.148-2.395c0.262-0.151,0.473-0.556,0.473-0.905v-0.094 C447.297,228.352,447.086,228.192,446.824,228.343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M455.831,223.142l-4.148,2.395c-0.262,0.151-0.474,0.556-0.474,0.905v0.094 c0,0.349,0.212,0.509,0.474,0.358l4.148-2.395c0.262-0.151,0.473-0.556,0.473-0.905V223.5 C456.305,223.152,456.093,222.991,455.831,223.142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M464.838,217.941l-4.148,2.395c-0.261,0.151-0.473,0.556-0.473,0.905v0.094 c0,0.349,0.212,0.509,0.473,0.358l4.148-2.395c0.261-0.151,0.473-0.556,0.473-0.905v-0.094 C465.312,217.951,465.1,217.79,464.838,217.941z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3954_",
    style: {
      fill: "#5f95fa"
    },
    points: "388.005,247.3 393.107,244.354 393.107,252.737 388.005,255.682  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3953_",
    style: {
      fill: "#5f95fa"
    },
    points: "397.009,233.454 402.111,230.508 402.111,247.538 397.009,250.484  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3731_",
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    points: "397.009,233.454 402.111,230.508 402.111,247.538  397.009,250.484  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3952_",
    style: {
      fill: "#5f95fa"
    },
    points: "406.013,217.477 411.115,214.531 411.115,242.34 406.013,245.285  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3732_",
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    points: "406.013,217.477 411.115,214.531 411.115,242.34  406.013,245.285  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3951_",
    style: {
      fill: "#5f95fa"
    },
    points: "415.017,227.335 420.119,224.389 420.119,237.141 415.017,240.087  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3734_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    points: "415.017,227.335 420.119,224.389 420.119,237.141  415.017,240.087  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3950_",
    style: {
      fill: "#5f95fa"
    },
    points: "424.022,219.302 429.123,216.356 429.123,231.943 424.022,234.888  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3745_",
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    points: "424.022,219.302 429.123,216.356 429.123,231.943  424.022,234.888  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3949_",
    style: {
      fill: "#5f95fa"
    },
    points: "433.026,209.287 438.128,206.341 438.128,226.744 433.026,229.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3948_",
    style: {
      fill: "#5f95fa"
    },
    points: "442.03,215.06 447.132,212.114 447.132,221.546 442.03,224.491  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3746_",
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    points: "442.03,215.06 447.132,212.114 447.132,221.546  442.03,224.491  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3947_",
    style: {
      fill: "#5f95fa"
    },
    points: "451.034,206.853 456.136,203.907 456.136,216.347 451.034,219.293  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3747_",
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    points: "451.034,206.853 456.136,203.907 456.136,216.347  451.034,219.293  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3944_",
    style: {
      fill: "#5f95fa"
    },
    points: "460.038,199.658 465.14,196.713 465.14,211.149 460.038,214.094  "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f95fa"
    },
    d: "M465.047,185.751c-5.64,11.939-13.09,15.423-17.757,14.777c-1.712-0.237-2.971-0.751-4.083-1.204 c-2.21-0.902-3.956-1.614-7.63,0.507c-2.356,1.36-4.311,3.87-6.202,6.298c-2.451,3.147-4.767,6.122-7.59,5.851 c-1.984-0.191-3.376-1.634-4.722-3.029c-2.078-2.155-4.228-4.383-8.498-1.917c-7.135,4.119-15.299,19.744-20.82,31.139 l0.521,0.53c5.427-11.202,13.436-26.552,20.299-30.514c3.95-2.281,5.896-0.263,7.955,1.873c1.398,1.448,2.842,2.946,4.964,3.15 c3.13,0.301,5.595-2.863,8.203-6.214c1.818-2.333,3.697-4.746,5.889-6.012c3.454-1.994,5.036-1.349,7.226-0.456 c1.131,0.462,2.413,0.985,4.17,1.228c4.887,0.675,12.691-2.979,18.604-15.497L465.047,185.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M465.047,185.751c-5.64,11.939-13.09,15.423-17.757,14.777 c-1.712-0.237-2.971-0.751-4.083-1.204c-2.21-0.902-3.956-1.614-7.63,0.507c-2.356,1.36-4.311,3.87-6.202,6.298 c-2.451,3.147-4.767,6.122-7.59,5.851c-1.984-0.191-3.376-1.634-4.722-3.029c-2.078-2.155-4.228-4.383-8.498-1.917 c-7.135,4.119-15.299,19.744-20.82,31.139l0.521,0.53c5.427-11.202,13.436-26.552,20.299-30.514 c3.95-2.281,5.896-0.263,7.955,1.873c1.398,1.448,2.842,2.946,4.964,3.15c3.13,0.301,5.595-2.863,8.203-6.214 c1.818-2.333,3.697-4.746,5.889-6.012c3.454-1.994,5.036-1.349,7.226-0.456c1.131,0.462,2.413,0.985,4.17,1.228 c4.887,0.675,12.691-2.979,18.604-15.497L465.047,185.751z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M386.143,274.351c-0.172,0-0.34-0.09-0.433-0.249c-0.139-0.239-0.057-0.545,0.182-0.684 l79.17-45.828c0.233-0.138,0.543-0.059,0.683,0.182c0.139,0.239,0.057,0.545-0.182,0.683l-79.169,45.828 C386.315,274.33,386.229,274.351,386.143,274.351z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M386.143,278.974c-0.172,0-0.34-0.09-0.433-0.249c-0.139-0.239-0.057-0.545,0.183-0.684 l79.169-45.827c0.233-0.138,0.543-0.059,0.683,0.182c0.139,0.239,0.057,0.545-0.183,0.683l-79.169,45.827 C386.315,278.953,386.229,278.974,386.143,278.974z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M386.143,283.597c-0.172,0-0.34-0.09-0.433-0.249c-0.139-0.239-0.057-0.545,0.183-0.684 l79.169-45.827c0.233-0.138,0.543-0.059,0.683,0.182c0.139,0.239,0.057,0.545-0.183,0.683l-79.169,45.827 C386.315,283.576,386.229,283.597,386.143,283.597z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M386.041,171.101c-0.172,0-0.341-0.089-0.433-0.25c-0.139-0.239-0.057-0.545,0.183-0.683 l40.62-23.451c0.238-0.137,0.545-0.057,0.683,0.183c0.139,0.239,0.057,0.545-0.183,0.683l-40.62,23.451 C386.211,171.08,386.126,171.101,386.041,171.101z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M386.039,175.792c-0.172,0-0.341-0.089-0.433-0.25c-0.139-0.239-0.057-0.545,0.183-0.683 l60.932-35.178c0.237-0.138,0.545-0.057,0.683,0.183c0.139,0.239,0.057,0.545-0.183,0.683l-60.932,35.178 C386.21,175.77,386.124,175.792,386.039,175.792z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M386.04,185.173c-0.172,0-0.341-0.089-0.433-0.25c-0.139-0.239-0.057-0.545,0.183-0.683 l36.559-21.107c0.238-0.139,0.545-0.058,0.683,0.183c0.139,0.239,0.057,0.545-0.183,0.683l-36.559,21.107 C386.211,185.151,386.125,185.173,386.04,185.173z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M386.04,189.863c-0.172,0-0.341-0.089-0.433-0.25c-0.139-0.239-0.057-0.545,0.183-0.683 l36.559-21.107c0.238-0.138,0.545-0.057,0.683,0.183c0.139,0.239,0.057,0.545-0.183,0.683l-36.559,21.107 C386.211,189.842,386.125,189.863,386.04,189.863z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M386.04,194.553c-0.172,0-0.341-0.089-0.433-0.25c-0.139-0.239-0.057-0.545,0.183-0.683 l36.559-21.106c0.238-0.139,0.545-0.058,0.683,0.183c0.139,0.239,0.057,0.545-0.183,0.683l-36.559,21.107 C386.211,194.532,386.125,194.553,386.04,194.553z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M386.04,199.244c-0.172,0-0.341-0.089-0.433-0.25c-0.139-0.239-0.057-0.545,0.183-0.683 l36.559-21.107c0.238-0.138,0.545-0.057,0.683,0.183c0.139,0.239,0.057,0.545-0.183,0.683l-36.559,21.107 C386.211,199.222,386.125,199.244,386.04,199.244z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M386.04,203.934c-0.172,0-0.341-0.089-0.433-0.25c-0.139-0.239-0.057-0.545,0.183-0.683 l36.559-21.106c0.238-0.138,0.545-0.058,0.683,0.183c0.139,0.239,0.057,0.545-0.183,0.683l-36.559,21.106 C386.211,203.912,386.125,203.934,386.04,203.934z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M386.04,208.624c-0.172,0-0.341-0.089-0.433-0.25c-0.139-0.239-0.057-0.545,0.183-0.683 l36.559-21.107c0.238-0.137,0.545-0.057,0.683,0.183c0.139,0.239,0.057,0.545-0.183,0.683l-36.559,21.107 C386.211,208.603,386.125,208.624,386.04,208.624z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M386.04,213.314c-0.172,0-0.341-0.089-0.433-0.25c-0.139-0.239-0.057-0.545,0.183-0.683 l36.559-21.107c0.238-0.138,0.545-0.058,0.683,0.183c0.139,0.239,0.057,0.545-0.183,0.683l-36.559,21.106 C386.211,213.292,386.125,213.314,386.04,213.314z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M428.404,160.728c-0.172,0-0.341-0.089-0.433-0.25c-0.139-0.239-0.057-0.545,0.183-0.683 l36.559-21.106c0.238-0.138,0.545-0.058,0.683,0.183c0.139,0.239,0.057,0.545-0.183,0.683l-36.559,21.107 C428.575,160.706,428.489,160.728,428.404,160.728z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M428.404,165.418c-0.172,0-0.341-0.089-0.433-0.25c-0.139-0.239-0.057-0.545,0.183-0.683 l36.559-21.107c0.238-0.137,0.545-0.057,0.683,0.183c0.139,0.239,0.057,0.545-0.183,0.683l-36.559,21.107 C428.575,165.396,428.489,165.418,428.404,165.418z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M428.404,170.108c-0.172,0-0.341-0.089-0.433-0.25c-0.139-0.239-0.057-0.545,0.183-0.683 l36.559-21.106c0.238-0.138,0.545-0.058,0.683,0.183c0.139,0.239,0.057,0.545-0.183,0.683l-36.559,21.106 C428.575,170.087,428.489,170.108,428.404,170.108z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M428.404,174.798c-0.172,0-0.341-0.089-0.433-0.25c-0.139-0.239-0.057-0.545,0.183-0.683 l36.559-21.107c0.238-0.137,0.545-0.057,0.683,0.183c0.139,0.239,0.057,0.545-0.183,0.683l-36.559,21.107 C428.575,174.777,428.489,174.798,428.404,174.798z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M428.404,179.488c-0.172,0-0.341-0.089-0.433-0.25c-0.139-0.239-0.057-0.545,0.183-0.683 l36.559-21.106c0.238-0.138,0.545-0.057,0.683,0.183c0.139,0.239,0.057,0.545-0.183,0.683l-36.559,21.106 C428.575,179.467,428.489,179.488,428.404,179.488z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M428.404,184.179c-0.172,0-0.341-0.089-0.433-0.25c-0.139-0.239-0.057-0.545,0.183-0.683 l36.559-21.107c0.238-0.137,0.545-0.057,0.683,0.183c0.139,0.239,0.057,0.545-0.183,0.683l-36.559,21.107 C428.575,184.157,428.489,184.179,428.404,184.179z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M428.404,188.869c-0.172,0-0.341-0.089-0.433-0.25c-0.139-0.239-0.057-0.545,0.183-0.683 l36.559-21.106c0.238-0.138,0.545-0.057,0.683,0.183c0.139,0.239,0.057,0.545-0.183,0.683l-36.559,21.107 C428.575,188.847,428.489,188.869,428.404,188.869z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoring);
export default __webpack_public_path__ + "static/media/monitoring.3e5e176c98d0be1ba4e4c7d47bb4dc63.svg";
export { ForwardRef as ReactComponent };